webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';

        this.market_app_name = "stanelworld";
        this.app_url = "https://lookbookgallery.com";
        this.app_name = "Stanel World";

        this.sp_url = "https://wspk.herokuapp.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';
        this.video_exts = ['mp4', 'mp3'];
        this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.upload_wait_period = 60000;
        this.max_media_upload = "7MB";
        this.baseURL = 'https://spattle.afiahub.com/api/';

        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "formatCurrency",
        value: function formatCurrency(currency) {
            currency = Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(currency);
            currency = currency.replace("₦", "");
            currency = currency.replace("NGN", "");
            return currency;
        }
    }, {
        key: "getStates",
        value: function getStates(context, id) {
            return context.$http.get(this.baseURL + 'states', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCities",
        value: function getCities(context, id) {
            return context.$http.get(this.baseURL + 'cities/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "regUser",
        value: function regUser(context, data) {
            return context.$http.post(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "loginUser",
        value: function loginUser(context, data) {
            return context.$http.post(this.baseURL + 'users/login', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "activateUserToken",
        value: function activateUserToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/activate/user/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "forgotPassword",
        value: function forgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "verifyResetPasswordToken",
        value: function verifyResetPasswordToken(context, id) {
            return context.$http.get(this.baseURL + 'settings/verify/reset/token/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetForgotPassword",
        value: function resetForgotPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetPassword",
        value: function resetPassword(context, data) {
            return context.$http.post(this.baseURL + 'settings/password/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "changeEmail",
        value: function changeEmail(context, data) {
            return context.$http.post(this.baseURL + 'settings/email/reset', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionGuard",
        value: function sessionGuard(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSyncSet",
        value: function sessionSyncSet(context, id) {
            return context.$http.get(this.baseURL + 'auth/sessions/sync/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sessionSync",
        value: function sessionSync(context, data) {
            return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkUserDetails",
        value: function checkUserDetails(context, data) {
            return context.$http.post(this.baseURL + 'users/checks', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProfileDetails",
        value: function editProfileDetails(context, data) {
            return context.$http.put(this.baseURL + 'users', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "makeAppSubscriptionOrder",
        value: function makeAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updateAppSubscriptionOrder",
        value: function updateAppSubscriptionOrder(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "can_edit",
        value: function can_edit(context, data) {
            return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinesses",
        value: function getBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinesses",
        value: function getAppBusinesses(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessByUserName",
        value: function getBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessByUserName",
        value: function getAppBusinessByUserName(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/usernames/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessProducts",
        value: function getBusinessProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getAppBusinessProducts",
        value: function getAppBusinessProducts(context, id, limit) {
            return context.$http.get(this.baseURL + 'products/app/businesses/' + id + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addNewBusiness",
        value: function addNewBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/new', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addExistingBusiness",
        value: function addExistingBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses/existing', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "validateBusinessUserName",
        value: function validateBusinessUserName(context, data) {
            return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarketUpgradeDetails",
        value: function getBusinessMarketUpgradeDetails(context, id) {
            return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/' + id, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "upgradeBusinessMarketSubscription",
        value: function upgradeBusinessMarketSubscription(context, data) {
            return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getCategories",
        value: function getCategories(context) {
            return context.$http.get(this.baseURL + 'categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMainCategories",
        value: function getMainCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/main/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessSubCategories",
        value: function getBusinessSubCategories(context, id) {
            return context.$http.get(this.baseURL + 'categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessCategories",
        value: function getBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addGallery",
        value: function addGallery(context, data) {
            return context.$http.post(this.baseURL + 'posts/gallery', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "getPointGalleryPosts",
        value: function getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
            return context.$http.get(this.baseURL + 'posts/gallery/points/' + id + '/' + offset + '/' + limit + '/' + posts_offset + '/' + posts_limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getGallerySearch",
        value: function getGallerySearch(context, id) {
            return context.$http.get(this.baseURL + 'posts/gallery/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editBusinessDetails",
        value: function editBusinessDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/details', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setShippingFeeStatus",
        value: function setShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addDeliveryOption",
        value: function addDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDeliveryOption",
        value: function editDeliveryOption(context, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteDeliveryOption",
        value: function deleteDeliveryOption(context, id, data) {
            return context.$http.put(this.baseURL + 'businesses/deliveryoptions/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "switchProcessingFeePay",
        value: function switchProcessingFeePay(context, data) {
            return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDiscountsAndCoupons",
        value: function getBusinessDiscountsAndCoupons(context, id) {
            return context.$http.get(this.baseURL + 'businesses/discounts/coupons/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setDiscountsAndCoupons",
        value: function setDiscountsAndCoupons(context, data) {
            return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editDiscountsAndCoupons",
        value: function editDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deactivateDiscountsAndCoupons",
        value: function deactivateDiscountsAndCoupons(context, data) {
            return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductImages",
        value: function getProductImages(context, id) {
            return context.$http.get(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductImage",
        value: function deleteProductImage(context, id) {
            return context.$http.delete(this.baseURL + 'products/images/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "uploadDataPhoto",
        value: function uploadDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "uploadBusinessDataPhoto",
        value: function uploadBusinessDataPhoto(context, data) {
            return context.$http.post(this.baseURL + 'businesses/uploads', data, {
                headers: {
                    'Origin-Host': this.apiToken,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    }, {
        key: "getUser",
        value: function getUser(context, id) {
            return context.$http.get(this.baseURL + 'users/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductsInBusinessCategories",
        value: function getProductsInBusinessCategories(context, id) {
            return context.$http.get(this.baseURL + 'products/businesses/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketCategories",
        value: function getMarketCategories(context) {
            return context.$http.get(this.baseURL + 'market/categories', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getFilters",
        value: function getFilters(context) {
            return context.$http.get(this.baseURL + 'filters', {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addBusiness",
        value: function addBusiness(context, data) {
            return context.$http.post(this.baseURL + 'businesses', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessNotifications",
        value: function getBusinessNotifications(context, id) {
            return context.$http.get(this.baseURL + 'notifications/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMessages",
        value: function getBusinessMessages(context, id) {
            return context.$http.get(this.baseURL + 'messages/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessOrders",
        value: function getBusinessOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/businesses/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "readNotifications",
        value: function readNotifications(context, data) {
            return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addCategory",
        value: function addCategory(context, data) {
            return context.$http.post(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editCategory",
        value: function editCategory(context, data) {
            return context.$http.put(this.baseURL + 'businesses/categories', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProducts",
        value: function getProducts(context, offset, limit) {
            return context.$http.get(this.baseURL + 'products/all/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketProducts",
        value: function getMarketProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getMarketActivityProducts",
        value: function getMarketActivityProducts(context, id, offset, limit) {
            return context.$http.get(this.baseURL + 'products/markets/activities/' + id + '/' + offset + '/' + limit, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessMarket",
        value: function getBusinessMarket(context, id) {
            return context.$http.get(this.baseURL + 'businesses/markets/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCategoryProducts",
        value: function getCategoryProducts(context, id) {
            return context.$http.get(this.baseURL + 'products/categories/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchCategoryProducts",
        value: function searchCategoryProducts(context, name, type) {
            return context.$http.get(this.baseURL + 'products/search/categories/' + name + '/' + type, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchProducts",
        value: function searchProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "searchBusinessProducts",
        value: function searchBusinessProducts(context, search) {
            return context.$http.get(this.baseURL + 'products/search/businesses/' + search, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductSearch",
        value: function getProductSearch(context, id) {
            return context.$http.get(this.baseURL + 'products/product/url/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProduct",
        value: function addProduct(context, data) {
            return context.$http.post(this.baseURL + 'products', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductItem",
        value: function addProductItem(context, data) {
            return context.$http.post(this.baseURL + 'products/items', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProductDetail",
        value: function addProductDetail(context, data) {
            return context.$http.post(this.baseURL + 'products/details', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "addProductReview",
        value: function addProductReview(context, data) {
            return context.$http.post(this.baseURL + 'products/reviews', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProduct",
        value: function editProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductSettings",
        value: function editProductSettings(context, id, data) {
            return context.$http.put(this.baseURL + 'products/settings/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemSingle",
        value: function editProductItemSingle(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/singles/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItem",
        value: function editProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItem",
        value: function removeProductItem(context, id, data) {
            return context.$http.put(this.baseURL + 'products/items/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductItemGroup",
        value: function editProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProductItemGroup",
        value: function removeProductItemGroup(context, id, data) {
            return context.$http.put(this.baseURL + 'products/itemgroups/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeProduct",
        value: function removeProduct(context, id, data) {
            return context.$http.put(this.baseURL + 'products/remove/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editProductDetail",
        value: function editProductDetail(context, id, data) {
            return context.$http.put(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductDetail",
        value: function deleteProductDetail(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/details/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductDeliveryOptions",
        value: function getProductDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'products/delivery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDelivery",
        value: function setProductDelivery(context, id, data) {
            return context.$http.put(this.baseURL + 'products/delivery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductShippingFeeStatus",
        value: function setProductShippingFeeStatus(context, data) {
            return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setProductDeliveryOption",
        value: function setProductDeliveryOption(context, data) {
            return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getProductInformation",
        value: function getProductInformation(context, id) {
            return context.$http.get(this.baseURL + 'products/information/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addProductInformation",
        value: function addProductInformation(context, data) {
            return context.$http.post(this.baseURL + 'products/information', data, {
                headers: {
                    'Origin-Host': this.apiToken

                }
            });
        }
    }, {
        key: "editProductInformation",
        value: function editProductInformation(context, id, data) {
            return context.$http.put(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteProductInformation",
        value: function deleteProductInformation(context, id, data) {
            return context.$http.delete(this.baseURL + 'products/information/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGallery",
        value: function editGallery(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGallery",
        value: function deleteGallery(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editGalleryPost",
        value: function editGalleryPost(context, id, data) {
            return context.$http.put(this.baseURL + 'posts/gallery/posts/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteGalleryPost",
        value: function deleteGalleryPost(context, id) {
            return context.$http.delete(this.baseURL + 'posts/gallery/posts/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "resetData",
        value: function resetData(context, type, id) {
            return context.$http.get(this.baseURL + 'data/reset/' + type + '/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "deleteImages",
        value: function deleteImages(context, id, data) {
            return context.$http.put(this.baseURL + 'data/images/' + id, data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkout",
        value: function checkout(context, data) {
            return context.$http.post(this.baseURL + 'orders', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrder",
        value: function getCheckoutOrder(context, url) {
            return context.$http.get(this.baseURL + 'orders/url/' + url, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getCheckoutOrders",
        value: function getCheckoutOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/topays/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getUserDeliveryDetails",
        value: function getUserDeliveryDetails(context, id) {
            return context.$http.get(this.baseURL + 'users/deliverydetails/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "updatePayment",
        value: function updatePayment(context, data) {
            return context.$http.post(this.baseURL + 'payments', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getOrders",
        value: function getOrders(context, id) {
            return context.$http.get(this.baseURL + 'orders/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "addService",
        value: function addService(context, data) {
            return context.$http.post(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "editService",
        value: function editService(context, data) {
            return context.$http.put(this.baseURL + 'businesses/services', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "getBusinessDeliveryOptions",
        value: function getBusinessDeliveryOptions(context, id) {
            return context.$http.get(this.baseURL + 'businesses/deliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "checkBusinessPayOnDelivery",
        value: function checkBusinessPayOnDelivery(context, id) {
            return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/' + id, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "sendBusinessContactForm",
        value: function sendBusinessContactForm(context, data) {
            return context.$http.post(this.baseURL + 'businesses/contacts', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessFilterOptions",
        value: function setBusinessFilterOptions(context, data) {
            return context.$http.put(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "removeBusinessFilterOption",
        value: function removeBusinessFilterOption(context, data) {
            return context.$http.post(this.baseURL + 'businesses/filters', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }, {
        key: "setBusinessBankDetails",
        value: function setBusinessBankDetails(context, data) {
            return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
                headers: {
                    'Origin-Host': this.apiToken
                }
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(187)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  "data-v-1a0c39ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(188)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  "data-v-1d8bed0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_SELLPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALL_SELLPOINTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALL_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCT_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_BY_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VIEW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_MSG; });
/* unused harmony export SUCCESS_MSG */
var ALL_SELLPOINTS = 'ALL_SELLPOINTS';
var ALL_SELLPOINTS_SUCCESS = 'ALL_SELLPOINTS_SUCCESS';

var ALL_PRODUCTS = 'ALL_PRODUCTS';
var ALL_PRODUCTS_SUCCESS = 'ALL_PRODUCTS_SUCCESS';

var PRODUCT_BY_ID = 'PRODUCT_BY_ID';
var PRODUCT_BY_ID_SUCCESS = 'PRODUCT_BY_ID_SUCCESS';

var VIEW_CART = 'VIEW_CART';
var ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = 'REMOVE_FROM_CART';

var ERROR_MSG = 'ERROR_MSG';
var SUCCESS_MSG = 'SUCCESS_MSG';

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: "validate_array",
        value: function validate_array(str_array, error_msg) {
            var process_errors = [];

            var reg_num = /^[0-9]+$/;
            var reg_name = /^[\w\-\s]+$/;
            var reg_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var reg_phone = /^\d{4}\d{3}\d{4}$/;

            for (var i = 0; i < str_array.length; i++) {
                var arr_in_str_array = str_array[i];
                if (arr_in_str_array[1] == undefined || arr_in_str_array[1] == "") {
                    process_errors.push(error_msg + arr_in_str_array[0]);

                    if (arr_in_str_array[2] == "alpha") {
                        if (!reg_name.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "num") {
                        if (!reg_num.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "email") {
                        if (!reg_email.test(String(arr_in_str_array[1]).toLowerCase())) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }

                    if (arr_in_str_array[2] == "phone") {
                        if (!reg_phone.test(arr_in_str_array[1])) {
                            process_errors.push(arr_in_str_array[0] + " is not valid");
                        }
                    }
                }
            }

            return process_errors;
        }
    }, {
        key: "validateEmail",
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    }, {
        key: "validateName",
        value: function validateName(name) {
            var re = /^[\w\-\s]+$/;
            return re.test(name);
        }
    }, {
        key: "validatePhoneNumber",
        value: function validatePhoneNumber(phone) {
            var re = /^\d{4}\d{3}\d{4}$/;
            return re.test(phone);
        }
    }, {
        key: "validateWebsite",
        value: function validateWebsite(url) {
            var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            return re.test(url);
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(185)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(193)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
    function _class() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

        this.market_store = 'm1010store';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'setMarketStoreForage',
        value: function setMarketStoreForage(data) {
            localforage.setItem(this.market_store, data).then(function (value) {}).catch(function (err) {});
        }
    }, {
        key: 'setBusinessStoreForage',
        value: function setBusinessStoreForage(data) {
            localforage.setItem(this.business_store, data).then(function (value) {}).catch(function (err) {});
        }
    }, {
        key: 'getBusinessStoreForage',
        value: function getBusinessStoreForage() {}
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(201)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-e351e79c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__businesses__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getstarted__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__purchase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__register__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__login__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sellpoint__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buypoint__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orderpoint__ = __webpack_require__(131);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [__WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__businesses__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__search__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__getstarted__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__purchase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__register__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__login__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__buypoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__orderpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__sellpoint__["a" /* default */], { path: '*', redirect: '/' }]
}));

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(136);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
    key: 'vuex',
    storage: window.localStorage,
    reducer: function reducer(state) {
        return {
            cart: state.cart
        };
    }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    strict: true,
    plugins: [vuexLocalStorage.plugin],
    state: {
        sellpoints: [],

        sellpoint: {},

        products: [],

        product: {},

        cart: [],

        showLoader: false
    },

    getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* productGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["b" /* sellpointGetters */], __WEBPACK_IMPORTED_MODULE_4__getters__["c" /* cartGetters */]),
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* productMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["b" /* sellpointMutations */], __WEBPACK_IMPORTED_MODULE_5__mutations__["c" /* cartMutations */]),
    actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__actions__["a" /* productActions */], __WEBPACK_IMPORTED_MODULE_6__actions__["b" /* sellpointActions */])
}));

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      user: {},
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem.active_order = true;
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_order_url = this.productMain.product_business_ownername + "-" + this.productMain.product_url_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }

      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;


      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);

      this.redir('order');
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    },
    configureCTAButton: function configureCTAButton() {}
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['productMain', 'productItemGroup', 'productItem', 'productMainView'],
  data: function data() {
    return {
      cart: this.$store.state.cart
    };
  },

  computed: {
    canAdd: function canAdd() {
      var _this = this;

      var index = this.cart.findIndex(function (p) {
        return p.product_item_id === _this.productItem.product_item_id;
      });
      if (index < 0) {
        return true;
      }
    }
  },
  methods: {
    addToCart: function addToCart() {
      this.productItem._id = this.productItem.product_item_id;

      if (this.productItem.product_item_order_quantity == undefined) {
        this.productItem.product_item_order_quantity = 1;
      }
      this.productItem.product_main_id = this.productMain.product_id;
      this.productItem.product_business = this.productMain.product_business_ownername;
      this.productItem.product_name = this.productMain.product_name;
      this.productItem.product_url = this.productMain.product_business_ownername + "/" + this.productMain.product_url_name;
      this.productItem.product_item_quantity = this.productItem.product_item_quantity;

      if (this.productItemGroup.product_item_group_is_color_image == 'IMG' && this.productItemGroup.product_item_group_image != 'error') {
        this.productItem.product_item_image = this.productItemGroup.product_item_group_image;
      } else {
        this.productItem.product_item_image = '';
      }

      this.productItem.product_shipping_calculation_method = this.productMain.product_set_shipping_fee_status;


      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["i" /* ADD_TO_CART */], this.productItem);
    },
    removeFromCart: function removeFromCart(payload) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
    },
    redir: function redir(rlink) {
      location.replace("/" + rlink);
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            product: {},
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {}
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
                this.addProductItemPanel = false;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.addProductItemPanel = false;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
                this.addProductPanel = false;
                this.createSellpointPanel = false;
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = false;
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.getSellpointCategories();
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this2 = this;

            service.getBusinessByUserName(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.sellpoint = response.body.data;

                    service.getBusinessCategories(_this2, _this2.sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this2.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                    _this2.getSubCategories(_this2.sellpoint.business_category_id);
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        getSubCategories: function getSubCategories(category) {
            var _this3 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this3.sub_categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProduct: function addProduct() {
            var _this5 = this;

            this.disable_btn = true;

            var credentials = {
                product_name: this.product.product_name,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function (data) {
                    var _this4 = this;

                    if (data.body.status == 201) {
                        toastr.success("Product Added Successfully", 'Success!');

                        this.product = data.body.data;

                        this.imageForm.append("data_id", this.product.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this4.product_info = true;
                                _this4.product_url = "/" + _this4.$route.params.id + "/" + _this4.product.product_url_name;
                            }
                        }).catch(function (err) {
                            if (err) {}
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this5.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                this.file_info = files;
                var formData = new FormData();
                formData.append('photo', files[0]);
                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.preset();
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductItemForm',
    data: function data() {
        return {
            user: {},
            sellpoint: {},
            product: {},
            product_items: {},
            disable_btn: false,
            imageForm: "",
            addProductItemPanel: false
        };
    },

    components: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'reset-edit') {}
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                        }, _this);

                        _this.setProduct();
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        setProduct: function setProduct() {
            var _this2 = this;

            service.getProductSearch(this, this.$route.params.id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.product = response.body.data;
                }
            }).catch(function (err) {
                _this2.$router.push("/");
            });
        },
        addProductItem: function addProductItem() {
            var _this3 = this;

            this.disable_btn = true;

            var credentials = {
                product_id: this.product.product_id,
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        var result = data.body.data;
                        this.imageForm.append("data_id", result.product_item_id);
                        this.imageForm.append("data_type", "product_items");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                location.reload(true);
                            }
                        }).catch(function (err) {
                            if (err) {}
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this3.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);


                this.imageForm = formData;
            }
        }
    },
    created: function created() {
        this.imageForm = new FormData();
        this.setProduct();
    }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-list',
  created: function created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },

  computed: {
    products: function products() {
      return this.$store.getters.allProducts;
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RightSidebar',
  data: function data() {
    return {
      user: {},
      loggedIn: false
    };
  },


  methods: {
    checkLoggedIn: function checkLoggedIn() {
      if (localStorage.getItem("sp_token") != null) {
        this.loggedIn = true;
        this.user.user_name = localStorage.getItem("sp_user");
      }
    }
  },
  created: function created() {
    this.checkLoggedIn();
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            search_words: "",
            search_type: "business"
        };
    },


    methods: {
        search: function search() {
            location.replace("search?search=" + this.search_type + "&k=" + this.search_words);
        }
    }
});

/***/ }),
/* 101 */
/***/ (function(module, exports) {



/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SearchBox',
    data: function data() {
        return {
            products: {}
        };
    },


    methods: {
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this.products = response.body.data;
                    _this.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASE; });
/* unused harmony export imageURL */
var API_BASE = 'http://localhost/kokoeco/dev/koko/v1/api/';
var imageURL = 'http://localhost/kokoeco/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(71);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_v_clipboard___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '\n    <div id="app">\n      <router-view></router-view>\n    </div>\n    '
}).$mount('#app');

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        var componentInstance = this;
        return {
            user: {},
            sellpoints: {},
            sellpoint: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},

            states: {},
            cities: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            managePanel: false,
            manageBusinesses: true,
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            showProductItemGroups: true,

            viewing_lookbook: {},
            viewing_lookbook_post: {},
            is_viewing_lookbook: false,

            drag_options: {
                onDragend: function onDragend(event) {
                    if (!event.droptarget) {
                        console.log('event is dropped out');
                    }
                }
            }

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-item-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default.a
    },

    methods: {
        onDragChangerr: function onDragChangerr() {
            console.log("jku");
        },
        onDragChange: function onDragChange(gallery) {

            console.log(gallery);
        },
        setComponent: function setComponent(attr1, attr2) {
            this.resetAll();
            this.data_processing_message = "";
            this.deactivate_processing();

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true;
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
        },
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        setMenuComponent: function setMenuComponent(go_to) {
            this.setPanel = false;
            this.managePanel = false;

            var section = document.getElementById(go_to).offsetTop;
            window.scrollTo(0, section);
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                this.setComponent('manage-lookbooks', '');
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;

                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                } else if (attr3 == 'viewLookbook') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        setBusinessComponent: function setBusinessComponent(component) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.businessComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var arr = _step.value;

                    if (arr == this.businessComponents[component]) {
                        this.businessComponents[component] = true;
                    } else {
                        this.businessComponents[this.businessComponents.indexOf(arr)] = false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing();
            this.discount_coupon = {};
            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse';
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing();

            if (component == "viewProductLookbookPost") {
                this.viewing_lookbook = this.lookbook;
                this.viewing_lookbook_post = attr3;
                this.is_viewing_lookbook = true;
                this.setComponent('manage-products', '');
                this.setComponentView('products', attr3.gallery_post_product_details, '');
            } else {

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {};
            this.setSellpoint();

            this.toggleSwitchBusiness();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this4.user = data.body.data;

                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this3);
                    } else {
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        syncset: function syncset(request_page) {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            };

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        },
        getSellpoints: function getSellpoints(user) {
            var _this6 = this;

            this.loading = false;
            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this6.sellpoints = data.body.data;
                    _this6.sellpoint = _this6.sellpoints[0];
                    _this6.business_set_shipping_fee_status = _this6.sellpoint.business_set_shipping_fee_status;

                    _this6.setSellpoint();
                    _this6.loading = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint_gallery = response.body.data;

                    _this7.getSellpointProducts();

                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Free Plan') {
                        _this7.max_plan_lookbooks = 2;
                        _this7.max_plan_lookbook_posts = 5;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Basic Plan') {
                        _this7.max_plan_lookbooks = 10;
                        _this7.max_plan_lookbook_posts = 50;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Premium Plan') {
                        _this7.max_plan_lookbooks = 50;
                        _this7.max_plan_lookbook_posts = 50;
                        _this7.can_add_product_lookbook = true;
                    }

                    var self = _this7;
                    setTimeout(function () {
                        self.setGallery();
                    }, 3000);
                    _this7.getCategories(_this7.sellpoint.business_category_id);

                    _this7.getSellpointCategories();
                }
            }).catch(function (err) {});
        },
        setGallery: function setGallery() {
            var _this8 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this8.galleria = response.body.data;

                _this8.total_lookbooks_added = response.body.total_data;

                if (_this8.total_lookbooks_added < _this8.max_plan_lookbooks) {
                    _this8.can_add_more_lookbook = true;
                }
                _this8.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this10 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this10.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this11, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this12 = this;

            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint edited";
                    if (attr == "delivery") {
                        this.business_details = {};
                    } else {
                        this.manageBusinessDetails = false;

                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top);
                        this.deactivate_processing();
                    }
                } else {
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this12.data_processing_message = "Could not edit details, something went wrong, please try again";
                _this12.deactivate_processing();
            });
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this13.delivery_option = {};
                        _this13.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};

                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this14.delivery_option.edit_set = false;
                        _this14.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.delivery_option = {};
                _this15.deactivate_processing();
            });
        },
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this16 = this;

            this.activate_processing();
            this.data_processing_message = "";

            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1;
            }

            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }


                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                        coupon_business_category: discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var row = _step3.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this16.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this17 = this;

            this.data_processing_message = "";

            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var item = _step4.value;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var row = _step5.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this17.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this18 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var row = _step7.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                _this18.deactivate_processing();
            });
        },
        getProductImages: function getProductImages() {
            var _this19 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_images = response.body.data;
                    _this19.product_display_image = _this19.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this20 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this20.deactivate_processing();
            });
        },
        editProduct: function editProduct() {
            var _this21 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this21.product = response.body.data;
                        _this21.product_details = {};
                    } else {
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this21.data_processing_message = "Something went wrong";
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this22 = this;

            this.activate_processing();

            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this22.product.product_items[0] = response.body.data;
                        _this22.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price;
                        _this22.deactivate_processing();
                        _this22.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this22.data_processing_message = "Update failed, Something went wrong";
                        _this22.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductSettings: function editProductSettings() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this23.product = response.body.data;
                    _this23.product_details = {};
                } else {
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this23.data_processing_message = "Something went wrong";
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this24 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                    this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,


                    product_item_group: this.product.product_item_group || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;

                        this.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this24.data_error_message = "Something went wrong", 'Warning!';

                        _this24.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');

                this.deactivate_processing();
            }
        },
        editProductItem: function editProductItem() {
            var _this25 = this;

            this.activate_processing();

            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this25.product_item = response.body.data;
                        _this25.deactivate_processing();
                        _this25.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this25.data_processing_message = "Update failed, Something went wrong";
                        _this25.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this26 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this26.product.product_item_groups = response.body.data;

                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    } else {
                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this26.data_processing_message = 'Update failed, Something went wrong';
                        _this26.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this27 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this27.redir(_this27.$route.params.id);
                    }
                    _this27.product.product_item_groups = response.body.data;

                    _this27.deactivate_processing();
                    _this27.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this27.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this28 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this28.redir(_this28.$route.params.id);
                    }
                    _this28.product.product_item_groups = response.body.data;
                    _this28.deactivate_processing();
                    _this28.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this28.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this29 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this29.product_details = {};
                _this29.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this30 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this30.delivery_option.edit_set = false;
                        _this30.product_details = {};
                        _this30.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        addPostToGallery: function addPostToGallery() {
            var _this32 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this31 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this31.setGallery();
                                _this31.gallery = data.body.data_gallery;
                                _this31.addNewPost = false;
                                _this31.edit_mode = false;
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this32.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this33 = this;

            this.activate_processing();

            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this33.data_processing_message = "Something went wrong";

                        _this33.deactivate_processing();
                        _this33.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this34 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {} else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this34.deactivate_processing();
                    _this34.lookbook_details = {};
                    _this34.data_processing_message = "Something went wrong";
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this35 = this;

            this.activate_processing();

            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data;
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this35.data_processing_message = "Something went wrong";

                        _this35.deactivate_processing();
                        _this35.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this36 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data;
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this36.deactivate_processing();
                    _this36.data_processing_message = "Something went wrong";
                    _this36.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        resetComponentData: function resetComponentData(component) {
            var _this37 = this;

            if (component == 'lookbook') {
                service.resetData(this, "gallery", this.lookbook.gallery_posts_group_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        var lookbook = response.body.data;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lookbook.gallery_posts_group_posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var post = _step8.value;

                                if (post.gallery_post_id == _this37.lookbook_post.gallery_post_id) {
                                    _this37.lookbook_post = post;
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        _this37.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this38 = this;

            this.product_details = {};
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;

                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this38.getProductImages();
                            if (_this38.product_details.editProductItemGroup) {
                                _this38.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this38.getProductInformation();
                        }
                        _this38.deactivate_processing();
                    } else {
                        _this38.data_processing_message = "Something went wrong uploading media, please try again";
                        _this38.deactivate_processing();
                    }
                    _this38.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this38.data_processing_message = "Something went wrong uploading media, please try again";
                    _this38.deactivate_processing();
                    _this38.product_details.uploading_image = false;
                });
            }
        },
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this39 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this39.product.product_item_group_image = data.body.data_id;
                            _this39.data_media_error_message = "";
                            _this39.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });

                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000);
                setTimeout(function () {
                    self.data_media_error_message = "";
                }, 95000);
            }
        },
        onFileChangeLookbook: function onFileChangeLookbook(e, type, data_id) {
            var _this40 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this40.resetComponentData("lookbook");
                        }
                    } else {
                        _this40.data_processing_message = "Sorry Upload Failed";
                    }
                    _this40.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this40.data_processing_message = "Sorry Upload Failed";
                        _this40.deactivate_processing();
                    }
                });
            }
        }
    },
    created: function created() {
        document.title = "Account" + " | Gallery";
        this.getStates();
        this.preset();
    }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, "nudeberry").then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    _this2.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        this.setMarketRemote();
    }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Account',
    data: function data() {
        var componentInstance = this;
        return {
            user: {},
            sellpoints: {},
            sellpoint: {},
            products: {},
            product: {},
            product_item_group: {},
            product_item: {},
            categories: {},
            main_category: {},
            sub_categories: [],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery: {},
            galleria: {},
            lookbooks: {},
            lookbook: {},
            lookbook_post: {},
            img_url: service.imageURL,
            server_query_done: false,
            setPanel: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            data_processing_message: "",
            data_error_message: "",
            data_success_message: "",
            data_media_error_message: "",
            max_media_info: service.max_upload_image_info,
            max_plan_lookbooks: 0,
            max_plan_lookbook_posts: 0,
            total_lookbooks_added: 0,
            can_add_more_lookbook: false,
            can_add_product_lookbook: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings: false,
            setting_details: {},

            states: {},
            cities: {},
            delivery_option: {},
            other_delivery_option: false,
            edit_other_delivery_option: false,
            component_view: { viewProducts: true, viewProduct: false, viewLookbooks: true, viewLookbook: false, viewLookbookPost: false },
            business_details: { delivery_edit: false, delivery_add: false, delivery_option_edit: false, viewDiscounts: true, setDiscount: false },
            product_details: {},
            lookbook_details: {},
            manageList: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            manage: ["manageBusinesses", "manageProducts", "manageServices", "manageLookbooks"],
            discount_coupon: {},
            managePanel: false,
            manageBusinesses: true,
            manageProducts: false,
            manageServices: false,
            manageLookbooks: false,
            managePosts: false,
            manageOrders: false,
            manageBusinessDetails: false,
            businessComponents: ["BusinessEditing", "BusinessDeliveryShipping", "BusinessCoupons", "BusinessPaymentGateway"],
            business_set_shipping_fee_status: 9,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,

            showProductItemGroups: true,

            viewing_lookbook: {},
            viewing_lookbook_post: {},
            is_viewing_lookbook: false,

            drag_options: {
                onDragend: function onDragend(event) {
                    if (!event.droptarget) {
                        console.log('event is dropped out');
                    }
                }
            }

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-item-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductItemForm_vue___default.a
    },

    methods: {
        onDragChangerr: function onDragChangerr() {
            console.log("jku");
        },
        onDragChange: function onDragChange(gallery) {

            console.log(gallery);
        },
        setComponent: function setComponent(attr1, attr2) {
            this.resetAll();
            this.data_processing_message = "";
            this.deactivate_processing();

            if (attr1 == 'set-settings-inner') {
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if (attr1 == 'manage-panel') {
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true;
            }

            if (attr1 == 'set-business-card-details') {
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if (attr1 == 'set-business-details') {
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
                this.business_details["delivery_option_edit"] = true;
            }

            if (attr1 == 'edit-discount-coupon') {
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if (attr1 == 'manage-businesses') {
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-products') {
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-services') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-lookbooks') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-posts') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if (attr1 == 'manage-orders') {
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            if (attr1 == 'reset-edit') {
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details = {};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message = "";
            }

            if (attr1 == 'reset-component-details') {
                this.manageBusinessDetails = false;
            }
        },
        setInnerComponent: function setInnerComponent(attr1, attr2) {
            if (attr1 == 'set-product-item-group') {
                this.product.product_item_group = attr2;

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                }

                document.getElementById(attr2 + "PRTGR").style = "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
        },
        resetAll: function resetAll() {
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        setMenuComponent: function setMenuComponent(go_to) {
            this.setPanel = false;
            this.managePanel = false;

            var section = document.getElementById(go_to).offsetTop;
            window.scrollTo(0, section);
        },
        setComponentView: function setComponentView(attr1, attr2, attr3) {
            this.resetAll();
            if (attr1 == 'switch-to-viewing-loobook') {
                this.setComponent('manage-lookbooks', '');
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks', this.viewing_lookbook_post, 'viewLookbookPost');

                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};
            }
            if (attr1 == 'products') {
                if (this.component_view.viewProducts) {
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;

                    this.product_set_shipping_fee_status = this.product.product_set_shipping_fee_status;
                } else if (this.component_view.viewProduct) {
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
            }
            if (attr1 == 'lookbooks') {
                if (attr3 == 'viewLookbookPost') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                } else if (attr3 == 'viewLookbook') {
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                } else if (attr3 == 'viewLookbooks') {
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
            }
        },
        setBusinessComponent: function setBusinessComponent(component) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.businessComponents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var arr = _step.value;

                    if (arr == this.businessComponents[component]) {
                        this.businessComponents[component] = true;
                    } else {
                        this.businessComponents[this.businessComponents.indexOf(arr)] = false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        setProductComponent: function setProductComponent(component, attr2, attr3) {
            this.deactivate_processing();
            this.discount_coupon = {};
            if (attr2 == 'productitemgroup') {
                this.product_item_group = attr3;
            }
            if (attr2 == 'productitem') {
                this.product_item = attr3;
            }

            if (component == "addProductItemPanel") {
                if (this.product.product_set_groups == 0) {
                    this.showProductItemGroups = 'showfalse';
                }
            }
            if (component == 'setProductDeliveryInformation') {
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (component == 'editDiscount') {
                this.discount_coupon = attr3;
            }
            if (component == 'deactivateDiscount') {
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3);
            }

            this.product_details = {};
            this.product_details[component] = true;
        },
        setLookbookComponent: function setLookbookComponent(component, attr2, attr3) {
            this.deactivate_processing();

            if (component == "viewProductLookbookPost") {
                this.viewing_lookbook = this.lookbook;
                this.viewing_lookbook_post = attr3;
                this.is_viewing_lookbook = true;
                this.setComponent('manage-products', '');
                this.setComponentView('products', attr3.gallery_post_product_details, '');
            } else {

                this.lookbook_details = {};
                this.lookbook_details[component] = true;
            }
        },
        toggleSwitchBusiness: function toggleSwitchBusiness() {
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        switchBusiness: function switchBusiness(sellpoint) {
            this.sellpoint = sellpoint;
            this.galleria = {};
            this.setSellpoint();

            this.toggleSwitchBusiness();
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message = "";
        },
        checkIfVideo: function checkIfVideo(url) {
            if (url != undefined) {
                var ext = url.split('.').pop();
                if (service.video_exts.includes(ext)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        reset: function reset() {
            this.setPanel = false;
            this.managePanel = false;
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this2 = this;

            this.activate_processing();
            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this3 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.server_query_done = true;
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this4 = this;

                            service.getUser(this, element.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this4.user = data.body.data;

                                    _this4.getSellpoints(element.user_id);
                                }
                            }).catch(function (err) {
                                if (err) {}
                            });
                        }, _this3);
                    } else {
                        _this3.$router.push('/login/');
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        syncset: function syncset(request_page) {
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page
            };
            if (credentials.session_key != null) {
                service.sessionSync(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var ref = response.body.data;
                        window.location.href = service.sp_url + '/manage/' + ref;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        editProfileDetails: function editProfileDetails() {
            var _this5 = this;

            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            };

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_processing_message = "";
            }
            if (data_test) {
                if (payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        } else {
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details = {};
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Could not edit details, something went wrong, please try again";
                        _this5.deactivate_processing();
                        _this5.setSettings = false;
                        _this5.setting_details = {};
                    });
                }
            }
        },
        getSellpoints: function getSellpoints(user) {
            var _this6 = this;

            this.loading = false;
            service.getAppBusinesses(this, user).then(function (data) {
                if (data.body.status == 200) {
                    _this6.sellpoints = data.body.data;
                    _this6.sellpoint = _this6.sellpoints[0];
                    _this6.business_set_shipping_fee_status = _this6.sellpoint.business_set_shipping_fee_status;

                    _this6.setSellpoint();
                    _this6.loading = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        setSellpoint: function setSellpoint() {
            var _this7 = this;

            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.sellpoint_gallery = response.body.data;

                    _this7.getSellpointProducts();

                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Free Plan') {
                        _this7.max_plan_lookbooks = 2;
                        _this7.max_plan_lookbook_posts = 5;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Basic Plan') {
                        _this7.max_plan_lookbooks = 10;
                        _this7.max_plan_lookbook_posts = 50;
                    }
                    if (_this7.sellpoint_gallery.business_market_subscription_name == 'Premium Plan') {
                        _this7.max_plan_lookbooks = 50;
                        _this7.max_plan_lookbook_posts = 50;
                        _this7.can_add_product_lookbook = true;
                    }

                    var self = _this7;
                    setTimeout(function () {
                        self.setGallery();
                    }, 3000);
                    _this7.getCategories(_this7.sellpoint.business_category_id);

                    _this7.getSellpointCategories();
                }
            }).catch(function (err) {});
        },
        setGallery: function setGallery() {
            var _this8 = this;

            service.getPointGalleryPosts(this, this.sellpoint.business_id, 0, this.max_plan_lookbooks, 0, this.max_plan_lookbook_posts).then(function (response) {
                _this8.galleria = response.body.data;

                _this8.total_lookbooks_added = response.body.total_data;

                if (_this8.total_lookbooks_added < _this8.max_plan_lookbooks) {
                    _this8.can_add_more_lookbook = true;
                }
                _this8.deactivate_processing();
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this10 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this10.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this11 = this;

            service.getBusinessByUserName(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this11, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this11.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this12 = this;

            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            } else {
                var payload = {
                    business_main_details: true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.data_processing_message = "Sellpoint edited";
                    if (attr == "delivery") {
                        this.business_details = {};
                    } else {
                        this.manageBusinessDetails = false;

                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top);
                        this.deactivate_processing();
                    }
                } else {
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this12.data_processing_message = "Could not edit details, something went wrong, please try again";
                _this12.deactivate_processing();
            });
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this13.delivery_option = {};
                        _this13.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.business_details = {};

                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this14.delivery_option.edit_set = false;
                        _this14.deactivate_processing();
                    });
                } else {
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.delivery_option = {};
                _this15.deactivate_processing();
            });
        },
        setShippingFeeStatus: function setShippingFeeStatus() {
            this.activate_processing();
            var payload = {
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id: this.sellpoint.business_id
            };

            service.setShippingFeeStatus(this, payload).then(function (data) {
                this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var _this16 = this;

            this.activate_processing();
            this.data_processing_message = "";

            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                this.discount_coupon.discount_category = 1;
            }

            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    var discount_category = 0;
                    if (this.business_details.setDiscount) {
                        discount_category = this.discount_coupon.discount_category;
                    }

                    var product_id = 0;
                    var product_item_id = 0;

                    if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                        product_id = this.product.product_id;
                    }
                    if (this.product_details.setProductItemDiscount) {
                        product_item_id = this.product_item.product_item_id;
                    }


                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                        coupon_business_category: discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date
                    };
                    service.setDiscountsAndCoupons(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var item = _step2.value;
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var row = _step3.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this16.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            var _this17 = this;

            this.data_processing_message = "";

            var entry_arr = [["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if (end_date <= start_date) {
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                } else {
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                        if (data.body.status == 200) {
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if (this.product_details.setProductDiscount || this.product_details.setProductItemDiscount) {
                                var res = data.body.data;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var item = _step4.value;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var row = _step5.value;

                                                if (row.product_item_id == item.product_item_id) {
                                                    item.product_item_discounts = row.product_item_discounts;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            } else {
                                this.sellpoint.business_discounts_coupons = data.body.data;
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch(function (err) {
                        _this17.deactivate_processing();
                    });
                }
            } else {
                validated_arr.forEach(function (error) {
                    this.data_processing_message = this.data_processing_message + " . " + error;
                }, this);
                this.deactivate_processing();
            }
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            var _this18 = this;

            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.business_details.viewDiscounts = true;
                    if (this.product.product_id) {
                        var res = data.body.data;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.product.product_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var row = _step7.value;

                                        if (row.product_item_id == item.product_item_id) {
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }
                    } else {
                        this.sellpoint.business_discounts_coupons = data.body.data;
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch(function (err) {
                _this18.deactivate_processing();
            });
        },
        getProductImages: function getProductImages() {
            var _this19 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_images = response.body.data;
                    _this19.product_display_image = _this19.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            var _this20 = this;

            this.activate_processing();
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this20.deactivate_processing();
            });
        },
        editProduct: function editProduct() {
            var _this21 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this21.product = response.body.data;
                        _this21.product_details = {};
                    } else {
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this21.data_processing_message = "Something went wrong";
                        _this21.product_details = {};
                        _this21.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        editProductSingleProductItem: function editProductSingleProductItem() {
            var _this22 = this;

            this.activate_processing();

            var set_product_item = 0;
            var current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if (this.product.product_items[0].product_item_actual_price != 0) {
                set_product_item = this.product.product_items[0].product_item_actual_price;
            } else {
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this22.product.product_items[0] = response.body.data;
                        _this22.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price;
                        _this22.deactivate_processing();
                        _this22.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this22.data_processing_message = "Update failed, Something went wrong";
                        _this22.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductSettings: function editProductSettings() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item'
            };

            var navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this23.product = response.body.data;
                    _this23.product_details = {};
                } else {
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            }).catch(function (err) {
                if (err) {
                    _this23.data_processing_message = "Something went wrong";
                    _this23.product_details = {};
                    _this23.deactivate_processing();
                }
            });
        },
        addProductItem: function addProductItem() {
            var _this24 = this;

            this.activate_processing();
            if (this.product_details.addProductItemToGroup) {
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            } else {
                var new_product_item_group = false;
                var product_item_group_is_color_image = 'IMG';
                if (this.product.product_item_group == undefined) {
                    new_product_item_group = true;
                }
                if (this.product.product_item_group_color == undefined) {
                    product_item_group_is_color_image = 'IMG';
                } else {
                    product_item_group_is_color_image = 'COL';
                    this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,


                    product_item_group: this.product.product_item_group || 1,

                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: this.product.product_item_service_duration + this.service_duration || '1 year'
                };
            }
            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function (data) {
                    if (data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        this.product = data.body.data_product;

                        this.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this24.data_error_message = "Something went wrong", 'Warning!';

                        _this24.deactivate_processing();
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');

                this.deactivate_processing();
            }
        },
        editProductItem: function editProductItem() {
            var _this25 = this;

            this.activate_processing();

            var set_product_item = 0;
            if (this.product_item.product_item_actual_price != 0) {
                set_product_item = this.product_item.product_item_actual_price;
            } else {
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,

                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this25.product_item = response.body.data;
                        _this25.deactivate_processing();
                        _this25.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this25.data_processing_message = "Update failed, Something went wrong";
                        _this25.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this26 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this26.product.product_item_groups = response.body.data;

                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    } else {
                        _this26.deactivate_processing();
                        _this26.product_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this26.data_processing_message = 'Update failed, Something went wrong';
                        _this26.deactivate_processing();
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    location.reload(true);
                }
            }).catch(function (err) {
                if (err) {
                    location.reload(true);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this27 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this27.redir(_this27.$route.params.id);
                    }
                    _this27.product.product_item_groups = response.body.data;

                    _this27.deactivate_processing();
                    _this27.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this27.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this28 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this28.redir(_this28.$route.params.id);
                    }
                    _this28.product.product_item_groups = response.body.data;
                    _this28.deactivate_processing();
                    _this28.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this28.deactivate_processing();
                }
            });
        },
        setProductDelivery: function setProductDelivery() {
            var _this29 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product_details = {};
                }
                this.deactivate_processing();
            }).catch(function (err) {
                _this29.product_details = {};
                _this29.deactivate_processing();
            });
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                this.set_shipping_fee_status_track = false;
                this.deactivate_processing();
            }).catch(function (err) {});
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this30 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.product_details = {};

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this30.delivery_option.edit_set = false;
                        _this30.product_details = {};
                        _this30.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        addPostToGallery: function addPostToGallery() {
            var _this32 = this;

            this.disable_btn = true;

            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details
            };

            var navi = this.$router;
            if (credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function (data) {
                    var _this31 = this;

                    if (data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');

                        this.post = data.body.data;

                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type", "gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(function (data) {
                            if (data.body.status == 200) {
                                _this31.setGallery();
                                _this31.gallery = data.body.data_gallery;
                                _this31.addNewPost = false;
                                _this31.edit_mode = false;
                            }
                        }).catch(function (err) {
                            if (err) {
                                console.log(err);
                            }
                            toastr.warning("Something went wrong.", 'Warning!');
                        });
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.warning("Something went wrong", 'Warning!');

                        _this32.disable_btn = false;
                    }
                });
            } else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },
        editLookbook: function editLookbook() {
            var _this33 = this;

            this.activate_processing();

            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description: this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id
            };

            var navi = this.$router;
            if (credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                    } else {
                        this.deactivate_processing();
                        this.editGalleryPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this33.data_processing_message = "Something went wrong";

                        _this33.deactivate_processing();
                        _this33.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },
        deleteLookbook: function deleteLookbook() {
            var _this34 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function (data) {
                if (data.body.status == 200) {} else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this34.deactivate_processing();
                    _this34.lookbook_details = {};
                    _this34.data_processing_message = "Something went wrong";
                }
            });
        },
        editLookbookPost: function editLookbookPost() {
            var _this35 = this;

            this.activate_processing();

            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details: this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id
            };

            var navi = this.$router;
            if (credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function (data) {
                    if (data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";

                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data;
                    } else {
                        this.deactivate_processing();
                        this.lookbook_details = {};
                    }
                }).catch(function (err) {
                    if (err) {
                        _this35.data_processing_message = "Something went wrong";

                        _this35.deactivate_processing();
                        _this35.lookbook_details = {};
                    }
                });
            } else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },
        deleteLookbookPost: function deleteLookbookPost() {
            var _this36 = this;

            this.activate_processing();
            var navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function (data) {
                if (data.body.status == 200) {
                    this.lookbook = data.body.data;
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                } else {
                    this.data_processing_message = "Something went wrong";
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch(function (err) {
                if (err) {
                    _this36.deactivate_processing();
                    _this36.data_processing_message = "Something went wrong";
                    _this36.lookbook_details = {};
                }
            });
        },
        deletePostImage: function deletePostImage(image) {
            this.activate_processing();
            var payload = {
                data_type: "gallery_media"
            };
            service.deleteImages(this, image, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        resetComponentData: function resetComponentData(component) {
            var _this37 = this;

            if (component == 'lookbook') {
                service.resetData(this, "gallery", this.lookbook.gallery_posts_group_url_name).then(function (response) {
                    if (response.body.status == 200) {
                        var lookbook = response.body.data;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lookbook.gallery_posts_group_posts), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var post = _step8.value;

                                if (post.gallery_post_id == _this37.lookbook_post.gallery_post_id) {
                                    _this37.lookbook_post = post;
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        _this37.deactivate_processing();
                    }
                }).catch(function (err) {});
            }
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this38 = this;

            this.product_details = {};
            this.product_details.uploading_image = true;
            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;

                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this38.getProductImages();
                            if (_this38.product_details.editProductItemGroup) {
                                _this38.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this38.getProductInformation();
                        }
                        _this38.deactivate_processing();
                    } else {
                        _this38.data_processing_message = "Something went wrong uploading media, please try again";
                        _this38.deactivate_processing();
                    }
                    _this38.product_details.uploading_image = false;
                }).catch(function (err) {
                    _this38.data_processing_message = "Something went wrong uploading media, please try again";
                    _this38.deactivate_processing();
                    _this38.product_details.uploading_image = false;
                });
            }
        },
        onFileChangeProductItems: function onFileChangeProductItems(e, type, data_id) {
            var _this39 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this39.product.product_item_group_image = data.body.data_id;
                            _this39.data_media_error_message = "";
                            _this39.getProductImages();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });

                this.data_media_error_message = service.media_upload_timeout_msg;
                var self = this;
                setTimeout(function () {
                    self.data_media_error_message;
                }, 65000);
                setTimeout(function () {
                    self.data_media_error_message = "";
                }, 95000);
            }
        },
        onFileChangeLookbook: function onFileChangeLookbook(e, type, data_id) {
            var _this40 = this;

            this.activate_processing();
            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);

                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "gallery_media") {
                            _this40.resetComponentData("lookbook");
                        }
                    } else {
                        _this40.data_processing_message = "Sorry Upload Failed";
                    }
                    _this40.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this40.data_processing_message = "Sorry Upload Failed";
                        _this40.deactivate_processing();
                    }
                });
            }
        }
    },
    created: function created() {
        document.title = "Account" + " | Gallery";
        this.getStates();
        this.preset();
    }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_8__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
        },
        toggleFAQComponent: function toggleFAQComponent(action, show, hide, head, body) {
            if (action == 'show') {
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if (action == 'hide') {
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;

                    _this2.getMarketMainProductsAsSubscriptions();

                    _this2.loading = false;
                }
            }).catch(function (err) {
                _this2.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this3 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this3.subscriptions = response.body.data;
                    _this3.plan1 = _this3.subscriptions[2];
                    _this3.plan2 = _this3.subscriptions[1];
                    _this3.plan3 = _this3.subscriptions[0];
                }
            }).catch(function (err) {});
        },
        purchase_plan: function purchase_plan(plan, plan_product_service_item_index) {
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;

            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.selected_plan.product_items[0].product_item_price == 0) {
                this.updatePayment("gw-free-account");
            } else {
                this.processPayment();
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                    } else {
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if (this.selected_plan.product_items[0].product_item_price == 0) {
                            this.updatePayment("gw-free-account");
                        } else {
                            this.processPayment();
                        }
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                }
            }).catch(function (err) {});
        },
        processPayment: function processPayment() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan.product_items[0].product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan.product_items[0].product_item_price * 100),
                    ref: "GWLOG" + Math.random(),
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        updatePayment: function updatePayment(payment_ref) {

            var navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this5 = this;

            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this4 = this;

                if (data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            $('#purchaseModal').modal('hide');
                            navi.push('/' + _this4.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');
                            _this4.disable_btn = false;
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    toastr.warning("Something went wrong", 'Warning!');
                    _this5.disable_btn = false;
                }
            });
        },
        setUpNewAccount: function setUpNewAccount() {
            this.disable_btn = true;
            this.loading = true;
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this6 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this6.preset();

                                    setTimeout(function () {
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this6.data_error_message = "invalid login credentials..";
                                    _this6.disable_btn = false;
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },
        validateUserName: function validateUserName() {
            var _this7 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this7.validate_user_name_error = true;
                    _this7.validate_user_name_message = "This username already exist";
                }
            }).catch(function (err) {
                _this7.validate_user_name_error = true;
                _this7.validate_user_name_message = "This username already exist";
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this8 = this;

            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3,
                business_subscription: this.selected_plan.product_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            $('#newBusinessModal').modal('hide');
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this8.data_error_message = "Something went wrong";
                            _this8.disable_btn = false;
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;
            });
        },
        creation_thread: function creation_thread() {
            var promises = [];
            for (var i = 0; i < 9; ++i) {
                if (i == 1) {
                    promises.push(this.preset());
                }
                if (i == 2) {
                    promises.push(this.getSellpointMarket());
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
                promises.forEach(function (promise) {
                    result.then(function () {});
                });
            }).catch(function (e) {});
        }
    },

    created: function created() {
        var self = this;
        setTimeout(function () {
            var menu = self.$route.params.menu;
            if (menu == "features") {
                var top = document.getElementById("features").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "pricing") {
                var top = document.getElementById("pricing").offsetTop;
                window.scrollTo(0, top);
            }
            if (menu == "blog") {
                var top = document.getElementById("blog").offsetTop;
                window.scrollTo(0, top);
            }
        }, 1500);
        this.creation_thread();
    }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var util = new __WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            products: {},
            product: {},
            search_words: "",
            search_type: "business",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_6__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_7__components_templates_searchbox_vue___default.a
    },
    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        search: function search() {
            this.$router.push("search?search=" + this.search_type + "&k=" + this.search_words);
        },
        setProducts: function setProducts() {
            this.getProducts(0, 20);
        },
        setMarketRemote: function setMarketRemote() {
            var _this2 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this2.market = response.body.data;
                    util.setMarketStoreForage(_this2.market);
                }
            }).catch(function (err) {});
        },
        getMarketActivityProducts: function getMarketActivityProducts() {
            var _this3 = this;

            var offset = 0;var limit = 20;
            service.getMarketActivityProducts(this, service.market_app_name, offset, limit).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.loading = false;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.setMarketRemote();
        this.preset();
        this.getMarketActivityProducts();
    }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        var _ref;

        return _ref = {
            users: {},
            user: {},
            states: {},
            cities: {},
            disable_btn: false,
            data_error_message: ""
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disable_btn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'action_loading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'activate_token', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'set_forgot_password', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'reset_password', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'display_reset_password_form', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'data_processing_message', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'set_cta', false), _ref;
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a
    },
    computed: {
        checkPasswordMatch: function checkPasswordMatch() {
            this.data_processing_message = "";
            if (this.user.new_password != '' && this.user.new_password != undefined && this.user.confirm_password != '' && this.user.confirm_password != undefined) {
                if (this.user.new_password != this.user.confirm_password) {
                    this.data_processing_message = "Password does not match";
                } else {
                    this.data_processing_message = "";
                }
            } else {
                this.data_processing_message = "";
            }
        }
    },
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'forgot') {
                this.set_forgot_password = true;
            }
            if (attr1 == 'login') {
                this.set_forgot_password = false;
            }
            if (attr1 == 'reset') {
                this.reset_password = true;
                this.loading = true;
                this.verifyResetToken();
            }
            if (attr1 == 'activate') {
                this.activate_token = true;
                this.loading = true;
                this.activateUserToken();
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        showPassword: function showPassword() {
            var x = document.getElementById("password1");
            var y = document.getElementById("password2");
            if (x.type === "password") {
                x.type = "text";
                y.type = "text";
            } else {
                x.type = "password";
                y.type = "password";
            }
        },
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
            localStorage.removeItem("sp_#_sellpoint");
        },
        login: function login() {
            var _this = this;

            this.activate_processing();
            this.data_error_message = "";
            var credentials = {
                user_email: this.user.email,
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_email != null && credentials.user_password != null) {
                service.loginUser(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        localStorage.setItem("sp_user", data.user_name);
                        localStorage.setItem("sp_token", data.user_session_key);
                        localStorage.setItem("sp_token_key", data.user_token_key);
                        navi.push('/account');
                    } else {
                        _this.data_error_message = "invalid login credentials";

                        _this.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this.data_error_message = "Sorry, could not process request";

                    _this.deactivate_processing();
                });
            } else {
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },
        activateUserToken: function activateUserToken() {
            var _this2 = this;

            var navi = this.$router;
            service.activateUserToken(this, this.$route.params.activatetoken).then(function (response) {
                if (response.body.status == 200) {
                    _this2.data_processing_message = "Your Account Activation was successful. redirecting....";
                } else {
                    _this2.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                }
                setTimeout(function () {
                    navi.push('/');
                }, 5250);
            }).catch(function (err) {
                _this2.data_processing_message = "Your Account Activation was not successful, please try again. redirecting....";
                setTimeout(function () {
                    navi.push('/');
                }, 5250);
            });
        },
        forgot: function forgot() {
            var _this3 = this;

            this.data_processing_message = "";
            this.activate_processing();
            var credentials = {
                user_email: this.user.email
            };

            var navi = this.$router;
            if (credentials.user_email) {
                service.forgotPassword(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this3.set_cta = true;
                        _this3.data_processing_message = "Request was successful, please check your email for a link to reset password";
                    }
                    if (response.body.status == 404) {
                        _this3.data_processing_message = "Could not find this email";
                    }
                    if (response.body.status == 400) {
                        _this3.data_processing_message = "Request could not be completed, please try again";
                    }
                    _this3.deactivate_processing();
                }).catch(function (err) {
                    _this3.data_processing_message = "Request could not be completed, please try again";
                    _this3.deactivate_processing();
                });
            } else {
                this.data_processing_message = "Please enter your email";
                tthis.deactivate_processing();
            }
        },
        verifyResetToken: function verifyResetToken() {
            var _this4 = this;

            service.verifyResetPasswordToken(this, this.$route.params.resettoken).then(function (response) {
                if (response.body.status == 200) {
                    _this4.loading = false;
                    _this4.user.email = response.body.data;
                } else {
                    _this4.data_processing_message = "Password reset failed, please reset againj";
                    _this4.reset_password = false;
                    _this4.set_forgot_password = true;
                }
                _this4.deactivate_processing();
            }).catch(function (err) {
                _this4.data_processing_message = "Password reset failed, please reset againn";
                _this4.reset_password = false;
                _this4.set_forgot_password = true;
                _this4.loading = false;
            });
        },
        resetForgotPassword: function resetForgotPassword() {
            var _this5 = this;

            this.data_processing_message = "";

            if (this.user.new_password != '' && this.user.new_password != undefined) {
                if (this.user.new_password != this.user.confirm_password) {
                    this.data_processing_message = "Passwords does not match";
                } else {
                    this.activate_processing();
                    var credentials = {
                        user_email: this.user.email,
                        new_password: this.user.new_password
                    };

                    var navi = this.$router;

                    service.resetForgotPassword(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            _this5.data_processing_message = "Password Request was successful";
                            _this5.user.password = _this5.user.new_password;
                            _this5.loading = true;
                            var self = _this5;
                            setTimeout(function () {
                                self.login();
                            }, 6750);
                        } else {
                            _this5.data_processing_message = "Request could not be completed, please try again";
                            _this5.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this5.data_processing_message = "Request could not be completed, please try again";
                        _this5.deactivate_processing();
                    });
                }
            } else {
                this.data_processing_message = "Please enter passwords";
            }
        }
    },
    created: function created() {
        this.reset();

        if (this.$route.params.activatetoken) {
            this.setComponent("activate", "");
        }

        if (this.$route.params.resettoken) {
            this.setComponent("reset", "");
        }
    }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);

var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainFooter",
    data: function data() {
        return {
            user: {},
            user_slug: {}
        };
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(47);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var util = new __WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "MainHeader",
    data: function data() {
        return {
            user: '',
            user_slug: {},
            market: {},
            products: {},
            product: {},
            items: [],
            checked_out_items: [],
            img_url: service.imageURL,
            loggedIn: false
        };
    },

    components: {},

    computed: {
        total: function total() {
            var total = 0;
            for (var i = 0; i < this.items.length; i++) {
                total += this.items[i].product_price;
            }
            return total;
        }
    },
    methods: {
        checkLoggedIn: function checkLoggedIn() {
            if (localStorage.getItem("sp_token") != null) {
                this.loggedIn = true;
                this.user = localStorage.getItem("sp_user");
            }
        },
        setMarketLocal: function setMarketLocal() {
            var self = this;
            setTimeout(function () {
                localforage.getItem(util.market_store, function (err, value) {
                    self.market = value;
                });
            }, 1500);
        },
        slide: function slide() {
            console.log("hy6qdd111");

            $('.main-slider').bxSlider({
                pagerCustom: '.pager-container',
                controls: false,
                easing: 'ease-in',
                speed: 800,
                auto: true,
                pause: 6000
            });

            $('#video .radial-progress').on('click', function () {
                $('#video > iframe').show();
            });

            $('.tooltip').tooltipster({
                animation: 'grow',
                position: 'bottom'
            });

            $("figure.imgLiquidFill").imgLiquid();

            $('ul.dishes > li > div > a').magnificPopup({
                type: 'image',
                removalDelay: 300,
                mainClass: 'mfp-fade',
                image: {
                    tError: 'The image could not be loaded.'
                },
                closeMarkup: '<span class="mfp-close"></span>'
            });
        }
    },
    created: function created() {
        this.checkLoggedIn();
        this.setMarketLocal();
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);





var service = new __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            group_products: {},
            item_product: {},
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            coupon_code: [],
            product_delivery_fee: "",
            sellpoint_delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_delivery_fee: 0.0,
            processed_groups: 0,
            process_count: 0,
            loggedIn: false,
            buy_now_order: false
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {},
        toggleProductDelivery: function toggleProductDelivery(attr1, i, product_index) {
            if (attr1 == 'item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if (attr1 == 'hide-item-delivery-options') {
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },
        toggleSellpointDelivery: function toggleSellpointDelivery(attr1, i) {
            if (attr1 == 'group-delivery-options') {
                this.sorted_cart[i].display_delivery_details++;
            }
            if (attr1 == 'hide-group-delivery-options') {
                this.sorted_cart[i].display_delivery_details = false;
            }
        },
        removeFromCart: function removeFromCart(item_id, group_index, item) {
            this.removeFromSortedCart(group_index, item);
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item_id);

            this.prepCart();
        },
        removeFromSortedCart: function removeFromSortedCart(group_index, item) {
            var index = this.sorted_cart[group_index][1].findIndex(function (p) {
                return p._id === item._id;
            });
            this.sorted_cart[group_index][1].splice(index, 1);
        },
        prepCart: function prepCart() {
            var sorted_cart = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.cart.reduce(function (result, obj) {
                (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                return result;
            }, {}));


            var count = 0;var sorted_cart_array = [];
            sorted_cart.forEach(function (element) {
                var _this = this;

                var pre_sort = [];

                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];

                element.forEach(function (item) {
                    item.can_remove = true;
                    item.display_delivery_details = false;

                    item.has_delivery = false;
                    if (item.product_checked) {
                        item.product_checked = false;
                    }

                    service.getProductDeliveryOptions(this, item.product_main_id).then(function (response) {
                        if (response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        } else {
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch(function (err) {
                        pre_sort.products_without_delivery_details_count += 1;
                    });
                }, this);
                pre_sort.display_delivery_details = 0;
                pre_sort[0] = element[0].product_business;
                pre_sort[1] = element;
                pre_sort.items_in_checkout = 0;
                pre_sort.total_order_amt = 0.0;
                pre_sort.delivery_option_fee = 0.0;
                pre_sort.total_delivery_charge = 0.0;
                pre_sort.order_coupons_discounts = [];
                var promises = [];
                for (var i = 0; i < 5; ++i) {
                    if (i == 1) {
                        promises.push(service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[4] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 2) {
                        promises.push(service.getBusinessDeliveryOptions(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                var delivery_options = response.body.data;

                                if (element.length == 1) {
                                    delivery_options.forEach(function (item) {
                                        var fees = item.business_products_delivery_fees;

                                        if (fees.length != 0) {
                                            fees.forEach(function (fee) {
                                                if (element[0].product_main_id == fee.product_delivery_product) {
                                                    item.has_product_delivery_fee = true;
                                                    item.business_product_delivery_fee = fee.product_delivery_fee;
                                                    pre_sort[2] = delivery_options;
                                                }
                                            }, this);
                                        } else {
                                            pre_sort[2] = delivery_options;
                                        }
                                    }, _this);
                                } else {
                                    pre_sort[2] = delivery_options;
                                }

                                pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                            } else {
                                pre_sort.delivery_option = "Free Delivery";
                            }
                        }).catch(function (err) {}));
                    }

                    if (i == 3) {
                        promises.push(service.checkBusinessPayOnDelivery(this, element[0].product_business).then(function (response) {
                            if (response.body.status == 200) {
                                pre_sort[3] = response.body.data;
                            }
                        }).catch(function (err) {}));
                    }
                }

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    sorted_cart_array.push(pre_sort);
                }).catch(function (e) {});
            }, this);

            this.sorted_cart = sorted_cart_array;

            return this.sorted_cart;
        },
        preset: function preset() {
            var _this2 = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.prepCart();
                        }, _this2);
                        _this2.loggedIn = true;
                    } else {}
                    _this2.loading = false;
                }).catch(function (err) {
                    if (err) {}
                });
            } else {
                this.$router.push('login');
            }
        },
        set_coupons: function set_coupons(i, coupon, coupon_percentage) {
            var calc = 0;
            if (this.sorted_cart[i].total_order_amt != 0) {
                if (!coupon.added) {
                    calc = coupon_percentage / 100 * this.sorted_cart[i].total_order_amt;

                    coupon.added = true;
                    coupon.value = calc;
                    this.sorted_cart[i].order_coupons_discounts.push(coupon);

                    this.sorted_cart[i].total_order_amt -= calc;

                    this.total_order_amt -= calc;
                } else {
                    calc = coupon.value;

                    coupon.added = false;
                    var index = this.sorted_cart[i].order_coupons_discounts.findIndex(function (c) {
                        return c.discount_id === coupon.discount_id;
                    });
                    this.sorted_cart[i].order_coupons_discounts.splice(index, 1);

                    this.sorted_cart[i].total_order_amt += calc;

                    this.total_order_amt += calc;
                    coupon.value = 0;
                }
            } else {
                this.coupon_code.checked = false;
            }
        },
        calc_product_delivery_fee: function calc_product_delivery_fee(i, option, product_index) {
            if (this.sorted_cart[i][1][product_index].delivery_option_fee != undefined) {
                if (this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0) {
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee_XXX: function calc_sellpoint_delivery_fee_XXX(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);

            this.total_delivery_fee += Number(option.business_delivery_option_price);
        },
        calc_sellpoint_delivery_fee: function calc_sellpoint_delivery_fee(i, option) {
            if (this.sorted_cart[i].delivery_option_fee != 0.0) {
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee;
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }

            this.sorted_cart[i].selected_business_delivery_option = option;
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;

            var fees = option.business_products_delivery_fees;
            if (fees.length == 0) {
                if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                } else {
                    var items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                        return item.product_checked == true;
                    });
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items_to_checkout), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                            }
                            if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } else {
                var _items_to_checkout = this.sorted_cart[i][1].filter(function (item) {
                    return item.product_checked == true;
                });

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item = _step2.value;

                        if (_item.has_calculated_product_delivery_fee == true) {
                            _item.has_calculated_product_delivery_fee = false;
                            _item.calculated_product_delivery_fee = 0;
                        };
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(fees), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var fee = _step4.value;

                                if (_item.product_main_id == fee.product_delivery_product) {
                                    if (_item.product_shipping_calculation_method == 13) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item.product_item_order_quantity * fee.product_delivery_fee);
                                    }
                                    if (_item.product_shipping_calculation_method == 12) {
                                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                                    }

                                    _item.has_calculated_product_delivery_fee = true;
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var sorted_fees = _items_to_checkout.filter(function (item) {
                    return item.has_calculated_product_delivery_fee == true;
                });

                if (sorted_fees.length < _items_to_checkout.length) {
                    if (this.sorted_cart[i].business_shipping_calculation_method == 9) {
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                    } else {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_items_to_checkout), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item2 = _step3.value;

                                if (this.sorted_cart[i].business_shipping_calculation_method == 10) {
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price);
                                }
                                if (this.sorted_cart[i].business_shipping_calculation_method == 11) {
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(_item2.product_item_order_quantity * option.business_delivery_option_price);
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            }

            this.sorted_cart[i].delivery_option_fee = Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.sorted_cart[i].total_delivery_charge += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);

            this.total_delivery_fee += Number(this.sorted_cart[i].delivery_option_total_delivery_fee);
        },
        calc_total_delivery_fee: function calc_total_delivery_fee() {
            this.sorted_cart.forEach(function (element) {});
        },
        setPaymentOption: function setPaymentOption(i, option) {
            this.sorted_cart[i].payment_mode = option;
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        refreshCheckout: function refreshCheckout(it, group_index, item_index) {
            this.sorted_cart[group_index].total_order_amt = 0;
            this.total_order_amt = 0;
            this.checked_out.forEach(function (item) {
                this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

                this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            }, this);
        },
        addToCheckout: function addToCheckout(item, group_index, item_index) {
            this.sorted_cart[group_index][1][item_index].can_remove = false;
            this.sorted_cart[group_index].products_in_checkout = true;
            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            } else {
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true;
            this.sorted_cart[group_index].total_order_amt += item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt += item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout++;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }

            if (this.buy_now_order) {
                document.getElementById(item.item_index + "PRT_CART").style = "display:block;";
            }
        },
        removeFromCheckout: function removeFromCheckout(item, group_index, item_index) {
            var index = this.checked_out.findIndex(function (p) {
                return p._id === item._id;
            });
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;

            if (this.sorted_cart[group_index][1][item_index].has_delivery) {
                var _index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(_index, 1);;
            } else {
                var _index2 = this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(function (p) {
                    return p._id === item._id;
                });
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(_index2, 1);;
            }

            this.sorted_cart[group_index].total_order_amt -= item.product_item_order_quantity * item.product_item_price;

            this.total_order_amt -= item.product_item_order_quantity * item.product_item_price;
            this.sorted_cart[group_index].items_in_checkout--;

            this.sorted_cart[group_index][1][item_index].can_remove = true;
            if (this.sorted_cart[group_index].items_in_checkout == 0 && this.sorted_cart[group_index].delivery_option != "Free Delivery") {
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee;
                this.sorted_cart[group_index].delivery_option_fee = 0;
                this.sorted_cart[group_index].delivery_option = 0;
                this.sorted_cart[group_index].total_delivery_charge = 0;
            }

            if (this.sorted_cart[group_index].selected_business_delivery_option) {
                this.calc_sellpoint_delivery_fee(group_index, this.sorted_cart[group_index].selected_business_delivery_option);
            }
        },
        process_checkout: function process_checkout(group) {
            var processed_checkout = {};

            processed_checkout.order_user_id = this.user.user_id;
            processed_checkout.order_mode = 1;
            processed_checkout.order_business = group[0];
            var order_url = group[0] + new Date().getTime();
            processed_checkout.order_url = order_url, processed_checkout.order_delivery_option = group.delivery_option;
            processed_checkout.order_payment_mode = group.payment_mode || 1;
            processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
            processed_checkout.order_items = [];
            this.checked_out.forEach(function (element) {
                if (element.product_business == group[0]) {
                    processed_checkout.order_items.push(element);
                }
                processed_checkout.status = "processed";
            }, this);
            if (processed_checkout.status == "processed") {
                if (this.loggedIn) {
                    service.checkout(this, processed_checkout).then(function (data) {
                        if (data.body.status == 201) {
                            this.process_count++;

                            processed_checkout.order_items.forEach(function (item) {
                                this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                                var index = this.checked_out.findIndex(function (p) {
                                    return p._id === item._id;
                                });
                                this.checked_out.splice(index, 1);
                            }, this);
                        }

                        if (this.process_count == this.processed_groups) {
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;

                            location.replace("/checkout/" + order_url);
                        }
                    }).catch(function (err) {
                        if (err) {}
                    });
                } else {
                    this.process_count++;

                    processed_checkout.order_items.forEach(function (item) {
                        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* REMOVE_FROM_CART */], item._id);
                        var index = this.checked_out.findIndex(function (p) {
                            return p._id === item._id;
                        });
                        this.checked_out.splice(index, 1);
                    }, this);

                    if (this.process_count == this.processed_groups) {
                        this.total_delivery_fee = 0;
                        this.total_order_amt = 0;

                        return processed_checkout;
                    }
                }
            }
        },
        process_orders: function process_orders() {
            var processed = [];
            var product_errors = 0;

            this.checked_out.forEach(function (item) {
                if (item.has_delivery && item.delivery_option == 0) {
                    product_errors++;
                }
            }, this);

            this.sorted_cart.forEach(function (group) {
                var with_delivery = group.products_with_delivery_details_checked.length;
                var without_delivery = group.products_without_delivery_details_checked.length;

                if (with_delivery != 0 && without_delivery == 0) {
                    group.delivery_option = "Product Specific Delivery Set";
                }

                if (group.items_in_checkout) {
                    if (group.delivery_option != 0 && group.delivery_option != undefined) {
                        processed.push(group);
                    } else {
                        product_errors++;
                    }
                }
            }, this);

            if (this.loggedIn) {
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        this.process_checkout(group);
                    }, this);
                }
            } else {
                var processed_to_store_in_forage = [];
                if (processed.length != 0 && product_errors == 0) {
                    this.processed_groups = processed.length;
                    processed.forEach(function (group) {
                        processed_to_store_in_forage.push(this.process_checkout(group));
                    }, this);
                    localforage.setItem('buy_now_order', processed_to_store_in_forage).then(function (value) {}).catch(function (err) {});
                }

                this.$router.push("checkout");
            }
        },
        processPayment: function processPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this3 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_user_id: this.user.user_id
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {

                        if (_this3.request_page != '') {
                            _this3.$router.push(_this3.request_page);
                        } else {
                            _this3.$router.go('/');
                        }
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        }
    },
    created: function created() {
        if (this.$route.path == '/order') {
            this.buy_now_order = true;
        }
        document.title = "Cart" + " | SP";

        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.prepCart();
        }
    }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Cart" + " | SP";
    }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(8);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Cart',
    data: function data() {
        return {
            user: {},
            selected_order: [],
            checkout_orders: {},
            delivery_details: [],
            payment_details: {},
            payment_mode: "",
            request_page: "orders",
            checked_out: [],
            processed_checkout_orders: [],
            sorted_cart: [],
            orders: [],
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            item_delivery_fee: "",
            delivery_fee: "",
            payment_option: "",
            total_order_amt: 0.0,
            total_orders_amount: 0.0,
            total_shipping_fee: 0.0,
            states: {},
            cities: [],
            loggedIn: false,
            new_account: true,
            process_count: 0,
            checkout_processed: false,
            data_error_message: "",
            data_success_message: "",
            is_logged_in_order_mode: 0,
            disable_btn: false,
            loading: true,
            action_loading: false,
            selected_order_shipping_details_state: "",
            selected_order_shipping_details_city: "",
            selected_order_shipping_details_address: ""
        };
    },

    components: {},
    computed: {},
    methods: {
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'login') {
                this.new_account = false;
            }
            if (attr1 == 'new-account') {
                this.new_account = true;
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        removeFromCart: function removeFromCart(payload) {
            this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["j" /* REMOVE_FROM_CART */], payload);
        },
        getStates: function getStates() {
            var _this = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state) {
            var _this2 = this;

            this.activate_processing();
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this2.cities = response.body.data;
                    _this2.deactivate_processing();
                }
            }).catch(function (err) {
                _this2.deactivate_processing();
            });
        },
        login: function login() {
            var _this3 = this;

            this.activate_processing();
            service.loginUser(this, this.user).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);
                    _this3.user = data;
                    if (!_this3.new_account) {
                        _this3.is_logged_in_order_mode = 1;
                        _this3.process_checkout();
                        _this3.deactivate_processing();
                    }
                } else {
                    _this3.data_error_message = "Sorry, these login details are invalid.";
                    _this3.deactivate_processing();
                }
            }).catch(function (err) {
                _this3.deactivate_processing();
            });
        },
        preset: function preset() {
            var _this4 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.loggedIn = true;

                            if (this.$route.params.ckid != null) {
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            } else {
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true;
                            this.loading = false;

                            this.getUserDeliveryDetails();
                        }, _this4);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getCheckoutLocalOrder: function getCheckoutLocalOrder() {
            this.loading = false;

            this.activate_processing();
            var self = this;

            setTimeout(function () {
                localforage.getItem('buy_now_order').then(function (value) {
                    if (value != null) {
                        self.checkout_orders = value;
                    }
                }).catch(function (err) {
                    this.deactivate_processing();
                    this.$router.push("orders");
                });
            }, 500);
        },
        getCheckoutOrders: function getCheckoutOrders() {
            var _this5 = this;

            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this5.setCheckoutOrders(response);
                } else {
                    _this5.$router.push("orders");
                }
            }).catch(function (err) {
                _this5.deactivate_processing();
                _this5.$router.push("orders");
            });
        },
        getCheckoutOrdersByURL: function getCheckoutOrdersByURL() {
            var _this6 = this;

            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(function (response) {
                if (response.body.status == 200) {
                    _this6.setCheckoutOrders(response);
                } else {
                    _this6.deactivate_processing();
                    _this6.$router.push("orders");
                }
            }).catch(function (err) {
                _this6.deactivate_processing();
                _this6.$router.push("orders");
            });
        },
        setCheckoutOrders: function setCheckoutOrders(response) {
            this.checkout_orders = response.body.data;
            this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;

            this.checkout_orders.forEach(function (order) {
                order.display_delivery = false;
                order.cities = {};
            }, this);

            this.checkout_processed = true;
            if (this.new_account) {
                this.login();
            }
            this.deactivate_processing();
        },
        getUserDeliveryDetails: function getUserDeliveryDetails() {
            var _this7 = this;

            service.getUserDeliveryDetails(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.delivery_details = response.body.data;
                }
            }).catch(function (err) {});
        },
        prep_process_checkout: function prep_process_checkout() {
            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if (email_test == false || this.user.user_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.user.user_has_shipping_details = true;
                this.user.user_password = this.user.user_name;
                this.user.new_set_account = true;

                this.process_checkout();
            }
        },
        process_checkout: function process_checkout() {
            this.activate_processing();

            this.checkout_orders.forEach(function (processed_checkout) {
                var _this8 = this;

                this.order_url = this.checkout_orders[0].order_business + new Date().getTime();
                processed_checkout.order_mode = this.is_logged_in_order_mode;
                processed_checkout.order_url = this.order_url;
                if (!this.new_account) {
                    processed_checkout.order_user_id = this.user.user_id;
                } else {
                    processed_checkout.order_user_details = this.user;
                }

                service.checkout(this, processed_checkout).then(function (data) {
                    if (data.body.status == 201) {
                        this.process_count++;
                    }
                    if (this.process_count == this.checkout_orders.length) {
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
                }).catch(function (err) {
                    if (err) {
                        _this8.deactivate_processing();
                    }
                });
            }, this);
        },
        pre_checkout: function pre_checkout() {
            this.preset();
        },
        displayDeliveryOptions: function displayDeliveryOptions(order) {
            this.selected_order = [];
            this.selected_order = order;
            if (this.selected_order.display_delivery) {
                this.selected_order.display_delivery = false;
            } else {
                this.selected_order.display_delivery = true;
            }
        },
        calc_delivery_fee: function calc_delivery_fee(i, option) {
            this.total_order_amt -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee;
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == option.business_delivery_option) {
                    this.checkout_orders[i].order_user_delivery_addresses = [];

                    this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                }
            }, this);
        },
        calc_product_specific_delivery_fee: function calc_product_specific_delivery_fee(i, i2, option) {
            this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee;
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

            this.total_order_amt += option.business_delivery_option_price;
            this.checkout_orders[i].order_total += option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];

            this.delivery_details.forEach(function (detail) {
                if (detail.address_city == option.business_delivery_option_city_id) {
                    this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
                } else {}
            }, this);
        },
        setUserDeliveryAddress: function setUserDeliveryAddress(i, city) {
            this.delivery_details.forEach(function (detail) {
                if (detail.user_delivery_city == city) {
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },
        setPaymentOption: function setPaymentOption(option) {
            this.payment_mode = option;
        },
        processPayment: function processPayment() {
            var process_errors = [];

            this.checkout_orders.forEach(function (order) {
                if (order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined) {
                    process_errors.push("Please enter delivery address for " + order.order_business);
                }

                order.order_items.forEach(function (item) {
                    if (item.order_delivery_city) {
                        if (item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined) {
                            process_errors.push("Please enter delivery address for " + item.product_name);
                        }
                    }
                }, this);
            }, this);
            if (process_errors.length != 0) {
                process_errors.forEach(function (error) {
                    toastr.error(error);
                }, this);
            } else {
                this.processCardPayment(this.payment_details);
            }
        },
        processPaymentMini: function processPaymentMini() {
            var process_errors = [];

            if (this.selected_order_shipping_details_state != '' && this.selected_order_shipping_details_city != '' && this.selected_order_shipping_details_address != '') {
                this.processCardPayment(this.payment_details);
            }
        },
        processCardPayment: function processCardPayment(data) {
            var obj = this;

            var handler = PaystackPop.setup({
                key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                Name: data.payment_payer_name,

                email: "keneinfostream@gmail.com",
                amount: Math.round(data.payment_amount * 100),
                ref: data.payment_ref,
                metadata: {
                    custom_fields: [{
                        display_name: "",
                        variable_name: "",
                        value: data.payment_payer_name
                    }, {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.payment_service
                    }]
                },

                callback: function callback(response) {
                    obj.updatePayment(response.trxref);
                },
                onClose: function onClose() {
                    alert('window closed');
                }
            });
            handler.openIframe();
        },
        updatePayment: function updatePayment(payment_ref) {
            var _this9 = this;

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.payment_details.payment_amount,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service,
                payment_order_delivery_details: { state: this.selected_order_shipping_details_state,
                    city: this.selected_order_shipping_details_city,
                    address: this.selected_order_shipping_details_address }
            };
            var navi = this.$router;

            if (payment_ref != "") {
                service.updatePayment(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("Payment Processed!", "Success!");

                        if (_this9.request_page != '') {
                            _this9.$router.push(_this9.request_page);
                        } else {
                            _this9.$router.go('/');
                        }
                    } else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch(function (err) {
                    if (err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                });
            } else {
                toastr.error('Something went wrong', 'Warning!');
            }
        }
    },
    created: function created() {
        document.title = "Checkout" + " | Gallery";

        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined || localStorage.getItem("sp_token") != null) {
            this.new_account = false;
            this.preset();
        } else {
            this.getCheckoutLocalOrder();
        }
        this.getStates();
    }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Order',
    data: function data() {
        return {
            loading: false,
            user: {},
            cart: this.$store.state.cart,
            img_product_url: service.imageProductsURL,
            loggedIn: false
        };
    },

    components: {
        'cart-widget': __WEBPACK_IMPORTED_MODULE_1__CartWidget_index_vue___default.a
    },
    computed: {},
    methods: {},
    created: function created() {
        document.title = "Order" + " | Gallery";
    }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);


var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Orders',
    data: function data() {
        return {
            user: {},
            orders: {},
            order: {},
            img_product_url: service.imageProductsURL
        };
    },

    components: {},

    methods: {
        setOrder: function setOrder(order) {
            this.order = order;
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.getOrders();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        getOrders: function getOrders() {
            var _this2 = this;

            service.getOrders(this, this.user.user_id).then(function (response) {
                if (response.body.status == 200) {
                    _this2.orders = response.body.data;
                    _this2.orders.set = true;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        document.title = "Orders" + " | SP";

        this.preset();
    }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);




var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Buypoint',
    data: function data() {
        return {
            child_route_view: false,
            loading: false,
            loggedIn: false,
            user: {},
            sellpoint: {},
            set_gallery_banner_image: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        setSellpoint: function setSellpoint() {
            var _this = this;

            this.loading = true;
            service.getAppBusinessByUserName(this, service.business_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this.sellpoint = response.body.data;
                    document.title = _this.sellpoint.business_name + " | SP";

                    if (_this.sellpoint.business_banner_image == _this.default_banner_image || _this.sellpoint.business_banner_image == 'error') {
                        _this.set_gallery_banner_image = service.general_banner_image;
                    } else {
                        _this.set_gallery_banner_image = _this.sellpoint.business_banner_image;
                    }

                    if (_this.sellpoint.business_market_subscription_name == 'Bird Plan') {
                        _this.max_plan_lookbooks = 2;
                        _this.max_plan_lookbook_posts = 5;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Mid Bird Plan') {
                        _this.max_plan_lookbooks = 10;
                        _this.max_plan_lookbook_posts = 50;
                    }
                    if (_this.sellpoint.business_market_subscription_name == 'Max Bird Plan') {
                        _this.max_plan_lookbooks = 50;
                        _this.max_plan_lookbook_posts = 50;
                        _this.can_add_product_lookbook = true;
                    }

                    _this.preset();
                    _this.loading = false;
                } else {
                    _this.business_load_error_msg = "Sorry, this Business Information could not be found.";
                }
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    },

    created: function created() {
        this.setSellpoint();
    }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Home',
    data: function data() {
        return {
            user: {},
            market: {},
            business: {},
            categories: {},
            subscriptions: {},
            business_service_categories: [],
            business_product_categories: [],
            business_category_type: 0,
            plan1: {},
            plan2: {},
            plan3: {},
            selected_plan: {},
            selected_plan_product_service_item: {},
            upgradable_plans: {},
            upgrade_business: "",
            set_upgrade_plans: false,
            place_order: false,

            data_boarding_message: "",
            set_up_with_existing_account: false,
            set_up_with_new_account: false,
            set_up_business: false,
            validate_user_name_error: false,
            validate_user_name_message: "",
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name: "",
            payment_payer_email: "",
            payment_payer_phone: "",
            payment_service: "",
            payment_ref: "",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            action_loading: false,
            disable_btn: false,
            setup_error_message: "",
            newBusinessForm: false,
            product_service_items_select: "",
            set_upgrade_plan_process: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_5__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_6__components_templates_searchbox_vue___default.a,
        'c-settings': __WEBPACK_IMPORTED_MODULE_7__components_tools_settings_vue___default.a
    },
    computed: {},
    methods: {
        setCurrency: function setCurrency(currency) {
            return service.formatCurrency(currency);
        },
        setComponent: function setComponent(attr1, attr2) {
            if (attr1 == 'setup-existing') {
                this.set_up_with_existing_account = true;
            }
            if (attr1 == 'not-setup-existing') {
                this.set_up_with_existing_account = false;
            }
            if (attr1 == 'show-new-business-form') {
                this.newBusinessForm = true;
            }
            if (attr1 == 'display-product_service_items') {
                var x = document.getElementById("productServiceItems");
                if (x.style.display === "none") {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        },
        reset: function reset() {
            this.set_upgrade_plan_process = false;
        },
        toggleDisplayFeatures: function toggleDisplayFeatures() {
            var x = document.getElementById("seeFeatures");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        selectProductServiceItem: function selectProductServiceItem(item) {
            this.selected_plan_product_service_item = item;
        },
        preset: function preset() {
            var _this2 = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            var _this = this;

                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                            service.getUser(this, this.user.user_id).then(function (data) {
                                if (data.body.status == 200) {
                                    _this.user.user_name = data.body.data.user_name;
                                    _this.user.user_email = data.body.data.user_email;
                                    _this.user.user_phone = data.body.data.user_phone;
                                }
                            }).catch(function (err) {});

                            if (this.$route.query.upgrade) {
                                this.prepareUpgradePlans();
                            }
                        }, _this2);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        setPurchase: function setPurchase() {
            var query_plan = this.$route.query.purchase;
            var query_plan_item = this.$route.query.item;
            var found = false;

            this.subscriptions.forEach(function (element) {
                if (element.product_url_name == query_plan) {
                    this.selected_plan = element;
                    if (query_plan_item != 'n') {
                        if (element.product_items[query_plan_item]) {
                            this.selected_plan_product_service_item = element.product_items[query_plan_item];
                        } else {
                            this.selected_plan_product_service_item = element.product_items[0];
                        }
                    } else {
                        this.selected_plan_product_service_item = element.product_items[0];
                    }

                    found = true;

                    this.loading = false;
                }
            }, this);

            if (!found) {
                this.setup_error_message = "Something went wrong with your selection, please pick another plan";
            }

            this.loading = false;
        },
        prepareUpgradePlans: function prepareUpgradePlans() {
            this.loading = true;

            var navi = this.$router;
            service.getBusinessMarketUpgradeDetails(this, this.$route.query.upgrade).then(function (data) {
                this.upgradable_plans = data.body.data;
                this.upgrade_business = this.$route.query.upgrade;

                this.payment_payer_name = data.body.data_user_payment_details["user_name"];
                this.payment_payer_email = data.body.data_user_payment_details["user_email"];
                this.payment_payer_phone = data.body.data_user_payment_details["user_phone"];

                this.set_upgrade_plans = true;
                this.loading = false;
            });
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this3 = this;

            service.getBusinessByUserName(this, service.market_app_name).then(function (response) {
                if (response.body.status == 200) {
                    _this3.market = response.body.data;

                    _this3.getMarketMainProductsAsSubscriptions();

                    _this3.loading = false;
                }
            }).catch(function (err) {
                _this3.loading = true;
            });
        },
        getMarketMainProductsAsSubscriptions: function getMarketMainProductsAsSubscriptions() {
            var _this4 = this;

            service.getBusinessProducts(this, this.market.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this4.subscriptions = response.body.data;
                    _this4.plan1 = _this4.subscriptions[2];
                    _this4.plan2 = _this4.subscriptions[1];
                    _this4.plan3 = _this4.subscriptions[0];
                }

                if (_this4.$route.query.purchase) {
                    _this4.setPurchase();
                }
            }).catch(function (err) {});
        },
        purchase_plan_2: function purchase_plan_2(plan, plan_product_service_item_index) {
            this.loading = true;
            this.$router.push('/purchase/?purchase=' + plan.product_url_name + '&item=' + plan_product_service_item_index);
            this.setPurchase();

            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        purchase_plan: function purchase_plan(plan) {
            this.loading = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
        },
        upgrade_plan: function upgrade_plan(plan) {
            this.loading = true;
            this.set_upgrade_plan_process = true;
            this.selected_plan = plan;
            this.selected_plan_product_service_item = plan.product_items[0];
            this.loading = false;

            var top = document.getElementById("topwrap").offsetTop;
            window.scrollTo(0, top);
        },
        resetOptions: function resetOptions() {
            this.selected_plan = {};
            this.selected_plan_product_service_item = {}, this.total_price = 0;
            this.place_order = false;
        },
        resetMessages: function resetMessages() {
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        proceedUpgradePlan: function proceedUpgradePlan() {
            var found = false;
            this.selected_plan.product_items_upgrade_details.forEach(function (element) {
                if (this.selected_plan_product_service_item.product_item_id == element.subscription_new_product_item_id) {
                    this.selected_plan_product_service_item.product_item_price = element.subscription_new_product_total_amount_to_pay;
                    found = true;
                }
            }, this);

            if (found) {
                this.processPayment();
            }
        },
        proceedNewAccount: function proceedNewAccount() {
            this.resetMessages();
            this.set_up_with_new_account = true;

            if (this.loggedIn) {
                this.processOrder(1);
            } else {
                this.activate_processing();
                var credentials = {
                    user_name: this.payment_payer_name,
                    user_phone: this.payment_payer_phone,
                    user_email: this.payment_payer_email,
                    user_address: '',
                    user_state: '',
                    user_city: '',
                    user_password: this.user.user_password
                };

                var navi = this.$router;

                var data_test = false;
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email_test = re.test(String(this.payment_payer_email).toLowerCase());
                var re_phone = /^\d{4}\d{3}\d{4}$/;
                var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
                if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                    data_test = false;
                    this.data_error_message = "Some errors were found in your form, please fill correctly";
                    this.deactivate_processing();
                } else {
                    data_test = true;
                    this.data_error_message = "";
                }
                if (data_test) {
                    if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                        service.regUser(this, credentials).then(function (data) {
                            if (data.body.status == 201) {
                                this.data_boarding_message = "Registration Successful...";

                                this.user.user_name = this.payment_payer_name;
                                this.user.user_email = this.payment_payer_email;
                                this.user.user_phone = this.payment_payer_phone;

                                this.processOrder(1);
                            } else if (data.body.status == 409) {
                                this.data_error_message = "This User is already registered..";

                                this.deactivate_processing();
                            }
                        });
                    } else {
                        this.data_error_message = "Kindly fill all fields...";

                        this.deactivate_processing();
                    }
                }
            }
        },
        proceedWithAccount: function proceedWithAccount() {
            this.resetMessages();
            this.activate_processing();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            };
            service.checkUserDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    if (data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                        this.deactivate_processing();
                    } else {
                        this.data_boarding_message = "Account verified...";

                        this.user.user_name = data.body.data.user_name;
                        this.user.user_email = data.body.data.user_email;
                        this.user.user_phone = data.body.data.user_phone;

                        this.processOrder(0);
                    }
                } else {
                    this.data_error_message = "Sorry, Account does not exist";
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        processOrder: function processOrder(user_status) {
            var _this5 = this;

            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password
            };
            service.loginUser(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    var data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name);
                    localStorage.setItem("sp_token", data.user_session_key);
                    localStorage.setItem("sp_token_key", data.user_token_key);

                    _this5.preset();
                    _this5.data_boarding_message = "Logging you in...";
                }
            }).catch(function (err) {
                if (err.status == 404) {
                    _this5.data_error_message = "invalid login credentials";

                    _this5.deactivate_processing();
                }
            });

            if (this.loggedIn) {
                var payload = {
                    order_new_user: user_status,
                    order_user_email: this.user.user_email,
                    order_product: this.selected_plan.product_id,
                    order_product_item: this.selected_plan_product_service_item.product_item_id,
                    order_amount_to_pay: this.selected_plan_product_service_item.product_item_price,
                    order_details: "Order Request For Gallery Website: " + this.selected_plan.product_name
                };
                service.makeAppSubscriptionOrder(this, payload).then(function (response) {
                    if (response.body.status == 201) {
                        _this5.data_boarding_message = "Preparing your Order....";

                        _this5.payment_payer_name = _this5.user.user_name;
                        _this5.payment_payer_email = _this5.user.user_email;
                        _this5.payment_payer_phone = _this5.user.user_phone;
                        _this5.payment_ref = response.body.data_payref;

                        if (_this5.selected_plan_product_service_item.product_item_price == 0) {
                            _this5.updatePayment("gw-free-account");
                        } else {
                            _this5.processPayment();
                        }
                    } else {
                        _this5.data_error_message = "Something went wrong";
                        _this5.deactivate_processing();
                    }
                }).catch(function (err) {
                    _this5.data_error_message = "invalid, Something went wrong";
                    _this5.deactivate_processing();
                });
            }
        },
        processPayment: function processPayment() {
            this.data_boarding_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name + "(" + this.selected_plan_product_service_item.product_item_price + ")";
                var obj = this;

                var handler = PaystackPop.setup({
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,

                    email: this.payment_payer_email,
                    amount: Math.round(this.selected_plan_product_service_item.product_item_price * 100),
                    ref: this.payment_ref,
                    metadata: {
                        custom_fields: [{
                            display_name: "GalleryWebsite Order",
                            variable_name: "",
                            value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                        }, {
                            display_name: "Service",
                            variable_name: "service_type",
                            value: this.selected_plan.product_name
                        }]
                    },

                    callback: function callback(response) {
                        obj.updatePayment(response.trxref);
                    },
                    onClose: function onClose() {
                        obj.data_boarding_message = "You Stopped Payment..";
                        obj.deactivate_processing();
                        alert('window closed');
                    }
                });
                handler.openIframe();
            }
        },
        processPaymentRave: function processPaymentRave() {
            this.data_boarding_message = "Preparing Payment Information";

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctlyaaa" + this.payment_payer_name + "se" + this.payment_payer_phone + "33" + this.payment_payer_email;
                this.data_boarding_message = "";
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                var self = this;

                var x = getpaidSetup({
                    PBFPubKey: "FLWPUBK-8b636e40e721ae65285c678950808ef5-X",
                    customer_email: self.payment_payer_email,
                    amount: Math.round(self.selected_plan_product_service_item.product_item_price),
                    customer_phone: self.payment_payer_phone,
                    currency: "NGN",
                    payment_method: "both",
                    txref: self.payment_ref,
                    meta: [{
                        metaname: "GalleryWebsiteOrders",
                        metavalue: self.payment_payer_name,
                        metaservice: self.payment_payer_name + " - " + self.payment_payer_phone + " - ORDER - " + self.selected_plan.product_name
                    }],
                    onclose: function onclose() {
                        self.data_boarding_message = "Payment was Stopped.";
                    },
                    callback: function callback(response) {
                        var txref = response.tx.txRef;
                        var tx_amount = response.tx.amount;
                        if (response.tx.chargeResponseCode == "00" || response.tx.chargeResponseCode == "0") {
                            self.processing = true;

                            self.updatePayment(txref);
                        } else {}

                        x.close();
                    }
                });
            }
        },
        updatePayment: function updatePayment(payment_ref) {
            this.notifyPayments(15, payment_ref, 0);
            var navi = this.$router;

            this.payment_successful = true;
            if (this.selected_plan_product_service_item.product_item_price != 0) {
                this.payment_successful_message = "Payment Successful...";
            }

            if (this.set_up_with_existing_account) {
                this.setUpExistingAccount();
            }
            if (this.set_up_with_new_account) {
                this.setUpNewAccount();
            }

            if (this.set_upgrade_plan_process) {
                this.upgradePlan();
            }
        },
        notifyPayments: function notifyPayments(status, payment_ref, business_ordered) {
            var _this6 = this;

            var payload = {
                order_status: status,
                order_payment_ref: payment_ref,
                order_business: business_ordered
            };
            service.updateAppSubscriptionOrder(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this6.data_boarding_message = "Payment Updated....";
                }
            }).catch(function (err) {});
        },
        setUpExistingAccountB4Flow01: function setUpExistingAccountB4Flow01() {
            var _this8 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                var _this7 = this;

                if (data.body.status == 201 || data.body.status == 200) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    };
                    service.loginUser(this, credentials).then(function (response) {
                        if (response.body.status == 200) {
                            var _data = response.body.data;
                            localStorage.setItem("sp_user", _data.user_name);
                            localStorage.setItem("sp_token", _data.user_session_key);
                            localStorage.setItem("sp_token_key", _data.user_token_key);

                            navi.push('/' + _this7.user.user_business);
                        }
                    }).catch(function (err) {
                        if (err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!');

                            _this7.deactivate_processing();
                        }
                    });
                }
            }).catch(function (err) {
                if (err) {
                    _this8.deactivate_processing();
                }
            });
        },
        setUpExistingAccount: function setUpExistingAccount() {
            var _this9 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };

            var navi = this.$router;
            service.addExistingBusiness(this, credentials).then(function (data) {
                if (data.body.status == 201 || data.body.status == 200) {
                    this.data_boarding_message = "Sellpoint Setup Successful...";

                    this.notifyPayments(16, this.payment_ref, this.user.user_business);
                    navi.push('/' + this.user.user_business);
                }
            }).catch(function (err) {
                if (err) {
                    _this9.deactivate_processing();
                }
            });
        },
        setUpNewAccountB4Flow02: function setUpNewAccountB4Flow02() {
            this.activate_processing();
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address: '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            };

            var navi = this.$router;

            var data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            var phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if (email_test == false || this.payment_payer_name == " " || phone_test == false) {
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            } else {
                data_test = true;
                this.data_error_message = "";
            }
            if (data_test) {
                if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function (data) {
                        var _this10 = this;

                        if (data.body.status == 201) {
                            this.data_boarding_message = "Registration Successful...";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: this.user.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data2 = response.body.data;
                                    localStorage.setItem("sp_user", _data2.user_name);
                                    localStorage.setItem("sp_token", _data2.user_session_key);
                                    localStorage.setItem("sp_token_key", _data2.user_token_key);

                                    _this10.preset();

                                    var self = _this10;
                                    setTimeout(function () {
                                        self.set_up_business = true;

                                        self.data_boarding_message = " ";
                                        self.setComponent('show-new-business-form', '');
                                        self.deactivate_processing();

                                        var top = document.getElementById("banner").offsetTop;
                                        window.scrollTo(0, top);
                                    }, 3000);
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this10.data_error_message = "invalid login credentials..";

                                    _this10.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_error_message = "This User is already registered..";

                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields...";

                    this.deactivate_processing();
                }
            }
        },
        setUpNewAccount: function setUpNewAccount() {
            var self = this;
            setTimeout(function () {
                self.set_up_business = true;

                self.data_boarding_message = " ";
                self.setComponent('show-new-business-form', '');
                self.deactivate_processing();

                var top = document.getElementById("banner").offsetTop;
                window.scrollTo(0, top);
            }, 3000);
        },
        validateUserName: function validateUserName() {
            var _this11 = this;

            service.validateBusinessUserName(this, this.business).then(function (response) {
                if (response.body.status != 200) {
                    _this11.validate_user_name_error = true;
                    _this11.validate_user_name_message = "This username already exist";
                    _this11.deactivate_processing();
                }
            }).catch(function (err) {
                _this11.validate_user_name_error = true;
                _this11.validate_user_name_message = "This username already exist";
                _this11.deactivate_processing();
            });
        },
        setUpNewAccountBusiness: function setUpNewAccountBusiness() {
            var _this12 = this;

            this.resetMessages();

            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: 3,
                business_subscription: this.selected_plan_product_service_item.product_item_id
            };
            var navi = this.$router;
            if (this.validate_user_name_error) {
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            } else {
                if (credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function (data) {
                        if (data.body.status == 201) {
                            this.business.business_user_name = data.body.data_business_username;
                            this.data_boarding_message = "Sellpoint Creation Successful.";

                            this.notifyPayments(16, this.payment_ref, this.business.business_user_name);
                            navi.push('/' + this.business.business_user_name);
                        } else {
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        if (err) {
                            _this12.data_error_message = "Something went wrong";

                            _this12.deactivate_processing();
                        }
                    });
                } else {
                    this.data_error_message = "Kindly fill all fields";

                    this.deactivate_processing();
                }
            }
        },
        upgradePlan: function upgradePlan() {
            var _this13 = this;

            this.activate_processing();
            var credentials = {
                business_user_name: this.upgrade_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan_product_service_item.product_item_id,
                business_subscription_amount_paid: this.selected_plan_product_service_item.product_item_price
            };

            var navi = this.$router;
            service.upgradeBusinessMarketSubscription(this, credentials).then(function (data) {
                if (data.body.status == 200) {
                    navi.push('/' + this.upgrade_business);
                }
            }).catch(function (err) {
                if (err) {
                    _this13.data_error_message = "Something went wrong";
                    _this13.deactivate_processing();
                }
            });
        },
        getBusinessCategories: function getBusinessCategories() {
            service.getCategories(this).then(function (data) {
                this.categories = data.body.data;

                this.categories.forEach(function (element) {
                    if (element.category_type == 1) {
                        this.business_product_categories.push(element);
                    }
                    if (element.category_type == 2) {
                        this.business_service_categories.push(element);
                    }
                }, this);
            });
        }
    },
    mounted: function mounted() {
        var top = document.getElementById("topwrap").offsetTop;
        window.scrollTo(0, top);
    },

    created: function created() {
        if (this.$route.query.upgrade) {
            this.set_upgrade_plans = true;
        }
        this.preset();
        this.getSellpointMarket();
        this.getBusinessCategories();
    }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);



var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Register',
    data: function data() {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_purchase: false,
            terms: true,
            disable_btn: false,
            loading: false,
            action_loading: false,
            data_proccessing_message: ""
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a
    },
    methods: {
        reset: function reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        getStates: function getStates() {
            service.getStates(this).then(function (data) {
                this.states = data.body;
            });
        },
        getCities: function getCities(state) {
            service.getCities(this, state).then(function (data) {
                this.cities = data.body;
            });
        },
        reg: function reg() {
            this.disable_btn = true;
            this.user.agree = true;
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            };

            var navi = this.$router;
            if (credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null && credentials.user_email != null && credentials.user_password != null) {
                if (this.terms) {
                    this.activate_processing();
                    service.regUser(this, credentials).then(function (data) {
                        var _this = this;

                        if (data.body.status == 201) {
                            this.data_proccessing_message = "Account Created";

                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            };
                            service.loginUser(this, credentials).then(function (response) {
                                if (response.body.status == 200) {
                                    var _data = response.body.data;
                                    localStorage.setItem("sp_user", _data.user_name);
                                    localStorage.setItem("sp_token", _data.user_session_key);
                                    localStorage.setItem("sp_token_key", _data.user_token_key);
                                    if (_this.user_purchase) {
                                        navi.push("/getstarted");
                                    } else {
                                        navi.push('/account');
                                    }
                                }
                            }).catch(function (err) {
                                if (err.status == 404) {
                                    _this.data_proccessing_message = "invalid login credentials";
                                    _this.deactivate_processing();
                                }
                            });
                        } else if (data.body.status == 409) {
                            this.data_proccessing_message = "You already have a Sellpoint Account";

                            this.deactivate_processing();
                        }
                    });
                } else {
                    this.data_proccessing_message = 'Please agree to Terms';
                    this.disable_btn = false;
                }
            } else {
                this.data_proccessing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        }
    },
    created: function created() {}
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue__);








var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',
    data: function data() {
        return {
            user: {},
            products: {},
            product: {},
            search_data: "",
            loggedIn: false
        };
    },


    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'right-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_templates_rightsidebar_vue___default.a,
        'left-sidebar': __WEBPACK_IMPORTED_MODULE_4__components_templates_leftsidebar_vue___default.a,
        'search-box': __WEBPACK_IMPORTED_MODULE_5__components_templates_searchbox_vue___default.a,
        'active-products': __WEBPACK_IMPORTED_MODULE_6__components_widgets_activeproducts_vue___default.a
    },
    methods: {
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        getSearchProducts: function getSearchProducts() {
            var _this2 = this;

            service.searchProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this2.products = response.body.data;
                    _this2.search_data = _this2.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getBusinessSearchProducts: function getBusinessSearchProducts() {
            var _this3 = this;

            service.searchBusinessProducts(this, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this3.products = response.body.data;
                    _this3.search_data = _this3.$route.query.k;
                }
            }).catch(function (err) {});
        },
        getCategorySearchProducts: function getCategorySearchProducts() {
            var _this4 = this;

            service.searchCategoryProducts(this, this.$route.query.s, this.$route.query.k).then(function (response) {
                if (response.body.status == 200) {
                    _this4.products = response.body.data;
                    _this4.search_data = response.body.data_search;
                }
            }).catch(function (err) {});
        }
    },
    created: function created() {
        this.preset();
        if (this.$route.query.search == "business") {
            this.getBusinessSearchProducts();
        } else if (this.$route.query.search == "product") {
            this.getSearchProducts();
        } else if (this.$route.query.s) {
            this.getCategorySearchProducts();
        }
    }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue__);









var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Product',
    props: ['productItem'],
    data: function data() {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            categories: {},
            main_category: {},
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sub_categories: [],
            product: {},
            details: {},
            reviews: {},
            information: {},
            states: {},
            cities: {},
            other_products: {},
            delivery_option: {},
            discount_coupon: {},
            product_item_group: {},
            product_item: {},
            sellpoint_categories: {},
            seller_mode: false,
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option: false,
            edit_other_delivery_option: false,
            edit_city: false,
            editProductPanel: false,
            addProductItemPanel: false,
            editProductItemPanel: false,
            removeItemPanel: false,
            editProductItemGroupPanel: false,
            removeItemGroupPanel: false,
            removeProductPanel: false,
            product_details_descr: true,
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            setProductDeliveryInformation: false,
            setDiscount: false,
            editDiscount: false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl: "",
            is_product_in_cart: false,
            loading: false,
            copied: false,
            descr_active: 'active',
            user_type: "buyer",
            new_added: false,
            product_display_image: {},
            action_loading: false,
            product_is_ready_to_cart: false,
            product_item_selected: [],
            product_item_group_selected: [],
            data_cart_message: "",
            data_cart_group_message: "",
            data_cart_item_message: "",
            product_set_shipping_fee_status: 12,
            set_shipping_fee_status_track: false,
            check_order_quantity: ""

        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_1__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_2__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_3__components_product_ProductForm_vue___default.a,
        "product-item-form": __WEBPACK_IMPORTED_MODULE_4__components_product_ProductItemForm_vue___default.a,
        'add-to-cart-button': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductCartActions_vue___default.a,
        'product-cta-button': __WEBPACK_IMPORTED_MODULE_6__components_product_ProductCTAActions_vue___default.a
    },
    computed: {},

    methods: {
        redir: function redir(rlink) {
            location.replace("/" + rlink);
        },
        copyLink: function copyLink() {
            this.$clipboard(this.siteUrl);
            this.copied = true;
        },
        mobileSideNavToggle: function mobileSideNavToggle(action) {
            if (action == "open") {
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if (action == "close") {
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },
        activate_processing: function activate_processing() {
            this.disable_btn = true;
            this.action_loading = true;
        },
        deactivate_processing: function deactivate_processing() {
            this.disable_btn = false;
            this.action_loading = false;
        },
        checkOrderQuantity: function checkOrderQuantity(qty) {
            if (this.product_item_selected.product_item_price > 0 && this.product_item.product_item_order_quantity != 0) {
                if (Number(qty) > this.product_item.product_item_quantity) {
                    this.check_order_quantity = "The quantity you entered is above Item Quantity";
                    this.product_is_ready_to_cart = false;
                    this.data_cart_message = "The quantity you entered is above Item Quantity";
                } else {
                    this.check_order_quantity = "";
                    this.product_is_ready_to_cart = true;
                    this.data_cart_message = "";
                }
            } else {
                this.check_order_quantity = "";
            }
        },
        trackevent: function trackevent(e) {
            if (e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined) {
                this.category_type_2 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined) {
                this.category_type_1 = true;
                this.category_type_3 = true;
            } else if (e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined) {
                this.category_type_1 = true;
                this.category_type_2 = true;
            } else {
                this.category_type_1 = false;
                this.category_type_2 = false;
                this.category_type_3 = true;
            }
        },
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'edit-product') {
                this.editProductPanel = true;
            }
            if (attr1 == 'remove-product') {
                this.removeProductPanel = true;
            }
            if (attr1 == 'add-product-item') {
                this.addProductItemPanel = true;
            }
            if (attr1 == 'edit-product-item') {
                this.editProductItemPanel = true;
            }
            if (attr1 == 'set-edit-product-item') {
                this.product_item = attr2;
                this.editProductItemPanel = true;
            }
            if (attr1 == 'remove-product-item') {
                this.product_item = attr2;
                this.removeItemPanel = true;
            }
            if (attr1 == 'edit-product-item_group') {
                this.product_item_group = attr2;
                this.editProductItemGroupPanel = true;
            }
            if (attr1 == 'remove-product-item_group') {
                this.product_item_group = attr2;
                this.removeItemGroupPanel = true;
            }
            if (attr1 == 'set-product-item-group-image') {
                this.product_item_group.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                }
                document.getElementById(attr2 + "PRTG").style.border = "1px solid #0000CC";
            }
            if (attr1 == 'edit-product-detail') {
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if (attr1 == 'edit-product-delivery') {
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if (attr1 == 'add-delivery-option') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-product-delivery-option') {
                this.delivery_option.edit_set = false;
                this.setProductDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'set-product-item') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item = attr2;
                this.product_item_selected = attr2;

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                if (attr2.product_item_size != "Nill" && attr2.product_item_size != "") {
                    document.getElementById(attr2.product_item_id + "PRT").style = "border:1px solid #0000CC;";
                }

                this.data_cart_item_message = '';
                this.data_cart_message = '';
                this.prep_set_product_is_ready_to_cart();
            }
            if (attr1 == 'set-product-item-group') {
                this.check_order_quantity = "";
                this.data_cart_message = '';

                this.product_item_group = attr2;
                this.product_item_group_selected = attr2;

                this.product_display_image.product_image = attr2.product_item_group_image;

                this.product_is_ready_to_cart = false;
                this.product_item_selected = [];

                var itms = document.getElementsByClassName('product-item');
                for (var i = 0; i < itms.length; i++) {
                    itms[i].style = "border:none;";
                }

                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style.border = "none";
                }

                document.getElementById(attr2.product_item_group_id + "PRTGR").style.border = "1px solid #0000CC";

                this.data_cart_group_message = '';

                if (attr2.product_items[0].product_item_size == "Nill" || attr2.product_items[0].product_item_size == "") {
                    this.setComponent('set-product-item', attr2.product_items[0]);
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                }
            }
            if (attr1 == 'set-product-display-image') {
                this.product_display_image = attr2;
            }
            if (attr1 == 'set-descr') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));

                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if (attr1 == 'set-reviews') {
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails', ''));
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if (attr1 == 'set-information') {
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if (attr1 == 'edit-discount') {
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if (attr1 == 'reset-edit') {
                this.addProductItemPanel = false;
                this.editProductPanel = false;
                this.editProductItemPanel = false;
                this.removeItemPanel = false;
                this.editProductItemGroupPanel = false;
                this.removeItemGroupPanel = false;
                this.removeProductPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false;
            }
            var self = this;

            setTimeout(function () {
                self.action_loading = false;
            }, 2000);
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },
        preset: function preset() {
            var _this = this;

            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.product.product_business_id;

                            this.is_editing();

                            this.loggedIn = true;
                        }, _this);
                    } else {}
                }).catch(function (err) {
                    if (err) {}
                });
            } else {}
        },
        is_editing: function is_editing() {
            var _this2 = this;

            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            };
            service.can_edit(this, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this2.seller_mode = true;
                    _this2.edit_mode = true;
                    _this2.can_edit = true;
                } else {
                    _this2.edit_mode = false;
                    _this2.seller_mode = false;
                }
            }).catch(function (err) {
                if (err) {}
            });
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        set_data_messages: function set_data_messages(data, action) {
            if (this.product.product_service == 'P') {
                if (action == 'set') {
                    if (data == 'product-item') {}
                }
                if (action == 'unset') {}
            } else {}
        },
        prep_set_product_is_ready_to_cart: function prep_set_product_is_ready_to_cart() {
            if (this.product_item_selected.length != 0) {
                this.product_is_ready_to_cart = true;
            } else {
                this.data_cart_message = "make a selection before you proceed";
                if (this.product_item_group_selected.length != 0) {
                    if (this.product.product_service == 'P') {
                        this.data_cart_item_message = "please select a Size";
                    } else {
                        this.data_cart_item_message = "please select a Service item";
                    }
                } else {
                    if (this.product.product_service == 'P') {
                        this.data_cart_group_message = "please select Colour";
                    } else {
                        this.data_cart_group_message = "please select a Service Package";
                    }
                }
            }
        },
        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        set_product_is_ready_to_cart: function set_product_is_ready_to_cart() {
            if (this.product.product_set_groups <= 1 && this.product.product_set_items <= 1) {
                this.product_item_selected = this.product_item;
                this.product_item_group_selected = this.product_item_group;
                this.product_is_ready_to_cart = true;
            }
        },
        setProduct: function setProduct() {
            var _this5 = this;

            this.loading = true;
            service.getProductSearch(this, this.$route.params.id1).then(function (response) {
                if (response.body.status == 200) {
                    _this5.product = response.body.data;

                    document.title = _this5.product.product_name + " | " + _this5.product.product_business_name + " | SP";

                    _this5.product_display_image = _this5.product.product_images[0];
                    _this5.product_item = _this5.product.product_items[0];
                    if (_this5.product.product_item_groups.length != 0) {
                        _this5.product_item_group = _this5.product.product_item_groups[0];
                    } else {
                        _this5.product_item_group = [];
                    }

                    _this5.product_set_shipping_fee_status = _this5.product.product_set_shipping_fee_status;

                    _this5.set_product_is_ready_to_cart();

                    _this5.siteUrl = service.siteUrl + "?p=" + _this5.product.product_url_name + "&p1=" + _this5.product.product_business_ownername + "&p2=" + _this5.product.product_url_name + "&p3=" + encodeURI(_this5.product.product_name) + "&p4=" + encodeURI(_this5.product.product_description) + "&p5=" + _this5.product_item.product_item_image + " ";

                    _this5.product.product_share_url = "http://sellpoints.com.ng/" + _this5.product.product_business_ownername + "/" + _this5.product.product_url_name;

                    _this5.preset();

                    _this5.setOtherProducts(_this5.product.product_business_id);

                    _this5.getCategories(_this5.product.product_business_category_id);

                    _this5.getSellpointCategories();

                    _this5.check_in_cart();
                    _this5.loading = false;
                }
            }).catch(function (err) {});
        },
        getCategories: function getCategories(category) {
            var _this6 = this;

            service.getMainCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this6.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSubCategories: function getSubCategories(category) {
            if (category != undefined) {
                this.sub_categories = category.sub_categories;
            } else {
                this.sub_categories = [];
            }
        },
        check_in_cart: function check_in_cart() {
            this.cart.forEach(function (element) {
                if (element.product_item_id == this.product_item.product_item_id) {
                    this.is_product_in_cart = true;
                }
            }, this);
        },
        setOtherProducts: function setOtherProducts(sellpoint_id) {
            var _this7 = this;

            service.getBusinessProducts(this, sellpoint_id).then(function (response) {
                if (response.body.status == 200) {
                    _this7.other_products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getProductImages: function getProductImages() {
            var _this8 = this;

            service.getProductImages(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this8.product.product_images = response.body.data;
                    _this8.product_display_image = _this8.product.product_images[0];
                }
            }).catch(function (err) {});
        },
        deleteProductImage: function deleteProductImage(image) {
            service.deleteProductImage(this, image).then(function (data) {
                if (data.body.status == 200) {
                    this.getProductImages();
                }
            }).catch(function (err) {});
        },
        editProduct: function editProduct() {
            var _this9 = this;

            this.activate_processing();

            var set_product_category = this.product.product_category_id;
            if (this.product.product_sub_category != undefined || this.product.product_listed_category != undefined) {
                set_product_category = 0;
            } else {
                if (this.product.product_category != undefined) {
                    set_product_category = this.product.product_category;
                } else {
                    set_product_category = this.product.product_category_id;
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,

                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",


                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id };

            var navi = this.$router;
            if (credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this9.editProductPanel = false;
                        _this9.product = response.body.data;
                        navi.push("/" + _this9.product.product_business_ownername + "/" + _this9.product.product_url_name);
                    } else {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                }).catch(function (err) {
                    if (err) {
                        _this9.editProductPanel = false;
                        _this9.deactivate_processing();
                    }
                });
            } else {
                this.disable_btn = false;
            }
        },
        editProductItem: function editProductItem() {
            var _this10 = this;

            this.activate_processing();
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                product_item_price: this.product_item.product_item_price,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 1
            };

            var navi = this.$router;
            if (credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        _this10.product_item = response.body.data;
                        _this10.deactivate_processing();
                        _this10.editProductItemPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this10.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        editProductItemGroup: function editProductItemGroup() {
            var _this11 = this;

            this.activate_processing();
            var product_item_group_is_color_image = 'IMG';
            if (this.product_item_group.product_item_group_color == undefined) {
                product_item_group_is_color_image = 'IMG';
            } else {
                product_item_group_is_color_image = 'COL';
            }

            if (this.product_item_group.product_item_group_color_new != undefined) {
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new;
                this.product_item_group.product_item_group_image = 0;
            } else {
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill";
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0
            };

            var navi = this.$router;
            if (credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(function (response) {
                    if (response.body.status == 200) {

                        _this11.product.product_item_groups = response.body.data;

                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    } else {
                        _this11.deactivate_processing();
                        _this11.editProductItemGroupPanel = false;
                    }
                }).catch(function (err) {
                    if (err) {
                        _this11.deactivate_processing();
                    }
                });
            } else {
                this.deactivate_processing();
            }
        },
        removeProduct: function removeProduct() {
            var _this12 = this;

            this.disable_btn = true;
            var payload = {
                product_id: this.product.product_id
            };
            var navi = this.$router;
            service.removeProduct(this, this.product.product_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    _this12.redir(_this12.$route.params.id1);

                    _this12.removeProductPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this12.disable_btn = false;
                    _this12.redir(_this12.$route.params.id1);
                }
            });
        },
        removeProductItem: function removeProductItem() {
            var _this13 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            };
            var navi = this.$router;
            service.removeProductItem(this, this.product_item.product_item_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this13.redir(_this13.$route.params.id);
                    }
                    _this13.product.product_item_groups = response.body.data;

                    _this13.deactivate_processing();
                    _this13.removeItemPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this13.deactivate_processing();
                }
            });
        },
        removeProductItemGroup: function removeProductItemGroup() {
            var _this14 = this;

            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            };
            var navi = this.$router;
            service.removeProductItemGroup(this, this.product_item_group.product_item_group_id, payload).then(function (response) {
                if (response.body.status == 200) {
                    if (response.body.no_product) {
                        _this14.redir(_this14.$route.params.id);
                    }
                    _this14.product.product_item_groups = response.body.data;
                    _this14.deactivate_processing();
                    _this14.removeItemGroupPanel = false;
                }
            }).catch(function (err) {
                if (err) {
                    _this14.deactivate_processing();
                }
            });
        },
        addProductDetail: function addProductDetail() {
            var _this15 = this;

            this.activate_processing();
            var payload = {
                product_detail: this.details.new_product_detail || "nill",
                product_id: this.product.product_id
            };
            service.addProductDetail(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_details = data.body.data;
                    this.details = {};
                    this.deactivate_processing();
                } else {
                    this.deactivate_processing();
                }
            }).catch(function (err) {
                _this15.details = {};
                _this15.deactivate_processing();
            });
        },
        editProductDetail: function editProductDetail() {
            var _this16 = this;

            this.details.product_id = this.product.product_id;
            service.editProductDetail(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this16.service = {};
            });
        },
        deleteProductDetail: function deleteProductDetail(details) {
            var _this17 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this17.service = {};
            });
        },
        setProductDelivery: function setProductDelivery() {
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            };
            service.setProductDelivery(this, 1, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.details = {};

                    this.details.edit_product_delivery = false;
                }
            }).catch(function (err) {});
        },
        setProductShippingFeeStatus: function setProductShippingFeeStatus() {
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status
            };
            service.setProductShippingFeeStatus(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                }
            }).catch(function (err) {});
        },
        addProductReview: function addProductReview() {
            var _this18 = this;

            var payload = {
                product_reviewed_by: this.user.user_id || 1,
                product_review: this.reviews.review || "nill",
                product_id: this.product.product_id
            };
            service.addProductReview(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    this.product.product_reviews = data.body.data;
                    this.reviews = {};
                }
            }).catch(function (err) {
                _this18.reviews = {};
            });
        },
        getProductInformation: function getProductInformation() {
            var _this19 = this;

            service.getProductInformation(this, this.product.product_id).then(function (response) {
                if (response.body.status == 200) {
                    _this19.product.product_information = response.body.data;
                }
            }).catch(function (err) {});
        },
        addProductInformation: function addProductInformation() {
            var _this20 = this;

            var payload = {
                product_info_detail: this.information.product_info_detail || "nill",
                product_info_type: "text",
                product_id: this.product.product_id
            };
            if (payload.product_information != "nill") {
                service.addProductInformation(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        this.product.product_information = data.body.data;
                        this.information = {};
                    }
                }).catch(function (err) {
                    _this20.details = {};
                });
            }
        },
        editProductInformation: function editProductInformation() {
            var _this21 = this;

            this.details.product_id = this.product.product_id;
            service.editProductInformation(this, 1, this.details).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this21.service = {};
            });
        },
        deleteProductInformation: function deleteProductInformation(details) {
            var _this22 = this;

            var payload = {
                product_detail_id: details.product_detail_id
            };
            service.deleteProductDetail(this, details.product_detail_id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_details = data.body.data;
                }
            }).catch(function (err) {
                _this22.service = {};
            });
        },
        setProductDeliveryOption: function setProductDeliveryOption() {
            var _this23 = this;

            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };
            if (payload.business_product_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_product_delivery_option != 0) {
                    service.setProductDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200 || data.body.status == 201) {
                            this.product.product_business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.setProductDeliveryInformation = false;

                            this.deactivate_processing();
                        } else {
                            this.deactivate_processing();
                        }
                    }).catch(function (err) {
                        _this23.delivery_option.edit_set = false;
                        _this23.setProductDeliveryInformation = false;
                        _this23.deactivate_processing();
                    });
                } else {
                    this.deactivate_processing();
                }
            }
        },
        deleteDeliveryFee: function deleteDeliveryFee(id) {
            var _this24 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this24.delivery_option = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this25 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_delivery_product: this.product.product_id,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this25.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this26 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            this.product.product_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this26.delivery_option.edit_set = false;
                        _this26.editDeliveryInformation = false;
                    });
                } else {}
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this27 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_product: this.product.product_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    this.product.product_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this27.delivery_option = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var payload = {
                business_id: this.sellpoint.business_id,
                product_item_id: this.product_item.product_item_id,
                is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'D',
                coupon_business_category: 0,
                coupon_percentage: this.discount_coupon.discount_percentage,
                coupon_start_date: this.discount_coupon.discount_start_date,
                coupon_end_date: this.discount_coupon.discount_end_date
            };
            service.setDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("New Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setDiscount = false;
                }
            }).catch(function (err) {});
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    this.editDiscount = false;
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    payload.discount_status_id = 6;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type, data_id) {
            var _this28 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);


                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "products") {
                            _this28.getProductImages();
                            if (_this28.editProductItemGroupPanel) {
                                _this28.product_item_group.product_item_group_image = data.body.data_id;
                            }
                        }

                        if (type == "product_information") {
                            _this28.getProductInformation();
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        getSellpointCategories: function getSellpointCategories() {
            var _this29 = this;

            service.getBusinessByUserName(this, this.product.product_business_ownername).then(function (response) {
                if (response.body.status == 200) {
                    var sellpoint = response.body.data;
                    service.getBusinessCategories(_this29, sellpoint.business_id).then(function (response) {
                        if (response.body.status == 200) {
                            _this29.sellpoint_categories = response.body.data;
                        }
                    }).catch(function (err) {});
                }
            }).catch(function (err) {});
        },
        handleScrollFix: function handleScrollFix(event) {
            var x = document.getElementById("menuHeader");

            var isMobile = false;
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                isMobile = true;
            }
            if (isMobile) {
                if (document.documentElement.scrollTop >= 300) {
                    x.style.display = "block";
                } else {
                    x.style.display = "none";
                }
            }
        }
    },
    mounted: function mounted() {},
    created: function created() {
        if (this.$route.query.setup == "yes") {
            this.new_added = true;
        }
        this.setProduct();
        this.getStates();

        window.addEventListener('scroll', this.handleScrollFix);
    },
    destroyed: function destroyed() {
        window.removeEventListener('scroll', this.handleScrollFix);
    }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue__);






var service = new __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_1__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SellpointTemplate',
    data: function data() {
        return {
            loading: false,
            page_set: false,
            user: {},
            sellpoint: {},
            categories: {},
            voucher: {},
            voucher_name: "",
            voucher_amount: 0,
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_2__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_3__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_4__components_product_ProductForm_vue___default.a
    },
    methods: {}
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_validation__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue__);







var service = new __WEBPACK_IMPORTED_MODULE_1__services_service__["a" /* default */]();
var validator = new __WEBPACK_IMPORTED_MODULE_2__services_validation__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sellpoint',
    data: function data() {
        return {
            loading: false,
            page_set: false,
            user: {},
            sellpoint: {},
            categories: {},
            voucher: {},
            voucher_name: "",
            voucher_amount: 0,
            orders: {},
            notifications: {},
            messages: {},
            details: {},
            cities: {},
            states: {},
            contact_form: {},
            category: {},
            service: {},
            delivery_option: {},
            discount_coupon: {},
            products: {},
            product: {},
            market: {},
            product_item: {},
            can_edit: false,
            edit_mode: false,
            disable_btn: false,
            setPanel: false,
            listView: true,
            marketView: false,
            addProductPanel: false,
            spProductsPanel: false,
            spMarketPanel: false,
            spProfilePanel: false,
            spContactPanel: false,
            spDeliveryPanel: false,
            spMessagesPanel: false,
            spOrdersPanel: false,
            addDeliveryInformation: false,
            editDeliveryInformation: false,
            spSettingsPanel: false,
            setDiscount: false,
            viewDiscounts: true,
            createSellpointPanel: false,
            viewAllProductsBanner: false,
            showSidebarMobile: false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            bg_main: '',
            other_delivery_option: false,
            edit_other_delivery_option: false,
            set_bank_details: false,
            edit_city: false,
            ipaddress: "",
            notifications_unread: 0
        };
    },

    components: {
        'component-header': __WEBPACK_IMPORTED_MODULE_3__MainHeader_index_vue___default.a,
        'component-footer': __WEBPACK_IMPORTED_MODULE_4__MainFooter_index_vue___default.a,
        'product-form': __WEBPACK_IMPORTED_MODULE_5__components_product_ProductForm_vue___default.a
    },
    methods: {
        setMenuComponent: function setMenuComponent() {},
        setComponent: function setComponent(attr1, attr2) {
            this.setPanel = true;
            if (attr1 == 'create-sellpoint') {
                this.createSellpointPanel = true;
                this.addProductPanel = false;
            }
            if (attr1 == 'sellpoint-panel') {
                this.addProductPanel = false;
            }
            if (attr1 == 'spProductsPanel') {
                this.spMarketPanel = false;
                this.spProductsPanel = true;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;

                if (attr2 == 'market') {
                    this.spMarketPanel = true;
                }
            }
            if (attr1 == 'spProfilePanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = true;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spContactPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = true;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = false;
            }
            if (attr1 == 'spDeliveryPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spDeliveryPanel = true;
            }
            if (attr1 == 'spMessagesPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spOrdersPanel = false;
                this.spMessagesPanel = true;
            }
            if (attr1 == 'spOrdersPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spSettingsPanel = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = true;
            }
            if (attr1 == 'spSettingsPanel') {
                this.spProductsPanel = false;
                this.spProfilePanel = false;
                this.spContactPanel = false;
                this.showSidebarMobile = false;
                this.spDeliveryPanel = false;
                this.spMessagesPanel = false;
                this.spOrdersPanel = false;
                this.spSettingsPanel = true;
            }
            if (attr1 == 'add-product') {
                this.addProductPanel = true;
                this.createSellpointPanel = false;
            }
            if (attr1 == 'edit-category') {
                this.category.edit = false;
                this.category = attr2;
                this.category.edit = true;
            }
            if (attr1 == 'reset-edit-category') {
                this.category.edit = false;
                this.category = {};
            }

            if (attr1 == 'view-all-products') {
                this.viewAllProductsBanner = false;
                this.getSellpointProducts();
            }
            if (attr1 == 'list-view') {
                this.marketView = false;
                this.listView = true;
            }
            if (attr1 == 'market-view') {
                this.marketView = true;
                this.listView = false;
            }
            if (attr1 == 'add-delivery-information') {
                this.addDeliveryInformation = true;
            }
            if (attr1 == 'set-discount') {
                this.setDiscount = true;
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
            }
            if (attr1 == 'view-discounts') {
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.viewDiscounts = true;
            }
        },
        setComponentActions: function setComponentActions(attr1, attr2) {
            if (attr1 == 'edit-service') {
                this.service.edit_set = false;
                this.service = attr2;
                this.service.edit_set = true;
            }
            if (attr1 == 'edit-delivery-option') {
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;

                this.getCities(this.delivery_option.business_delivery_state, 'edit');
            }
            if (attr1 == 'edit-tagline') {
                this.details = {};
                this.details.tagline_edit = true;
            }
            if (attr1 == 'edit-profile') {
                this.details = {};
                this.details.profile_edit = true;
            }
            if (attr1 == 'edit-contact-info') {
                this.details = {};
                this.details.contact_info_edit = true;
            }
            if (attr1 == 'edit-delivery-information') {
                this.details = {};
                this.details.delivery_edit = true;
            }
            if (attr1 == 'edit-bank-details') {
                this.details = {};
                this.details.bank_details_edit = true;
                this.set_bank_details = true;
            }
            if (attr1 == 'reset-delivery-information') {
                this.addDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = false;
            }
            if (attr1 == 'edit-discount-coupon') {
                this.viewDiscounts = false;
                this.discount_coupon.edit = false;
                this.setDiscount = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }
            if (attr1 == 'reset-discount-coupon') {
                this.viewDiscounts = true;
                this.discount_coupon.edit = false;
                this.discount_coupon = {};
                this.setDiscount = false;
            }
            if (attr1 == 'reset-edit') {
                this.details = {};
            }
        },


        prep: function prep() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");

            return parts[0];
        },

        toggleSidebar: function toggleSidebar() {
            if (this.showSidebarMobile == true) {
                this.showSidebarMobile = false;
            } else {
                this.showSidebarMobile = true;
            }
        },
        preset: function preset() {
            var _this = this;

            this.loading = true;
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            };
            if (credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(function (response) {
                    if (response.body.status == 200) {
                        var data = response.body.data;
                        data.forEach(function (element) {
                            this.user.user_id = element.user_id;

                            this.setSellpoint();
                        }, _this);
                    } else {
                        _this.$router.push('login');
                    }
                }).catch(function (err) {
                    if (err) {
                        console.log(err);
                        _this.$router.push('login');
                    }
                });
            } else {
                this.$router.push('login');
            }
        },
        is_editing: function is_editing() {
            var _this2 = this;

            if (this.user.user_id != "") {
                var payload = {
                    validate_user: this.user.user_id,
                    validate_business: this.sellpoint.business_id
                };
                service.can_edit(this, payload).then(function (response) {
                    if (response.body.status == 200) {
                        _this2.edit_mode = true;
                        _this2.can_edit = true;
                    } else {
                        _this2.edit_mode = false;
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        switchMode: function switchMode() {
            if (this.edit_mode == false) {
                this.is_editing();
            } else {
                this.edit_mode = false;
                this.can_edit = true;
            }
        },
        getIPAddress: function getIPAddress() {},
        getStates: function getStates() {
            var _this3 = this;

            service.getStates(this).then(function (response) {
                if (response.body.status == 200) {
                    _this3.states = response.body.data;
                }
            }).catch(function (err) {});
        },
        getCities: function getCities(state, option) {
            var _this4 = this;

            if (option == "edit") {
                this.edit_city = true;
            } else {
                this.edit_city = false;
            }
            service.getCities(this, state).then(function (response) {
                if (response.body.status == 200) {
                    _this4.cities = response.body.data;
                }
            }).catch(function (err) {});
        },
        setOtherOptions: function setOtherOptions(v, o) {
            if (v != undefined) {
                if (v == "other") {
                    this.other_delivery_option = true;
                    if (o == "edit") {
                        this.edit_other_delivery_option = true;
                    }
                }
                if (v == "all") {
                    this.delivery_option.business_delivery_other_option = "nill";
                    if (o == "edit") {
                        this.edit_other_delivery_option = false;
                    }
                    this.other_delivery_option = false;
                }
            }
        },
        viewCategoriesProducts: function viewCategoriesProducts() {},
        setSellpoint: function setSellpoint() {
            var _this5 = this;

            this.loading = true;
            var sp = "";
            if (this.$route.params.id != undefined) {
                sp = this.$route.params.id;
            } else {
                sp = this.prep();
            }
            service.getBusinessByUserName(this, sp).then(function (response) {
                if (response.body.status == 200) {
                    _this5.sellpoint = response.body.data;
                    localStorage.setItem("sp_#_sellpoint", _this5.sellpoint.business_username);
                    _this5.is_editing();
                    _this5.getCategories(_this5.sellpoint.business_category_id);
                    _this5.getSellpointProducts();
                    if (_this5.sellpoint.business_market_category_id != 1) {
                        _this5.getSellpointMarket();
                        _this5.getSellpointMarketProducts();
                    }
                    _this5.spProductsPanel = true;
                    _this5.loading = false;

                    var promises = [];
                    for (var i = 0; i < 5; ++i) {
                        if (i == 1) {
                            promises.push(_this5.getSellpointNotifications());
                        }

                        if (i == 2) {
                            promises.push(_this5.getSellpointMessages());
                        }

                        if (i == 3) {
                            promises.push(_this5.getSellpointOrders());
                        }
                    }

                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {}).catch(function (e) {});
                } else {
                    location.reload(true);
                }
            }).catch(function (err) {
                location.replace("/");

                _this5.loading = true;
            });
        },
        getSellpointNotifications: function getSellpointNotifications() {
            var _this6 = this;

            service.getBusinessNotifications(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this6.notifications = response.body.data;
                    _this6.notifications_unread = response.body.data_1;
                }
            }).catch(function (err) {});
        },
        getSellpointMessages: function getSellpointMessages() {
            var _this7 = this;

            service.getBusinessMessages(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this7.messages = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointOrders: function getSellpointOrders() {
            var _this8 = this;

            service.getBusinessOrders(this, this.sellpoint.business_username).then(function (response) {
                if (response.body.status == 200) {
                    _this8.orders = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointProducts: function getSellpointProducts() {
            var _this9 = this;

            service.getBusinessProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this9.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarketProducts: function getSellpointMarketProducts() {
            var _this10 = this;

            service.getMarketProducts(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this10.products = response.body.data;
                }
            }).catch(function (err) {});
        },
        getSellpointMarket: function getSellpointMarket() {
            var _this11 = this;

            service.getBusinessMarket(this, this.sellpoint.business_id).then(function (response) {
                if (response.body.status == 200) {
                    _this11.market = response.body.data;
                }
            }).catch(function (err) {
                _this11.getIPAddress();
                _this11.market = {};

                var err_payload = {
                    err_int_id: _this11.user.user_id || 0,
                    err_mod_id: 5,
                    err_route: _this11.$route.path,
                    err_func: "getSellpointMarket",
                    err_api_cl: "GET::" + err.url,
                    err_message: err.bodyText,
                    err_ln_rang: '363-377',
                    err_poss_cos: "returned could be 404 || 400",
                    err_ip_address: _this11.ipaddress
                };
            });
        },
        getCategories: function getCategories(category) {
            var _this12 = this;

            service.getBusinessSubCategories(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this12.categories = response.body.data;
                }
            }).catch(function (err) {});
        },
        addCategory: function addCategory() {
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                business_id: this.sellpoint.business_id
            };
            service.addCategory(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Category Added Successfull", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {});
        },
        editCategory: function editCategory() {
            var _this13 = this;

            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Category edited", 'Success!');
                    this.sellpoint.business_categories = data.body.data;
                    this.category = {};
                }
            }).catch(function (err) {
                _this13.category = {};
            });
        },
        getCategoryProducts: function getCategoryProducts(category) {
            var _this14 = this;

            service.getCategoryProducts(this, category).then(function (response) {
                if (response.body.status == 200) {
                    _this14.products = response.body.data;
                    _this14.viewAllProductsBanner = true;
                    _this14.showSidebarMobile = false;
                }
            }).catch(function (err) {});
        },
        onFileChange: function onFileChange(e, type) {
            var _this15 = this;

            var files = e.target.files || e.dataTransfer.files;
            if (files.length) {
                var formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id);
                formData.append('data_type', type);
                service.uploadBusinessDataPhoto(this, formData).then(function (data) {
                    if (data.body.status == 200) {
                        if (type == "business_banner_image") {
                            _this15.sellpoint.business_banner_image = data.body.data;
                        }
                        if (type == "business_brand_image") {
                            _this15.sellpoint.business_brand_image = data.body.data;
                        }
                    }
                }).catch(function (err) {
                    if (err) {}
                });
            }
        },
        addService: function addService() {
            var _this16 = this;

            var payload = {
                business_service: this.service.service_name || "Service Details",
                business_id: this.sellpoint.business_id
            };
            service.addService(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Sellpoint Service Added Successfully", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service = {};
                }
            }).catch(function (err) {
                _this16.service = {};
            });
        },
        editService: function editService() {
            var _this17 = this;

            this.service.business_id = this.sellpoint.business_id;
            service.editService(this, this.service).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Service edited", 'Success!');
                    this.sellpoint.business_services = data.body.data;
                    this.service.edit_set = false;
                    this.service = {};
                }
            }).catch(function (err) {
                _this17.service = {};
            });
        },
        addDeliveryOption: function addDeliveryOption() {
            var _this18 = this;

            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            };
            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.addDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 201) {
                            toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option = {};
                            this.addDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this18.delivery_option = {};
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        editDeliveryOption: function editDeliveryOption() {
            var _this19 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                business_delivery_state: this.delivery_option.business_delivery_state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            };

            if (payload.business_delivery_option_price == 0) {
                toastr.warning("Delivery Charge not Added", 'Warning!');
            } else {
                if (payload.business_delivery_option != 0 || payload.business_delivery_other_option != "nill") {
                    service.editDeliveryOption(this, payload).then(function (data) {
                        if (data.body.status == 200) {
                            toastr.success("Sellpoint Delivery Details edited", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.delivery_option.edit_set = false;
                            this.editDeliveryInformation = false;
                        }
                    }).catch(function (err) {
                        _this19.delivery_option.edit_set = false;
                        _this19.editDeliveryInformation = false;
                    });
                } else {
                    toastr.warning("Select a delivery option", 'Warning!');
                }
            }
        },
        deleteDeliveryOption: function deleteDeliveryOption(id) {
            var _this20 = this;

            var payload = {
                business_id: this.sellpoint.business_id
            };
            service.deleteDeliveryOption(this, id, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint Delivery Details deleted", 'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                }
            }).catch(function (err) {
                _this20.delivery_option = {};
            });
        },
        editBusinessDetails: function editBusinessDetails(attr) {
            var _this21 = this;

            if (attr == "tagline") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_tagline: this.sellpoint.business_tagline
                };
            }
            if (attr == "profile") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_profile: this.sellpoint.business_profile
                };
            }
            if (attr == "contact_info") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                };
            }
            if (attr == "delivery") {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                };
            }
            service.editBusinessDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Sellpoint edited", 'Success!');
                }
                this.details = {};
            }).catch(function (err) {
                _this21.details = {};
            });
        },
        sendBusinessContactForm: function sendBusinessContactForm() {
            var _this22 = this;

            var payload = {
                business_id: this.sellpoint.business_id,
                contact_form_name: this.contact_form.name || "nill",
                contact_form_email: this.contact_form.email || "nill",
                contact_form_message: this.contact_form.message || "nill"
            };
            service.sendBusinessContactForm(this, payload).then(function (data) {
                if (data.body.status == 201) {
                    toastr.success("Message Sent", 'Ok!');
                }
                this.contact_form = {};
            }).catch(function (err) {
                _this22.contact_form = {};
            });
        },
        setDiscountsAndCoupons: function setDiscountsAndCoupons() {
            var entry_arr = [["Discount or Coupon", this.discount_coupon.is_discount_coupon, "str"], ["Coupon Percentage", this.discount_coupon.discount_percentage, "num"], ["Discount Category", this.discount_coupon.discount_category, "num"], ["Start Date", this.discount_coupon.discount_start_date, "date"], ["End Date", this.discount_coupon.discount_end_date, "date"]];
            var validated_arr = validator.validate_array(entry_arr, "Please fill in ");
            if (validated_arr.length == 0) {
                var payload = {
                    business_id: this.sellpoint.business_id,
                    product_item_id: 0,
                    is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C',
                    coupon_business_category: this.discount_coupon.discount_category,
                    coupon_percentage: this.discount_coupon.discount_percentage,
                    coupon_start_date: this.discount_coupon.discount_start_date,
                    coupon_end_date: this.discount_coupon.discount_end_date
                };
                service.setDiscountsAndCoupons(this, payload).then(function (data) {
                    if (data.body.status == 201) {
                        toastr.success("New Discount Set", 'Update!');
                        this.sellpoint.business_discounts_coupons = data.body.data;
                        this.setComponentActions('reset-discount-coupon', '');
                    }
                }).catch(function (err) {});
            } else {
                validated_arr.forEach(function (error) {
                    toastr.error(error);
                }, this);
            }
        },
        editDiscountsAndCoupons: function editDiscountsAndCoupons() {
            this.discount_coupon.business_id = this.sellpoint.business_id;
            service.editDiscountsAndCoupons(this, this.discount_coupon).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        deactivateDiscountsAndCoupons: function deactivateDiscountsAndCoupons(payload) {
            payload.business_id = this.sellpoint.business_id;
            service.deactivateDiscountsAndCoupons(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Discount Set", 'Update!');
                    this.sellpoint.business_discounts_coupons = data.body.data;
                    this.setComponentActions('reset-discount-coupon', '');
                }
            }).catch(function (err) {});
        },
        setBankDetails: function setBankDetails() {
            var payload = {
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id: this.sellpoint.business_id
            };

            service.setBusinessBankDetails(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Bank Details Set", 'Update!');
                }
                this.set_bank_details = false;
            }).catch(function (err) {});
        },
        switchProcessingFee: function switchProcessingFee(to) {
            var payload = {
                business_process_fee_pay: to,
                business_id: this.sellpoint.business_id
            };

            service.switchProcessingFeePay(this, payload).then(function (data) {
                if (data.body.status == 200) {
                    toastr.success("Processing Fee Set", 'Reset!');
                    this.sellpoint.business_processing_fee_pay_status = to;
                }
            }).catch(function (err) {});
        },
        readNotifications: function readNotifications() {
            this.notifications_unread = 0;
            var payload = {
                notification_type: "business",
                notification_module: "notifications",
                notification_business: this.sellpoint.business_username
            };
            service.readNotifications(this, payload).then(function (data) {}).catch(function (err) {});
        },
        createVoucher: function createVoucher() {}
    },
    mounted: function mounted() {
        this.loading = true;
        if (localStorage.getItem("sp_token") != undefined) {
            this.preset();
        } else {
            this.setSellpoint();
        }
    },
    created: function created() {
        this.loading = true;

        this.getStates();
        this.getIPAddress();
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Account__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/account',
  name: 'Account',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Account___default.a

});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Businesses__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Businesses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Businesses__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/businesses',
    name: 'Businesses',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Businesses___default.a
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Buypoint__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/buypoint',
  name: 'Buypoint',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Buypoint___default.a

});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_GetStarted__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_GetStarted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_GetStarted__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/getstarted/',
  name: 'GetStarted',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_GetStarted___default.a
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home___default.a
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order__);





/* harmony default export */ __webpack_exports__["a"] = ({
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Orderpoint_Template___default.a,
    children: [{
        path: '/cart',
        name: 'Cart',
        component: __WEBPACK_IMPORTED_MODULE_1__pages_Orderpoint_Cart___default.a
    }, {
        path: '/checkout',
        name: 'Checkout',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/checkout/:ckid',
        name: 'CheckoutOrderURL',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Orderpoint_Checkout___default.a
    }, {
        path: '/orders',
        name: 'Orders',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_Orderpoint_Orders___default.a
    }, {
        path: '/order',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Orderpoint_Order___default.a
    }]
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Purchase__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/purchase/',
  name: 'Purchase',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Purchase___default.a
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Register__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/register',
  name: 'register',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Register___default.a
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Search__);


/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Search___default.a
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate__);





/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Sellpoint_SellpointTemplate___default.a,
  children: [{
    path: '',
    name: 'Sellpoint',
    component: __WEBPACK_IMPORTED_MODULE_1__pages_Sellpoint_Sellpoint___default.a
  }, {
    path: ':id1',
    name: 'Product',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Sellpoint_Product___default.a
  }]
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(8);





var sellpointActions = {
  allSellpoints: function allSellpoints(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* ALL_SELLPOINTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/businesses', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], response.data);
    });
  }
};

var productActions = {
  allProducts: function allProducts(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ALL_PRODUCTS */]);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* API_BASE */] + '/products', {
      headers: {
        'Api-Token': this.apiToken
      }
    }).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], response.data);
    });
  }
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartGetters; });

var sellpointGetters = {
  allSellpoints: function allSellpoints(state, getters) {
    return state.sellpoints;
  },

  sellpointById: function sellpointById(state, getters) {
    return function (id) {
      if (getters.allSellpoints.length > 0) {
        return getters.allSellpoints.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.sellpoint;
      }
    };
  }
};

var productGetters = {
  allProducts: function allProducts(state, getters) {
    return state.products;
  },

  productById: function productById(state, getters) {
    return function (id) {
      if (getters.allProducts.length > 0) {
        return getters.allProducts.filter(function (p) {
          return p._id === id;
        })[0];
      } else {
        return state.product;
      }
    };
  }
};

var cartGetters = {
  cartProducts: function cartProducts(state) {
    return state.added.map(function (_ref) {
      var id = _ref.id,
          quantity = _ref.quantity;

      var product_item = state.all.find(function (p) {
        return p._id === id;
      });

      return {
        name: product.name,
        price: product.price,
        quantity: quantity
      };
    });
  }
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sellpointMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cartMutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _sellpointMutations, _productMutations, _cartMutations;



var sellpointMutations = (_sellpointMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ALL_SELLPOINTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ALL_SELLPOINTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.sellpoints = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sellpointMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _sellpointMutations);

var productMutations = (_productMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ALL_PRODUCTS */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* ALL_PRODUCTS_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.products = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* PRODUCT_BY_ID */], function (state) {
  state.showLoader = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* PRODUCT_BY_ID_SUCCESS */], function (state, payload) {
  state.showLoader = false;
  state.product = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_productMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* ERROR_MSG */], function (state, payload) {}), _productMutations);

var cartMutations = (_cartMutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* VIEW_CART */], function (state) {
  return state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* ADD_TO_CART */], function (state, payload) {
  state.cart.push(payload);
  state.cart = state.cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_cartMutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* REMOVE_FROM_CART */], function (state, payload) {
  var index = state.cart.findIndex(function (p) {
    return p._id === payload;
  });
  state.cart.splice(index, 1);
}), _cartMutations);

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(192)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(194)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(181)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  "data-v-0dfa79e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(184)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  "data-v-14c82643",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  "data-v-59306fc2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-68ff5440",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(183)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  "data-v-13e458f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  "data-v-7b8296ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  "data-v-f73015e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(191)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  "data-v-38792e34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(190)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  "data-v-37538476",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(199)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  "data-v-81637c5a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(180)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  "data-v-067a3c68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  "data-v-b7ac8cd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(186)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(236),
  /* scopeId */
  "data-v-18b6c0b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(179)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(227),
  /* scopeId */
  "data-v-065f1bfd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(198)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  "data-v-7d42d542",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(189)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  "data-v-27b121f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(182)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  "data-v-13758c24",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('search-box'), _vm._v(" "), (!_vm.search_data != '') ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.search_data != '') ? _c('h4', {
    staticClass: "grey"
  }, [_vm._v("Products found in " + _vm._s(_vm.search_data))]) : _vm._e(), _vm._v(" "), (_vm.products.length == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("no matching products")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  }))]), _vm._v(" "), _c('active-products')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticStyle: {
      "color": "#ff5566",
      "padding": "1em"
    }
  }, [_vm._v("Top activity products")]), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4 col-sm-4 col-xs-6"
    }, [((product.product_items.length != 0)) ? _c('div', {
      staticStyle: {
        "min-height": "23em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + product.product_business_username + '/' + product.product_url_name
      }
    }, _vm._l((product.product_items), function(product_item, index2) {
      return _c('div', {
        key: index2,
        staticClass: "friend-card",
        staticStyle: {
          "min-height": "22em",
          "max-height": "22em",
          "border-bottom-color": "rgb(182, 176, 176)"
        }
      }, [(index2 == 0) ? _c('div', [_c('div', {
        staticStyle: {
          "height": "10em"
        }
      }, [_c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": product_item.product_item_image,
          "alt": "photo"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "card-info"
      }, [_c('div', {
        staticClass: "friend-info"
      }, [_c('a', {
        staticClass: "pull-right text-green",
        staticStyle: {
          "font-size": "12px"
        },
        attrs: {
          "href": "#"
        }
      }, [_vm._v("@" + _vm._s(product.product_business_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
        staticStyle: {
          "height": "3em"
        }
      }, [_c('a', {
        staticClass: "profile-link",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(product.product_name))])]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))]), _vm._v(" "), _vm._m(0, true)])])]) : _vm._e()])
    }))]) : _vm._e()])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Like"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "14px"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn text-red",
    attrs: {
      "title": "Add to Cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart",
    staticStyle: {
      "font-size": "14px"
    }
  })])])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky",
    staticStyle: {
      "background": "none"
    }
  }, [_c('div', {
    staticClass: "container clearfix nav-head",
    staticStyle: {
      "background": "none"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "vtd vtd-right-side-box"
  }, [_c('a', {
    staticClass: "header-btn vtd-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "height": "3em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "container banner-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('lookbooks')
      }
    }
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('li', {
    staticClass: "gw-mobile"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('feeds')
      }
    }
  }, [_vm._v("Feeds")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile')
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel')
      }
    }
  }, [_vm._v("Manage Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    attrs: {
      "href": "/getstarted"
    }
  }, [_vm._v("Get a Mall Space")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Settings")])])])])])]), _vm._v(" "), (!_vm.setPanel) ? _c('section', {
    staticClass: "account-inner",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row account-inner-row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "info-card",
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "info-card-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr",
    staticStyle: {
      "color": "inherit",
      "margin-top": "-1em"
    }
  }, [_vm._v("@" + _vm._s(_vm.sellpoint.business_username))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSwitchBusiness()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "show-business-list",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "businessList"
    }
  }, _vm._l((_vm.sellpoints), function(sellpoint) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.switchBusiness(sellpoint)
        }
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-stats-top"
  }, [_c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery_posts))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Posts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block stats-block-center"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_views))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Views")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Category")]), _vm._v(_vm._s(_vm.sellpoint.business_category))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Tagline:")]), _vm._v(_vm._s(_vm.sellpoint.business_tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Brief:")]), _vm._v(_vm._s(_vm.sellpoint.business_profile))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")]), _vm._v(" "), _c('button', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "right",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel', '')
      }
    }
  }, [_vm._v("Manage Gallery")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "lookbooks"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    })])])])
  }), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "feeds"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [(_vm.sellpoint.business_notifications && (_vm.sellpoint.business_notifications.length != 0)) ? _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[0].notification_message))])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[1].notification_message))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])]) : _c('div', [_vm._m(12)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Address")]), _vm._v(_vm._s(_vm.sellpoint.business_address))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Email:")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "subscription"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body",
    staticStyle: {
      "padding": "0 1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Current Plan: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0055",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_gallery.business_market_subscription_name))])]), _vm._v(" "), (!_vm.can_add_more_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("To add more lookbooks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account")])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.can_add_product_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Do you want to sell some Products or Services of your Gallery? ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Unlock this Package. "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account to Unlock")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.can_add_more_lookbook && _vm.can_add_product_lookbook) ? _c('div', [_vm._m(15)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(16), _vm._v(" "), (_vm.setSettings) ? _c('div', {
    staticClass: "container"
  }, [(_vm.setting_details.editProfile) ? _c('div', [_c('h6', [_vm._v("Edit Profile Details")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Name\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Phone Number\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.editProfileDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _c('div', {
    staticClass: "container info-card-body"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-settings-inner', 'editProfile')
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.syncset(_vm.sellpoint.business_username)
      }
    }
  }, [_vm._v("Manage Account on Sellpoint")])])])])])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), (_vm.managePanel) ? _c('section', {
    staticClass: "account-inner-set-panel",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    },
    attrs: {
      "id": "manage"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(19)]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-top": "1em",
      "padding": "1em"
    }
  }, [_c('h5', [_vm._v("Manage Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "container banner-menu manage-account-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-businesses', '')
      }
    }
  }, [_vm._v("Business Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-lookbooks', '')
      }
    }
  }, [_vm._v("Lookbooks Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-products', '')
      }
    }
  }, [_vm._v("Products")])])])])]), _vm._v(" "), (_vm.manageBusinesses) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-row-controls"
  }, [_c('div', [(_vm.manageBusinessDetails) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-component-details', '')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])]), _vm._v(" "), (!_vm.manageBusinessDetails) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row cards-grids"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 0)
      }
    }
  }, [_vm._m(20)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 1)
      }
    }
  }, [_vm._m(21)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 2)
      }
    }
  }, [_vm._m(22)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 3)
      }
    }
  }, [_vm._m(23)])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.businessComponents[0]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ecb989"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[1]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_vm._m(24), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "70%"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("edit")]), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("You have not set any delivery information\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                    " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                    "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div')])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[2]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]), _vm._v(" "), _c('span', [(_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Coupon")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.manageProducts) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Products (" + _vm._s(_vm.sellpoint.business_total_products) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewProducts) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, gndex) {
    return _c('div', {
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('products', product, '')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(product.product_images.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(product.product_images[0].product_image)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": product.product_images[0].product_image
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(product.product_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.component_view.viewProduct) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.is_viewing_lookbook) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('switch-to-viewing-loobook', '', '')
      }
    }
  }, [_vm._v("<< Back to Lookbook")])]) : _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('products', '', '')
      }
    }
  }, [_vm._v("<< Back ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Category: " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price))]), _vm._v(" "), _c('p', [_vm._v("Discounted Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]) : _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Quantity: " + _vm._s(_vm.product.product_items[0].product_item_quantity))])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Price\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Weight\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Quantity\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px",
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Items and Variations")]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "10px",
      "text-transform": "capitalize"
    }
  }, [_c('b', [_vm._v("Name of Group: ")]), _vm._v(_vm._s(_vm.product.product_groups_set_name) + "\r\n                    "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change")])]), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "row col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "0.6"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                            "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductSettings', '', '')
        }
      }
    }, [_vm._v(" Change")])]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group",
        attrs: {
          "cla": ""
        }
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                    "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                          "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-md-12"
    }, [(_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-3"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Price\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Quantity\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not set any product item variation")])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [(_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                               Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                                   Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                           ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex,
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_vm._v("Add to " + _vm._s(pg.product_item_group_name) + " ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {}, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                                       "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Media")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, _vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.4",
      "font-size": "14px"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Price\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "background": "#e7e8e9"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("DISCOUNTS AND COUPONS")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn admin-btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Delivery Location Fees")]), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                            ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.manageLookbooks) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Lookbooks (" + _vm._s(_vm.sellpoint.business_total_gallery) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewLookbooks) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "drag-and-drop",
      rawName: "v-drag-and-drop:options",
      value: (_vm.drag_options),
      expression: "drag_options",
      arg: "options"
    }]
  }, [_c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('li', {
      key: gallery.gallery_posts_group_id,
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', gallery, 'viewLookbook')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }))]), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', '', 'viewLookbooks')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('p', [_vm._v("Type: Posts Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('p', [_vm._v("Type: Product Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "white-space": "pre-line"
    }
  }, [_vm._v("Description: " + _vm._s(_vm.lookbook.gallery_posts_group_text))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Edit Lookbook ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Delete ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), (_vm.lookbook_details.editLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Lookbook Name\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_name),
      expression: "lookbook.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Details ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_text),
      expression: "lookbook.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "height": "250px"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbook
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Lookbook?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbook
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(28)]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbookPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Post ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('viewProductLookbookPost', 'productlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Product Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Product Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.lookbook_post.gallery_post_details))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.lookbook_details.editLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Caption\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_caption),
      expression: "lookbook_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Details\r\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_details),
      expression: "lookbook_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbookPost
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbookPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Post Images")]), _vm._v(" "), ((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "row img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.lookbook_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "border": "#eeccee 1px solid"
      }
    }, [_c('div', {
      staticClass: "img-row"
    }, [(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-column",
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "z-index": "1"
      }
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('a', {
      staticClass: "col-xs-2 btn pull-right",
      staticStyle: {
        "z-index": "9",
        "margin-top": "4em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeLookbook($event, 'gallery_media', _vm.lookbook_post.gallery_post_id)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Other Posts in \r\n                  "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]), _vm._v(" Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-6 col-xs-6"
    }, [(post.gallery_post_id != _vm.lookbook_post.gallery_post_id) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(29)]) : _vm._e()], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.managePosts) ? _c('div', {
    staticClass: "container"
  }) : _vm._e(), _vm._v(" "), (_vm.manageOrders) ? _c('div', {
    staticClass: "container"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-box clearfix"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": "Gallery"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "menu-toggler",
    attrs: {
      "data-target": "#main-nav-bar"
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase info-profile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('h5', [_vm._v("Lookbooks")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("If you have any issues setting up your Gallery Lookbooks, please do not hesitate to contact support")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Upgrade or Customize your account to unlock more features")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("CONTACT DETAILS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SUBSCRIPTION STATUS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Your Subscription is Active ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Would you love to Customize your Gallery? "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/customize"
    }
  }, [_vm._v("Talk to your Web Gallery Assistant")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SETTINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Logout from Account")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "5em",
      "margin-bottom": "5em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("View and Update Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Delivery and Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Coupons and Vouchers")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Connect to your Business Payment Receival Portal")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('article', {
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "menu-banner"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_category))])]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "menu"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "80px",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_profile))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dishes v2"
  }, _vm._l((_vm.products), function(product, prdex) {
    return _c('li', [_c('div', [(product.product_images[0]) ? _c('div', [_c('a', {
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": product.product_images[0].product_image,
        "alt": "featured"
      }
    })])]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "cat-con"
    }, [_c('span', [_c('i', [_vm._v(_vm._s(product.product_category_name))])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "height": "40px",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), (product.product_items && (product.product_items.length > 0)) ? _c('p', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "img-nav",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "menu-nav"
    }
  }, [_c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Fast Food and Entrees"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Steak and Chicken"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Pizzas and Calzones"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Sandwiches and Subs"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Drinks and Beverages"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Sweets and Desserts"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])
}]}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('main', [_c('aside', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#2d4c8b",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/facebook.png",
      "x": "23",
      "y": "10",
      "width": "9px",
      "height": "18px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Like Us!")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#34dfe6",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/twitter.png",
      "x": "17",
      "y": "12",
      "width": "23px",
      "height": "16px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Follow Us!")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#e842ab",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/flickr.png",
      "x": "17",
      "y": "16",
      "width": "18px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Flickr")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#ff9000",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/rss.png",
      "x": "18",
      "y": "12",
      "width": "16px",
      "height": "16px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Rss Feed")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#33517f",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/vimeo.png",
      "x": "18",
      "y": "13",
      "width": "17px",
      "height": "15px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Vimeo")])])])]), _vm._v(" "), _c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('ul', {
    staticClass: "main-slider"
  }, [_c('li', {
    staticClass: "first"
  }, [_c('h1', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("One Stop")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Make a tour")])]), _vm._v(" "), _c('li', {
    staticClass: "second"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("Touch Down")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Go to shop")])]), _vm._v(" "), _c('li', {
    staticClass: "third"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("Full Events")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("make a schedule")])])]), _vm._v(" "), _c('div', {
    staticClass: "pager-container"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "2"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "our-dishes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Stanel World")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('article', {
    attrs: {
      "id": "dishes-left"
    }
  }, [_c('article', [_c('div', [_c('h5', [_vm._v("Farmers Market")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "farmmarket"
    }
  }, [_vm._v("visit")])])])]), _vm._v(" "), _c('article', [_c('div', [_c('h5', [_vm._v("P & J Supermarket ")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "pjsupermarket"
    }
  }, [_vm._v("visit")])])])])]), _vm._v(" "), _c('article', {
    attrs: {
      "id": "dishes-right"
    }
  }, [_c('article', [_c('div', [_c('h5', [_vm._v("Chicken Republic Drive Thru")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site3.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "chickenrepublic"
    }
  }, [_vm._v("visit")])])])]), _vm._v(" "), _c('article', [_c('div', [_c('h5', [_vm._v("Essense Spa")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site4.jpg",
      "alt": "sandwiches"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "essencespa"
    }
  }, [_vm._v("visit")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "shows"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "35%",
      "padding-top": "-3em"
    },
    attrs: {
      "src": "/static/assets/images/december.png",
      "alt": "show-model"
    }
  }), _vm._v(" "), _c('article', [_c('h3', [_vm._v("Live"), _c('span', [_vm._v("Shows")])]), _vm._v(" "), _c('p', [_vm._v("Every Saturday")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea  derma commodo consequat. ")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    attrs: {
      "href": "events.html",
      "target": "_blank"
    }
  }, [_vm._v("Check all the events")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "popular-dishes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Popular Dishes")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', {
    staticClass: "dishes"
  }, [_c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Mozzarella Cheeseburger")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$15.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat2.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Barbeque Steak Strips")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$35.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Golden Onion Rings")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$21.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Meltdown Nachos")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$17.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat4.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Wild Veggies Sandwich")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$15.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat3.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Garlic Capresse Pizza")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$43.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat2.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Charcoal Chicken Wings")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$18.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat4.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("The Volcano Sandwich")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$12.00")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "specials"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/ivy.png",
      "alt": "ivy"
    }
  }), _vm._v(" "), _c('figure', {
    attrs: {
      "id": "board"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/specials-title.png",
      "alt": "specials-title"
    }
  }), _vm._v(" "), _c('article', [_c('article', [_c('h5', [_vm._v("Mozzarella Cheeseburger")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$15.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Dark Side Bacon Pizza")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$32.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Meltdown Nachos")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$17.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Golden Onion Rings")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$21.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "about"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("About Mozzarella")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('article', [_c('h5', [_vm._v("How did we Become "), _c('span', [_vm._v("this Succesful")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incidid ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. tem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Vintage Arcade Machines")]), _vm._v(" "), _c('li', [_vm._v("The Best 80's and 90's Music")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("5 New Pool Tables")]), _vm._v(" "), _c('li', [_vm._v("Happy Hour until 2AM")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/about-img.jpg",
      "alt": "about-img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quality-badge.png",
      "alt": "quality-badge"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "video"
    }
  }, [_c('p', [_vm._v("Find yourself at the")]), _vm._v(" "), _c('h2', [_vm._v("Last "), _c('span', [_vm._v("Friday")]), _vm._v(" Party")]), _vm._v(" "), _c('div', {
    staticClass: "radial-progress"
  }, [_c('div', {
    staticClass: "r-circle"
  }, [_c('div', {
    staticClass: "mask full"
  }, [_c('div', {
    staticClass: "fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask half"
  }, [_c('div', {
    staticClass: "fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "fill fix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inset"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/play-button.png",
      "alt": "play-button"
    }
  })])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "http://player.vimeo.com/video/109558222"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "reviews"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Customer Reviews")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-1.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-empty-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("James D.")]), _vm._v(" "), _c('p', [_vm._v("25 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-2.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Laura B.")]), _vm._v(" "), _c('p', [_vm._v("27 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-3.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Sarah H.")]), _vm._v(" "), _c('p', [_vm._v("22 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor "), _c('span', [_vm._v("incididunt")]), _vm._v(" ut labore etorn dolore eu magna porem ed ipsum dolor sit amet, do lorem consectetur utend tempor magna.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-4.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-empty-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Jack S.")]), _vm._v(" "), _c('p', [_vm._v("22 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "news"
    }
  }, [_c('p', [_vm._v("Do you wanna hear the latests news?")]), _vm._v(" "), _c('h4', [_vm._v("Subscribe to "), _c('span', [_vm._v("our Newsletter")])]), _vm._v(" "), _c('article', [_c('form', [_c('input', {
    attrs: {
      "type": "email",
      "id": "subs_email",
      "name": "subs_email",
      "placeholder": "Enter your email to subscribe..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "id": "subs",
      "value": "Subscribe"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subs-error"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Contact Us")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "type": "text",
      "id": "name",
      "name": "name",
      "placeholder": "Write your full name here..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Write your email adress here..."
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "Write your message here..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "id": "ctc",
      "name": "ctc",
      "value": "Send your Message"
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Facebook"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/fb-icon.png",
      "alt": "face-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Twitter"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/twitter-icon.png",
      "alt": "twitter-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Flickr"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/flickr-icon.png",
      "alt": "flickr-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Rss"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/rss-icon.png",
      "alt": "rss-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Vimeo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/vimeo-icon.png",
      "alt": "vimeo-icon"
    }
  })])])])])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Participating Businesses")]), _vm._v(" "), _c('div', {
    staticClass: "friend-list"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.market.business_markets), function(sellpoint) {
    return _c('div', {
      staticClass: "col-md-6 col-sm-6",
      staticStyle: {
        "min-height": "22em",
        "max-height": "22em"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + sellpoint.business_username
      }
    }, [_c('div', {
      staticClass: "friend-card",
      staticStyle: {
        "min-height": "20em",
        "max-height": "20em",
        "border-bottom-color": "rgb(182, 176, 176)"
      }
    }, [_c('div', {
      staticStyle: {
        "height": "10em",
        "background-size": "contain"
      },
      style: ({
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(' + sellpoint.business_banner_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-info"
    }, [_c('img', {
      staticClass: "profile-photo-lg",
      attrs: {
        "src": sellpoint.business_brand_image,
        "alt": "user"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "friend-info"
    }, [_c('a', {
      staticClass: "pull-right text-green",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(sellpoint.business_category))]), _vm._v(" "), _c('h5', [_c('a', {
      staticClass: "profile-link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sellpoint.business_tagline))]), _vm._v(" "), _c('a', {
      staticClass: "pull-right",
      staticStyle: {
        "color": "rgb(41, 34, 88)",
        "text-decoration": "none"
      },
      attrs: {
        "href": '/' + sellpoint.business_username
      }
    }, [_c('i', {
      staticClass: "fa fa-circle"
    }), _vm._v(" visit stall")])])])])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 static"
  }, [_c('right-sidebar')], 1)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-2 col-sm-12 col-xs-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('div', {
    staticClass: "wn-loader"
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product_info) ? _c('div', {
    staticClass: "margin-top-50 pretty-banner"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Same product but different variations")]), _vm._v(" "), _c('p', [_vm._v("if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _c('a', {
    attrs: {
      "href": _vm.product_url
    }
  }, [_vm._v("Proceed to this Product's View ")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_info) ? _c('div', {
    staticClass: "col-sm-10 col-sm-offset-4"
  }, [_c('h6', [_vm._v("Add Product / Service")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Select Product Category\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.sellpoint_categories.length != 0) ? _c('li', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select from related Shop Categories\n                        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_c('b', [_vm._v(" *Or ")]), _vm._v(" Enter a specific Category\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("Add")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" *Or ")])])
}]}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sign-in-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 create-new-account"
  }, [_c('h4', {
    staticClass: "checkout-subtitle"
  }, [_vm._v("Create a new account")]), _vm._v(" "), _c('p', {
    staticClass: "text title-tag-line"
  }, [_vm._v("Create your new account.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_proccessing_message))]), _vm._v(" "), _c('form', {
    staticClass: "register-form outer-top-xs",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail1"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail2"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "number",
      "id": "exampleInputEmail1"
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "password",
      "id": "exampleInputEmail1"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "info-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_purchase),
      expression: "user_purchase"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user_purchase) ? _vm._i(_vm.user_purchase, null) > -1 : (_vm.user_purchase)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.user_purchase,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.user_purchase = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.user_purchase = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.user_purchase = $$c
        }
      }
    }
  }), _vm._v("Do you want to get a space to sell in this mall?\r\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "info-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v("I agree to the"), _c('a', {
    attrs: {
      "href": "know#terms"
    }
  }, [_vm._v("Terms and Conditions")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_proccessing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn-upper btn btn-primary checkout-page-button",
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("Sign Up")])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "breadcrumb-inner"
  }, [_c('ul', {
    staticClass: "list-inline list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Sign-up")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-xs-12 hidden-xs"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/maller.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Name "), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputEmail2"
    }
  }, [_vm._v("Email Address "), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Phone Number "), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Password "), _c('span', [_vm._v("*")])])
}]}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "info"
    }
  }, [_c('article', [_c('h5', [_vm._v("About Mozzarella")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur. Do re eiusmod tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, consectetur.")]), _vm._v(" "), _c('ul', {
    staticClass: "c-info"
  }, [_c('li', [_vm._v("Fake street 123 - Springfield, USA")]), _vm._v(" "), _c('li', [_vm._v("inquiries@mozzarellabar.com")]), _vm._v(" "), _c('li', [_vm._v("(+044) 555 - 123 - 1234 / 35")])])]), _vm._v(" "), _c('article', {
    staticClass: "side-posts latests"
  }, [_c('h5', [_vm._v("Our Latests Posts")]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("Touring Through The City")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("10 Easy Red Onion Recipes")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])]), _vm._v(" "), _c('article', [_c('div', {
    staticClass: "circle small"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/blog/blog_image.png",
      "alt": "post"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon-small.png",
      "alt": "plus-icon-small"
    }
  })])]), _vm._v(" "), _c('h6', [_c('a', {
    attrs: {
      "href": "post.html"
    }
  }, [_vm._v("Healthy Tea Benefits")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, conte ad ipsum lorem.")])])]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Flickr Widget")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "flickr-w"
    }
  })]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Opening Hours")]), _vm._v(" "), _c('article', {
    staticClass: "op-hours"
  }, [_c('div', [_c('h6', [_vm._v("Monday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Tuesday")]), _vm._v(" "), _c('h6', [_c('span', [_vm._v("Closed")])])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Wednesday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Thursday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Friday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Saturday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])]), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Sunday")]), _vm._v(" "), _c('h6', [_vm._v("7:00PM - 2:00AM")])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "copy"
    }
  }, [_c('h5', [_c('span', [_vm._v("© 2019 Stanel World |")]), _vm._v(" All Rights Reserved")]), _vm._v(" "), _c('nav', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Places")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")])])])])])])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    attrs: {
      "id": "main-nav"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Places")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")])])]), _vm._v(" "), _c('ul', {
    staticClass: "responsive-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tour Places")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "pull"
    }
  })]), _vm._v(" "), _c('figure', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/main-logo.png",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('figcaption', [_vm._v("Stanel World")])])])])
}]}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('component-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-offset-2 col-md-8",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('cart-widget')], 1)])
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-info-wrap",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [(!_vm.checkout_processed) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h1', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "margin-left": "10px"
    }
  }, [_vm._v("Enter the details below to Checkout"), _c('br'), _vm._v(" "), (_vm.new_account) ? _c('span', [_vm._v("Do you have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('login', '')
      }
    }
  }, [_vm._v("Please Provide")])])]) : _c('span', [_vm._v("Don't have a "), _c('b', [_vm._v("Buypoint Account? ")]), _vm._v(" "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('new-account', '')
      }
    }
  }, [_vm._v("Click Here")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 gw-left-pan"
  }, [_c('div', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [(_vm.new_account) ? _c('form', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-5em",
      "display": "none"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Shipping Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12",
    staticStyle: {
      "margin-top": "-2em"
    }
  }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_shipping_details_state),
      expression: "user.user_shipping_details_state"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.user_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12",
    staticStyle: {
      "margin-top": "0.3em"
    }
  }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_shipping_details_address),
      expression: "user.user_shipping_details_address"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Shipping Address"
    },
    domProps: {
      "value": (_vm.user.user_shipping_details_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_shipping_details_address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.prep_process_checkout
    }
  }, [_vm._v("Process Checkout")])])]) : _c('form', {
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticStyle: {
      "margin": "1em 1em 3em 0.5em"
    }
  }, [_vm._v("Enter your Buypoint Login Details Below")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Your Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.data_success_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]) : _vm._e(), _vm._v(" "), (_vm.data_error_message) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Process Checkout")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 gw-right-pan"
  }, [_c('div', {
    staticClass: "gw-right-pan",
    staticStyle: {
      "margin": "-5em 0 0 1em"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin": "1em",
      "text-transform": "uppercase",
      "font-weight": "500"
    }
  }, [_vm._v("Items to Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em",
      "padding": "1em",
      "border": "#000000 solid 1px"
    }
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, _vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row cart-details"
      }, [_c('div', {
        staticClass: "col-xs-2",
        staticStyle: {
          "width": "50px",
          "height": "50px"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-3"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-2"
      }, [_vm._v("\r\n                                        QTY: " + _vm._s(item.product_item_order_quantity) + "\r\n                                    ")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-2"
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])])])
    }))
  }))])])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-xs-12"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "solid 1px #e0dfdf",
      "padding": "2em"
    }
  }, [_c('div', {
    staticClass: "row cktop ck-card-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_name))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_phone))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_payer_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right "
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.payment_details.payment_ref))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("₦" + _vm._s(_vm.total_orders_amount))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ckbody"
  }, _vm._l((_vm.checkout_orders), function(group, index) {
    return _c('div', {
      staticClass: "group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_vm._l((group.order_items), function(item) {
      return _c('div', {
        staticClass: "row ck-card-row"
      }, [_c('div', {
        staticClass: "col-md-2",
        staticStyle: {
          "width": "75px",
          "height": "75px"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_group_image && (item.product_item_group_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": item.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2"
      }, [_vm._v("\r\n                                            QTY: " + _vm._s(item.order_item_quantity) + "\r\n                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), (item.order_item_delivery_fee != 0) ? _c('div', {
        staticClass: "row pull-right",
        staticStyle: {
          "margin-right": "3px"
        }
      }, [_c('span', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Product Shipping Fee: ")]), _vm._v("₦" + _vm._s(item.order_item_delivery_fee) + "\r\n                                        ")]) : _vm._e()])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "pull-left col-md-6"
    }, [_vm._m(0, true), _vm._v(" "), ((group.order_business_delivery_options && (group.order_business_delivery_options.length != 0))) ? _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_state),
        expression: "selected_order_shipping_details_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities()
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_city),
        expression: "selected_order_shipping_details_city"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_address),
        expression: "selected_order_shipping_details_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.selected_order_shipping_details_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selected_order_shipping_details_address = $event.target.value
        }
      }
    })])]) : _c('div', [_c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "-2em"
      }
    }, [_c('label', [_vm._v("Select State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_state),
        expression: "selected_order_shipping_details_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(_vm.selected_order_shipping_details_state)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]), _vm._v(" "), (_vm.cities.length != 0) ? _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [_c('label', [_vm._v("Select Location")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_city),
        expression: "selected_order_shipping_details_city"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.selected_order_shipping_details_city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "margin-top": "0.3em"
      }
    }, [_c('label', [_vm._v("Shipping Address")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_order_shipping_details_address),
        expression: "selected_order_shipping_details_address"
      }],
      staticClass: "form-control input-group-lg",
      attrs: {
        "type": "text",
        "placeholder": "Shipping Address"
      },
      domProps: {
        "value": (_vm.selected_order_shipping_details_address)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selected_order_shipping_details_address = $event.target.value
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('div', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total Orders ₦" + _vm._s(_vm.total_orders_amount))]), _vm._v(" "), (_vm.checkout_orders) ? _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(_vm.total_shipping_fee))]), _vm._v(" "), _c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total: ₦" + _vm._s(_vm.total_orders_amount + _vm.total_shipping_fee))])]) : _c('span', [_vm._m(1, true)])])])])], 2)
  }))]), _vm._v(" "), ((_vm.selected_order_shipping_details_state != '') && (_vm.selected_order_shipping_details_city != '') && (_vm.selected_order_shipping_details_address != '')) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#000000"
    },
    on: {
      "click": _vm.processPaymentMini
    }
  }, [_vm._v("Make Payment")])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticStyle: {
      "margin": "1em 1em 2.2em 0.5em"
    }
  }, [_vm._v("Shipping Details\r\n                                                    "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Please enter your Shipping Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" {{}}")])
}]}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.canAdd) ? _c('div', [(_vm.productMainView == 'cartactions') ? _c('button', {
    staticClass: "cta-btn cta-btn-sm",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")]) : _c('button', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-8 contact_form add-prd-item"
  }, [_c('h6', [_vm._v("Add New Item ")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Price\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Weight\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Quantity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-post"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticClass: "profile-photo-md",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_words),
      expression: "search_words"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "texts",
      "id": "exampleTextarea",
      "cols": "100",
      "rows": "1",
      "placeholder": "Search: enter name or handle or hashtag"
    },
    domProps: {
      "value": (_vm.search_words)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_words = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "5em"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "business",
      "id": "business"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "business")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "business"
      }
    }
  }), _vm._v("Business\n                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_type),
      expression: "search_type"
    }],
    attrs: {
      "type": "radio",
      "value": "product",
      "id": "product"
    },
    domProps: {
      "checked": _vm._q(_vm.search_type, "product")
    },
    on: {
      "__c": function($event) {
        _vm.search_type = "product"
      }
    }
  }), _vm._v("Product/Service\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])])])])])
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Your Profile")]), _vm._v(" "), _c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Shops Followed")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.productMainView == 'cartactions') ? _c('span', [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn cart-btn-sm",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('div', [_c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "cart-cta-box"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "cart-btn cart-btn-sm",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])])]) : _c('div', {
    staticStyle: {
      "clear": "right",
      "float": "right"
    }
  }, [(_vm.canAdd) ? _c('button', {
    staticClass: "cart-btn",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("Add to Cart")]) : _c('div', [_c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "cart-cta-box"
  }, [_c('li', [_c('a', {
    staticClass: "cart-btn btn-white remove-btn",
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "cart-btn btn-black view-btn",
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('a', {
    staticClass: "cart-btn btn-white btn-primary",
    on: {
      "click": function($event) {
        _vm.redir('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" Continue Shopping")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md hidden-lg"
  }, [_c('button', {
    staticClass: "cart-btn remove-btn",
    staticStyle: {
      "background": "#e05024"
    },
    on: {
      "click": function($event) {
        _vm.removeFromCart(_vm.productItem)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Remove from Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn view-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")]), _vm._v(" "), _c('button', {
    staticClass: "cart-btn btn-primary",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.redir('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" Continue Shopping")])])])])])
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky",
    staticStyle: {
      "background": "none"
    }
  }, [_c('div', {
    staticClass: "container clearfix nav-head",
    staticStyle: {
      "background": "none"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "vtd vtd-right-side-box"
  }, [_c('a', {
    staticClass: "header-btn vtd-btn",
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")])]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticStyle: {
      "height": "3em",
      "background": "#ffffff"
    },
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "container banner-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('lookbooks')
      }
    }
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('li', {
    staticClass: "gw-mobile"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('feeds')
      }
    }
  }, [_vm._v("Feeds")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile')
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Orders")])]), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel')
      }
    }
  }, [_vm._v("Manage Gallery")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    attrs: {
      "href": "/getstarted"
    }
  }, [_vm._v("Get a Mall Space")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('settings')
      }
    }
  }, [_vm._v("Settings")])])])])])]), _vm._v(" "), (!_vm.setPanel) ? _c('section', {
    staticClass: "account-inner",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row account-inner-row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "info-card",
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "info-card-left"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-left": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr",
    staticStyle: {
      "color": "inherit",
      "margin-top": "-1em"
    }
  }, [_vm._v("@" + _vm._s(_vm.sellpoint.business_username))])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card-right",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.toggleSwitchBusiness()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "show-business-list",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "businessList"
    }
  }, _vm._l((_vm.sellpoints), function(sellpoint) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.switchBusiness(sellpoint)
        }
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-stats-top"
  }, [_c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery_posts))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Posts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block stats-block-center"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_gallery))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Lookbooks")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 stats-block"
  }, [_c('h5', {
    staticClass: "stats-num"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_total_views))]), _vm._v(" "), _c('p', {
    staticClass: "stats-descr"
  }, [_vm._v("Views")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Category")]), _vm._v(_vm._s(_vm.sellpoint.business_category))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Tagline:")]), _vm._v(_vm._s(_vm.sellpoint.business_tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Brief:")]), _vm._v(_vm._s(_vm.sellpoint.business_profile))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('a', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    attrs: {
      "href": '/' + _vm.sellpoint.business_username
    }
  }, [_vm._v("View Gallery")]), _vm._v(" "), _c('button', {
    staticClass: "btn vtd-btn",
    staticStyle: {
      "float": "right",
      "background": "#f1dee4",
      "font-size": "14px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('manage-panel', '')
      }
    }
  }, [_vm._v("Manage Gallery")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "lookbooks"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    })])])])
  }), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "feeds"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [(_vm.sellpoint.business_notifications && (_vm.sellpoint.business_notifications.length != 0)) ? _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[0].notification_message))])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_notifications[1].notification_message))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])]) : _c('div', [_vm._m(12)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Address")]), _vm._v(_vm._s(_vm.sellpoint.business_address))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Email:")]), _vm._v(_vm._s(_vm.sellpoint.business_emails))])]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row info-stats-list"
  }, [_c('p', [_c('span', [_vm._v("Phone:")]), _vm._v(_vm._s(_vm.sellpoint.business_phones))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "subscription"
    }
  }, [_c('div', {
    staticClass: "info-card"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body",
    staticStyle: {
      "padding": "0 1em"
    }
  }, [_c('p', [_c('b', [_vm._v("Current Plan: ")]), _c('span', {
    staticStyle: {
      "color": "#ff0055",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint_gallery.business_market_subscription_name))])]), _vm._v(" "), (!_vm.can_add_more_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("To add more lookbooks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account")])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.can_add_product_lookbook) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Do you want to sell some Products or Services of your Gallery? ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Unlock this Package. "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": '/purchase?upgrade=' + _vm.sellpoint.business_username
    }
  }, [_vm._v("Upgrade your Account to Unlock")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.can_add_more_lookbook && _vm.can_add_product_lookbook) ? _c('div', [_vm._m(15)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12",
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "info-card info-card-feeds"
  }, [_vm._m(16), _vm._v(" "), (_vm.setSettings) ? _c('div', {
    staticClass: "container"
  }, [(_vm.setting_details.editProfile) ? _c('div', [_c('h6', [_vm._v("Edit Profile Details")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Name\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v("Phone Number\r\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.editProfileDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _c('div', {
    staticClass: "container info-card-body"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-settings-inner', 'editProfile')
      }
    }
  }, [_vm._v("Edit Profile")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row info-card-inner-row",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.syncset(_vm.sellpoint.business_username)
      }
    }
  }, [_vm._v("Manage Account on Sellpoint")])])])])])]), _vm._v(" "), _vm._m(18)])]) : _vm._e(), _vm._v(" "), (_vm.managePanel) ? _c('section', {
    staticClass: "account-inner-set-panel",
    staticStyle: {
      "background": "#f7fbff",
      "margin-top": "2em"
    },
    attrs: {
      "id": "manage"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(19)]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "margin-top": "1em",
      "padding": "1em"
    }
  }, [_c('h5', [_vm._v("Manage Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "container banner-menu manage-account-menu"
  }, [_c('div', {
    staticClass: "row menu-links"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-businesses', '')
      }
    }
  }, [_vm._v("Business Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-lookbooks', '')
      }
    }
  }, [_vm._v("Lookbooks Settings")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setComponent('manage-products', '')
      }
    }
  }, [_vm._v("Products")])])])])]), _vm._v(" "), (_vm.manageBusinesses) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row card-row-controls"
  }, [_c('div', [(_vm.manageBusinessDetails) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-component-details', '')
      }
    }
  }, [_vm._v("Back")]) : _vm._e()])]), _vm._v(" "), (!_vm.manageBusinessDetails) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row cards-grids"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 0)
      }
    }
  }, [_vm._m(20)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 1)
      }
    }
  }, [_vm._m(21)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 2)
      }
    }
  }, [_vm._m(22)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-6",
    attrs: {
      "id": "businessprofile"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-card-details', 3)
      }
    }
  }, [_vm._m(23)])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.businessComponents[0]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-8 offset-md-1 set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h4', [_vm._v("Edit Business Details")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_name),
      expression: "sellpoint.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Tagline")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_tagline),
      expression: "sellpoint.business_tagline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_tagline = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Brief")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_profile),
      expression: "sellpoint.business_profile"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.sellpoint.business_profile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_profile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_address),
      expression: "sellpoint.business_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Emails")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_emails),
      expression: "sellpoint.business_emails"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_emails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_emails = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Business Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_phones),
      expression: "sellpoint.business_phones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sellpoint.business_phones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_phones = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "left",
      "background": "#f1dee4"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('main')
      }
    }
  }, [_vm._v("Save Details")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ecb989"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[1]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_vm._m(24), _vm._v(" "), (_vm.business_details.delivery_edit) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('label', [_vm._v("Your Delivery Information")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellpoint.business_delivery_information),
      expression: "sellpoint.business_delivery_information"
    }],
    staticStyle: {
      "width": "70%"
    },
    domProps: {
      "value": (_vm.sellpoint.business_delivery_information)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sellpoint.business_delivery_information = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.editBusinessDetails('delivery')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("save")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])]) : _c('div', [(_vm.sellpoint.business_delivery_information) ? _c('p', [_vm._v(_vm._s(_vm.sellpoint.business_delivery_information) + "\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("edit")]), _vm._v(" "), _c('br')]) : _c('p', [_vm._v("You have not set any delivery information\r\n                            "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_edit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("Set")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('p', [_vm._v("This setting affects all products orders shipping fees on th this Business. If you would like any product \r\n                            to have its on shipping fee, specify it when setting up your product.\r\n                        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#363535"
    }
  }, [_vm._v("How would your Business Shipping Fee be calculated?")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "9",
      "value": "9"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "9")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "9"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" One Charge Business Shipping Fee on all Items Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "10",
      "value": "10"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "10")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "10"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Same Charge Business Shipping Fee on each Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_set_shipping_fee_status),
      expression: "business_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "11",
      "value": "11"
    },
    domProps: {
      "checked": _vm._q(_vm.business_set_shipping_fee_status, "11")
    },
    on: {
      "click": function($event) {
        _vm.setShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.business_set_shipping_fee_status = "11"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Same Charge Business Shipping Fee on each Product and its quantities Ordered")])])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('h6', [_vm._v("Delivery Locations and Prices")]), _vm._v(" "), _c('div', [_c('div', [_vm._l((_vm.sellpoint.business_delivery_options), function(delivery_option) {
    return _c('div', [(_vm.business_details.delivery_option_edit && delivery_option.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_state),
        expression: "delivery_option.business_delivery_state"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.business_delivery_state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.getCities(delivery_option.business_delivery_state, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        domProps: {
          "value": state.state_id
        }
      }, [_vm._v(_vm._s(state.name))])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("City: "), _c('b', [_vm._v(_vm._s(delivery_option.business_delivery_option))])]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.city),
        expression: "delivery_option.city"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.setOtherOptions(delivery_option.city, 'edit')
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "all"
      }
    }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
      return _c('option', {
        domProps: {
          "value": city.city_id
        }
      }, [_vm._v(_vm._s(city.city_name))])
    }), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v("Other Areas / Cities ")])], 2)]), _vm._v(" "), (_vm.edit_other_delivery_option) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_other_option),
        expression: "delivery_option.business_delivery_other_option"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "eg. Abuja"
      },
      domProps: {
        "value": (delivery_option.business_delivery_other_option)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_other_option = $event.target.value
        }
      }
    }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery_option.business_delivery_option_price),
        expression: "delivery_option.business_delivery_option_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery_option.business_delivery_option_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery_option.business_delivery_option_price = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.editDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _c('div', [(delivery_option.business_delivery_product == 0) ? _c('p', [_vm._v("\r\n                                    " + _vm._s(delivery_option.business_delivery_option) + " - " + _vm._s(delivery_option.business_delivery_option_price) + " \r\n                                    "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-delivery-option', delivery_option)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDeliveryOption(delivery_option.business_delivery_option_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'delivery_add')
      }
    }
  }, [_vm._v("Add New Delivery Information")]), _vm._v(" "), _c('hr')], 2), _vm._v(" "), (_vm.business_details.delivery_add) ? _c('div', {
    staticClass: "contact_form col-md-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('h5', [_vm._v("Add a Delivery Location and Price")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.state),
      expression: "delivery_option.state"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getCities(_vm.delivery_option.state, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select State")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.state_id
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2)]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), (_vm.cities.length && _vm.cities.length != 0 && !_vm.edit_city) ? _c('div', [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.city),
      expression: "delivery_option.city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.delivery_option.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setOtherOptions(_vm.delivery_option.city, '')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Areas @Fixed Price")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('option', {
      domProps: {
        "value": city.city_id
      }
    }, [_vm._v(_vm._s(city.city_name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other Areas / Cities ")])], 2)]) : _vm._e(), _vm._v(" "), (_vm.other_delivery_option) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Areas / Cities")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_other_option),
      expression: "delivery_option.delivery_other_option"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "eg. Abuja"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_other_option)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_other_option = $event.target.value
      }
    }
  }), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Delivery Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delivery_option.delivery_option_price),
      expression: "delivery_option.delivery_option_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "eg. 1000"
    },
    domProps: {
      "value": (_vm.delivery_option.delivery_option_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.delivery_option.delivery_option_price = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.addDeliveryOption
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div')])])])])]) : _vm._e(), _vm._v(" "), (_vm.businessComponents[2]) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-10  set-panel"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "horizontal-cards"
  }, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set My Sellpoint's Discounts and Coupons")]), _vm._v(" "), _c('p', [_vm._v("Set a general discount and coupons that would apply to all products and services in your sellpoint. \r\n                          You can set individual Product Discounts on thier product pages.\r\n                      ")]), _vm._v(" "), _c('span', [(_vm.business_details.setDiscount) ? _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('view-discounts', '')
      }
    }
  }, [_vm._v("View your Discounts")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('set-business-details', 'setDiscount')
      }
    }
  }, [_vm._v("Set New Discount Or Coupon")]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.business_details.setDiscount) ? _c('div', [_c('div', {
    staticClass: "contact-form col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.sellpoint.business_discounts_active == 1) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an ongoing active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Set Coupon Or Discount")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label'), _vm._v(" "), (_vm.sellpoint.business_discounts_active != 1) ? _c('label', [_vm._v("Select Discount Category")]) : _c('label', [_vm._v("Select Coupon Discount Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.discount_coupon.edit && (!_vm.business_details.viewDiscounts || !_vm.business_details.setDiscount)) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_category),
      expression: "discount_coupon.discount_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.discount_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select Another Category")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("All Categories")]), _vm._v(" "), _vm._l((_vm.sellpoint.business_categories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.business_category_id
      }
    }, [_vm._v(_vm._s(cat.business_category))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), ((!_vm.business_details.setDiscount && !_vm.discount_coupon.edit) && _vm.sellpoint.business_discounts_coupons) ? _c('div', [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("View Discounts")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoint.business_discounts_coupons), function(dc, index) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('div', {
      staticStyle: {
        "border": "#f1dee4 solid 1px",
        "padding": "1em"
      }
    }, [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_type_name))]) : _c('p', [_c('b', [_vm._v("Type: ")]), _vm._v(_vm._s(dc.discount_category_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 2) || (dc.discount_type == 3)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-discount-coupon', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Coupon")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.deactivateDiscountsAndCoupons(dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Coupon")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Product Settings")]) : _vm._e()])])
  }))]) : _vm._e()])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.manageProducts) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Products (" + _vm._s(_vm.sellpoint.business_total_products) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewProducts) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.products), function(product, gndex) {
    return _c('div', {
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('products', product, '')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(product.product_images.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(product.product_images[0].product_image)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": product.product_images[0].product_image
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(product.product_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  })) : _vm._e(), _vm._v(" "), (_vm.component_view.viewProduct) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.is_viewing_lookbook) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('switch-to-viewing-loobook', '', '')
      }
    }
  }, [_vm._v("<< Back to Lookbook")])]) : _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('products', '', '')
      }
    }
  }, [_vm._v("<< Back ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Category: " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), (_vm.product.product_set_items == 0) ? _c('div', [(_vm.product.product_items[0].product_item_actual_price != 0) ? _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_actual_price))]), _vm._v(" "), _c('p', [_vm._v("Discounted Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]) : _c('div', [_c('p', [_vm._v("Price: ₦" + _vm._s(_vm.product.product_items[0].product_item_price))])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('p', [_vm._v("Weight: " + _vm._s(_vm.product.product_items[0].product_item_weight) + "(kg)")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Quantity: " + _vm._s(_vm.product.product_items[0].product_item_quantity))])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductSingleProductItem) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', {
    staticStyle: {
      "font-size": "14px",
      "text-decoration": "underline"
    }
  }, [_vm._v("Reset Product Details")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Price\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_price),
      expression: "product.product_items[0].product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Weight\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_weight),
      expression: "product.product_items[0].product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4 col-xs-4"
  }, [_c('label', [_vm._v(" Quantity\r\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_items[0].product_item_quantity),
      expression: "product.product_items[0].product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product.product_items[0].product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_items[0].product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSingleProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-2",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProductSingleProductItem', '')
      }
    }
  }, [_vm._v("Edit Price/Weight/Quantity")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), (_vm.product_details.editProduct) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _vm._v(" "), (_vm.sellpoint_categories.length > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v(" Select from My Shop Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "category-type-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-1')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_1
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      key: category.business_category_id,
      attrs: {
        "disabled": _vm.category_type_1
      },
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [(_vm.sellpoint_categories.length > 0) ? _c('span', [_c('b', [_vm._v("Or ")])]) : _vm._e(), _vm._v(" Select from Related Categories\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.main_category),
      expression: "main_category"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.main_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubCategories(_vm.main_category)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.category_id,
      domProps: {
        "value": category
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.sub_categories.length != 0) ? _c('label', [_vm._v(" Select a Category\r\n                                  "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_sub_category),
      expression: "product.product_sub_category"
    }],
    staticClass: "form-control category-type-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_sub_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.trackevent('category-type-2')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "disabled": _vm.category_type_2
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sub_categories), function(category) {
    return _c('option', {
      key: category.sub_category_id,
      attrs: {
        "disabled": _vm.category_type_2
      },
      domProps: {
        "value": category.sub_category_id
      }
    }, [_vm._v(_vm._s(category.sub_category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', [_c('b', [_vm._v("Or ")]), _vm._v(" Enter a specific Category\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_listed_category),
      expression: "product.product_listed_category"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.category_type_3,
      "type": "text",
      "placeholder": "",
      "id": "category-type-3"
    },
    domProps: {
      "value": (_vm.product.product_listed_category)
    },
    on: {
      "change": function($event) {
        _vm.trackevent('category-type-3')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_listed_category = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    staticClass: "form-control txtarea",
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs admin-btn",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('editProduct', '')
      }
    }
  }, [_vm._v("Edit Product Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Product Images")]), _vm._v(" "), _c('div', {
    staticClass: "img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.product.product_images), function(pt) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": _vm.img_product_url + pt.product_image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px",
        "float": "right"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductImage(pt.product_image_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading && _vm.product_details.uploading_image) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Photo")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(!_vm.product_details.removeProduct) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('removeProduct', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Product")]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeProduct) ? _c('span', {}, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Product?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.removeProduct
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Items and Variations")]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_set_items > 0) ? _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "10px",
      "text-transform": "capitalize"
    }
  }, [_c('b', [_vm._v("Name of Group: ")]), _vm._v(_vm._s(_vm.product.product_groups_set_name) + "\r\n                    "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change")])]), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', _vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "row col-xs-12",
      staticStyle: {
        "border-bottom": "1px solid #e9e6e6",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', [_vm._v("Edit Product Item Group")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Name\r\n                                    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("To change Colour/Image, pick Colour or pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v(" Pick Colour\r\n                                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', [_vm._v("Or Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn",
      staticStyle: {
        "line-height": "0.6"
      }
    }, [_vm._v("Or Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('span', {
      staticClass: "pull-left col-sm-12"
    }, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Item Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs admin-btn-tiny",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "bold",
        "text-transform": "capitalize",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('div', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\r\n                            "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductSettings', '', '')
        }
      }
    }, [_vm._v(" Change")])]), _vm._v(" "), _vm._l((pg.product_items), function(pt) {
      return _c('div', {
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('li', {
        staticClass: "box-wrap"
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(pt.product_item_quantity))]), _vm._v(" "), _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('li', [_c('a', {
        staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])]) : _vm._e()]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *"), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("Product Item Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v("Product Item tYPE")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group",
        attrs: {
          "cla": ""
        }
      }, [_c('label', [_vm._v(" *Service Tag\r\n                                    "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Price\r\n                                          "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                        "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-md-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn admin-btn",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {
        staticClass: "pull-left col-sm-12"
      }, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs admin-btn-tiny",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "0.8"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row col-md-12"
    }, [(_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-3"
    }, [_c('label', [_vm._v(" Service Tag\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Price\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Weight(KG)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v(" Quantity\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-3"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "background": "#e7e8e9"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not set any product item variation")])]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("add other variations like groups or types of this product eg. colors, materials, plans, sizes etc")]), _vm._v(" "), (_vm.product.product_set_groups == 0) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change this Name")])])]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")]) : _c('div', [(_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h6', [_vm._v("Add New Variation "), (_vm.product.product_groups_set_name) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(Set " + _vm._s(_vm.product.product_groups_set_name) + ")")]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\r\n                                               Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\r\n                                                   Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                           ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex,
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg.product_item_group_id)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2"
      }
    }, [_vm._v("Add to " + _vm._s(pg.product_item_group_name) + " ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + "\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {}, [_c('label', [_vm._v(" Pick Colour or Pick from uploaded Images to match the colour you are adding")])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\r\n                                                       "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "border": "1px dashed #eeccee",
      "padding": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Media")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, _vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.4",
      "font-size": "14px"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-4 col-xs-3"
  }, [_c('label', [_vm._v(" Service Tag\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Price\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\r\n                                                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "background": "#e7e8e9"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("DISCOUNTS AND COUPONS")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) ? _c('div', [_c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.product_details.setProductDiscount) ? _c('label', [_vm._v("Set Product Coupon Or Discount")]) : _vm._e(), _vm._v(" "), (_vm.product_details.setProductItemDiscount) ? _c('label', [_vm._v("Set Product Item Coupon Or Discount")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.is_discount_coupon),
      expression: "discount_coupon.is_discount_coupon"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount_coupon.is_discount_coupon = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("Discount")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("Coupon")])])]), _vm._v(" "), (((_vm.product.product_discounts_active == 1) || (_vm.product_item.product_item_discounts_active == 1))) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have an active Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.setDiscountsAndCoupons()
      }
    }
  }, [_vm._v("SET")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]), _vm._v(" "), _vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.product_details.editDiscount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("Edit Discount")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Percentage Discount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_percentage),
      expression: "discount_coupon.discount_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "100"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_percentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date: " + _vm._s(_vm.discount_coupon.discount_start_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_start_date),
      expression: "discount_coupon.discount_start_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_start_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("End Date: " + _vm._s(_vm.discount_coupon.discount_end_date))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount_coupon.discount_end_date),
      expression: "discount_coupon.discount_end_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.discount_coupon.discount_end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discount_coupon.discount_end_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.editDiscountsAndCoupons()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])]) : _vm._e(), _vm._v(" "), (!(_vm.product_details.setProductDiscount || _vm.product_details.setProductItemDiscount) && !_vm.product_details.editDiscount) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Discounts and Coupons")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('viewProductItemsDiscounts', '', '')
      }
    }
  }, [_vm._v("View Product Items Discounts and Coupons")])]) : _vm._e(), _vm._v(" "), (_vm.product_details.viewCoupons) ? _c('div', {
    staticStyle: {
      "margin-top": "2em",
      "border": "#e9e6e6 dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Item Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "items-list-tiny",
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.product_item.product_item_group_is_color_image == 'IMG') ? _c('li', [((_vm.product_item.product_item_group_image && (_vm.product_item.product_item_group_image != 'error'))) ? _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": _vm.product_item.product_item_group_image
    }
  }) : _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
    staticClass: "btn box-color-cube",
    style: ({
      background: _vm.product_item.product_item_group_color
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (_vm.product_item.product_item_size)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (_vm.product_item.product_item_service_tag)) ? _c('li', {
    staticClass: "box-wrap"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(_vm.product_item.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(_vm.product_item.product_item_quantity))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.product_item.product_item_discounts), function(dc) {
    return _c('div', [(dc.discount_type == 5) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                  Edit Discount")]), _vm._v("    \r\n                                "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product_item, dc)
        }
      }
    }, [_vm._v("\r\n                                  Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product_item.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), _c('div', [(_vm.product_item.product_item_only_coupon_discount_count == 0) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductItemDiscount', 'productitem', _vm.product_item)
      }
    }
  }, [_vm._v("Set New Item Discount Or Coupon")])])], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductItemsDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "1em",
      "border": "#0d022b dashed 1px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Items in this Product")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items), function(productItem) {
    return _c('div', {
      staticStyle: {
        "border": "dashed #d1ddf1",
        "padding": "5px",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [(productItem.product_item_group_is_color_image == 'IMG') ? _c('li', [((productItem.product_item_group_image && (productItem.product_item_group_image != 'error'))) ? _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": productItem.product_item_group_image
      }
    }) : _c('img', {
      staticStyle: {
        "height": "30px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (productItem.product_item_group_is_color_image == 'COL') ? _c('li', [_c('a', {
      staticClass: "btn box-color-cube",
      style: ({
        background: productItem.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P' && (productItem.product_item_size)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (productItem.product_item_service_tag)) ? _c('li', {
      staticClass: "box-wrap"
    }, [_vm._v(_vm._s(productItem.product_item_service_tag))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('li', [_c('span', [_vm._v("w(kg):")]), _vm._v(_vm._s(productItem.product_item_weight))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', [_vm._v("Price:")]), _vm._v(_vm._s(productItem.product_item_actual_price))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Qty:")]), _vm._v(_vm._s(productItem.product_item_quantity))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.product_details.viewCoupons && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "1.2"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductItemDiscount', 'productitem', productItem)
        }
      }
    }, [_vm._v("Set New Item Discount Or Coupon")])]), _vm._v(" "), _vm._l((productItem.product_item_discounts), function(dc) {
      return _c('div', [_c('div', [((dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("Product Item Discount")])]) : _vm._e(), _vm._v(" "), ((dc.discount_type == 4)) ? _c('p', [_c('b', [_vm._v("General Product Discount")])]) : _vm._e(), _vm._v(" "), (!(dc.discount_type == 4) && !(dc.discount_type == 5)) ? _c('p', [_c('b', [_vm._v("General Sellpoint Discount")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "background": "#d1ddf1",
          "text-align": "center"
        }
      }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "Edit"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editDiscount', '', dc)
          }
        }
      }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "text-decoration": "underline",
          "font-size": "13px",
          "color": "#448aff"
        },
        attrs: {
          "title": "De-Activate"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('deactivateDiscount', productItem, dc)
          }
        }
      }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (productItem.product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')])])
    }), _vm._v(" "), _c('div', [(productItem.product_item_discounts && _vm.product_item.product_item_discounts.length == 0) ? _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("No set discount or coupon")]) : _vm._e()])], 2) : _c('button', {
      staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny",
      staticStyle: {
        "line-height": "2em"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('viewCoupons', 'productitem', productItem)
        }
      }
    }, [_vm._v("View Coupons and Discounts")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.product_details.viewProductDiscounts) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.product.product_items[0]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('h6', {
    staticClass: "pull-left",
    staticStyle: {
      "text-transform": "uppercase",
      "font-size": "14px"
    }
  }, [_vm._v("Product Coupons and Discounts")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs v-tiny-btn admin-btn-tiny pull-right",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._l((_vm.product.product_items[0].product_item_discounts), function(dc) {
    return _c('div', [((dc.discount_type == 4)) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "#d1ddf1",
        "text-align": "center"
      }
    }, [(dc.discount_coupon == 'D') ? _c('p', [_c('b', [_vm._v("Discount")])]) : _vm._e(), _vm._v(" "), (dc.discount_coupon == 'C') ? _c('p', [_c('b', [_vm._v("Coupon:")]), _vm._v(" (Code: " + _vm._s(dc.discount_coupon_code) + " )")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('b', [_vm._v("%Discount: ")]), _vm._v(_vm._s(dc.discount_percentage) + "%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Start Date: ")]), _vm._v(_vm._s(dc.discount_start_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("End Date: ")]), _vm._v(_vm._s(dc.discount_end_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(dc.discount_status))]), _vm._v(" "), ((dc.discount_type == 4) || (dc.discount_type == 5)) ? _c('div', [(dc.discount_status_id == 5) ? _c('p', [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editDiscount', '', dc)
        }
      }
    }, [_vm._v("\r\n                                    Edit Discount")]), _vm._v("    \r\n                                  "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "underline",
        "font-size": "13px",
        "color": "#448aff"
      },
      attrs: {
        "title": "De-Activate"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('deactivateDiscount', _vm.product.product_items[0], dc)
        }
      }
    }, [_vm._v("\r\n                                    Deactivate Discount")])]) : _vm._e(), (_vm.action_loading && (_vm.product.product_items[0].product_item_id == _vm.product_item.product_item_id)) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p')]) : _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Edit/Deactivate at Business Settings")]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.product.product_only_coupon_discount_count == 0) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No set discount or coupon")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn-tiny",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductDiscount', '', '')
      }
    }
  }, [_vm._v("Set New Product Discount Or Coupon")])]) : _vm._e()]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (_vm.product_details.edit_product_delivery) ? _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_delivery_returns),
      expression: "product.product_delivery_returns"
    }],
    domProps: {
      "value": (_vm.product.product_delivery_returns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_delivery_returns = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.setProductDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("submit")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "btn"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" cancel")])])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "line-height": "1.2",
      "font-size": "13px"
    }
  }, [_vm._v("Set delivery and returns information for this product, Note that this is different from setting delivery places\r\n                      "), (_vm.product.product_delivery_returns) ? _c('span', [_vm._v(_vm._s(_vm.product.product_delivery_returns))]) : _vm._e(), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "type": "btn admin-btn",
      "title": "Edit"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('edit_product_delivery', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Set Delivery & Return Information")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {}, [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("Set How Product Shipping Fee would affect Buyers Checkout Ordering")]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "12",
      "value": "12"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "12")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "12"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee only once on all Quantity of Product Ordered")])])]), _vm._v(" "), _c('span', [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_set_shipping_fee_status),
      expression: "product_set_shipping_fee_status"
    }],
    attrs: {
      "type": "radio",
      "id": "13",
      "value": "13"
    },
    domProps: {
      "checked": _vm._q(_vm.product_set_shipping_fee_status, "13")
    },
    on: {
      "click": function($event) {
        _vm.setProductShippingFeeStatus()
      },
      "__c": function($event) {
        _vm.product_set_shipping_fee_status = "13"
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Charge Product Delivery Fee on each Quantity of Product Ordered")])])]), _vm._v(" "), (_vm.set_shipping_fee_status_track && _vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('h6', [_vm._v("Product Delivery Location Fees")]), _vm._v(" "), ((_vm.product.product_business_delivery_options) && (_vm.product.product_business_delivery_options.length != 0)) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have set some general delivery settings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("You can set a different delivery fee for this product")]), _vm._v(" "), _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(" -  ₦" + _vm._s(fee.product_delivery_fee) + "\r\n                            ")]) : _vm._e()])
    })) : _c('span'), _vm._v(" "), (_vm.product_details.setProductDeliveryInformation && delivery.edit_set) ? _c('div', {
      staticClass: "contact_form"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Delivery Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (delivery.product_delivery_fee),
        expression: "delivery.product_delivery_fee"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (delivery.product_delivery_fee)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          delivery.product_delivery_fee = $event.target.value
        }
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Business Set Shipping Fee: ₦" + _vm._s(delivery.business_delivery_option_price))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [(_vm.product_details.setProductDeliveryInformation && _vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "title": "save",
        "type": "submit"
      },
      on: {
        "click": _vm.setProductDeliveryOption
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn admin-btn",
      staticStyle: {
        "line-height": "1.6",
        "padding": "10px"
      },
      attrs: {
        "title": "cancel",
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "font-size": "10px"
      },
      attrs: {
        "type": "btn",
        "title": "Set Product Delivery Fee"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('setProductDeliveryInformation', delivery)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Set Fee")])])
  })], 2) : _c('div', [_c('p', [_vm._v("You have not set your Business Delivery Locations")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.manageLookbooks) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('h6', {
    staticStyle: {
      "margin-left": "1em",
      "margin-right": "2em"
    }
  }, [_vm._v("Lookbooks (" + _vm._s(_vm.sellpoint.business_total_gallery) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.component_view.viewLookbooks) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "drag-and-drop",
      rawName: "v-drag-and-drop:options",
      value: (_vm.drag_options),
      expression: "drag_options",
      arg: "options"
    }]
  }, [_c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('li', {
      key: gallery.gallery_posts_group_id,
      staticClass: "col-md-2 col-sm-3 col-xs-3"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', gallery, 'viewLookbook')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(gallery.gallery_posts_group_posts.length) + " posts")])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }))]), _vm._v(" "), (_vm.galleria.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', '', 'viewLookbooks')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', [_c('h4', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('p', [_vm._v("Type: Posts Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('p', [_vm._v("Type: Product Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "white-space": "pre-line"
    }
  }, [_vm._v("Description: " + _vm._s(_vm.lookbook.gallery_posts_group_text))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Edit Lookbook ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbook', 'lookbook', _vm.lookbook)
      }
    }
  }, [_vm._v("Delete ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), (_vm.lookbook_details.editLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Lookbook Name\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_name),
      expression: "lookbook.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" Details ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook.gallery_posts_group_text),
      expression: "lookbook.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "height": "250px"
    },
    domProps: {
      "value": (_vm.lookbook.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook.gallery_posts_group_text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbook
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbook) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Lookbook?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbook
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts.length == 0) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(28)]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.component_view.viewLookbookPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_vm._v("<< Back ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "product-detail-card"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('editLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Post ")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 2) ? _c('div', [_c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('viewProductLookbookPost', 'productlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Edit Product Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLookbookComponent('deleteLookbookPost', 'postlookbook', _vm.lookbook_post)
      }
    }
  }, [_vm._v("Delete Product Post ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v(_vm._s(_vm.lookbook_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(_vm.lookbook_post.gallery_post_details))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.lookbook_details.editLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [_c('h6', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Caption\r\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_caption),
      expression: "lookbook_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(" *Post Details\r\n                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lookbook_post.gallery_post_details),
      expression: "lookbook_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.lookbook_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lookbook_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editLookbookPost
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn admin-btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lookbook_details.deleteLookbookPost) ? _c('div', {
    staticClass: "row col-md-12"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to delete this Post?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.deleteLookbookPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs admin-btn-tiny",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("Post Images")]), _vm._v(" "), ((_vm.lookbook_post.gallery_post_media) && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "row img-row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._l((_vm.lookbook_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "border": "#eeccee 1px solid"
      }
    }, [_c('div', {
      staticClass: "img-row"
    }, [(_vm.lookbook_post.gallery_post_media && (_vm.lookbook_post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-column",
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('div', {
      staticClass: "col-xs-8",
      staticStyle: {
        "z-index": "1"
      }
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      staticStyle: {
        "z-index": "1",
        "height": "50px",
        "width": "80px"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('a', {
      staticClass: "col-xs-2 btn pull-right",
      staticStyle: {
        "z-index": "9",
        "margin-top": "4em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.lookbook.gallery_posts_group_type == 1) ? _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "upload-btn",
    staticStyle: {
      "line-height": "0.6",
      "font-size": "12px"
    }
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeLookbook($event, 'gallery_media', _vm.lookbook_post.gallery_post_id)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('hr')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "row product-detail-card"
  }, [_c('h5', {
    staticClass: "col-md-12"
  }, [_vm._v("Other Posts in \r\n                  "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponentView('lookbooks', _vm.lookbook, 'viewLookbook')
      }
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.lookbook.gallery_posts_group_name))])]), _vm._v(" Lookbook")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.lookbook.gallery_posts_group_posts), function(post, pndex) {
    return _c('div', {
      staticClass: "col-md-6 col-xs-6"
    }, [(post.gallery_post_id != _vm.lookbook_post.gallery_post_id) ? _c('div', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponentView('lookbooks', post, 'viewLookbookPost')
        }
      }
    }, [_c('div', {
      staticClass: "info-card info-card-lookbook"
    }, [_c('div', {
      staticClass: "container info-card-body"
    }, [_c('div', {
      staticClass: "info-card-row info-card-lookbook-row"
    }, [_c('div', {}, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "info-card-lookbook-image",
      staticStyle: {
        "margin": "5px"
      }
    }, [(_vm.checkIfVideo(post.gallery_post_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticStyle: {
        "margin": "5px"
      }
    }, [_c('img', {
      staticClass: "sp-prd-img-cs",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "0.8"
      }
    }, [_c('p', [_vm._v(_vm._s(post.gallery_post_caption))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.lookbook.gallery_posts_group_posts && (_vm.lookbook.gallery_posts_group_posts.length == 0)) ? _c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(29)]) : _vm._e()], 2)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.managePosts) ? _c('div', {
    staticClass: "container"
  }) : _vm._e(), _vm._v(" "), (_vm.manageOrders) ? _c('div', {
    staticClass: "container"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-box clearfix"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": "Gallery"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "menu-toggler",
    attrs: {
      "data-target": "#main-nav-bar"
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase info-profile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('h5', [_vm._v("Lookbooks")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-slide"
  }, [_c('div', {
    staticClass: "pc-slider"
  }, [_c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-0",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-1",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-2",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide input-slide-num",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-3",
      "type": "radio"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-slide",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "input-slider",
      "id": "input-slide-autoplay",
      "type": "radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "slide-0",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-1",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-2",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "slide-3",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slide-description"
  }, [_c('label', {
    staticClass: "slide-0"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("If you have any issues setting up your Gallery Lookbooks, please do not hesitate to contact support")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-1"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Upgrade or Customize your account to unlock more features")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-2"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("We hope you love your lookbook Gallery")])]), _vm._v(" "), _c('label', {
    staticClass: "slide-3"
  }, [_c('p', {
    staticClass: "text-slide"
  }, [_vm._v("Welcome to your lookbook Gallery")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-prev"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-arrow-next"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pc-slider-dot"
  }, [_c('label', {
    staticClass: "slide-0",
    attrs: {
      "for": "input-slide-0"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-1",
    attrs: {
      "for": "input-slide-1"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-2",
    attrs: {
      "for": "input-slide-2"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "slide-3",
    attrs: {
      "for": "input-slide-3"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("CONTACT DETAILS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SUBSCRIPTION STATUS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('h5', [_vm._v("Your Subscription is Active ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    }
  }, [_c('p', [_vm._v("Would you love to Customize your Gallery? "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/customize"
    }
  }, [_vm._v("Talk to your Web Gallery Assistant")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('h5', [_vm._v("SETTINGS")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row info-card-inner-row"
  }, [_c('a', {
    staticClass: "btn",
    staticStyle: {
      "cursor": "pointer",
      "background": "#f1dee4",
      "padding": "1em",
      "color": "#000"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Logout from Account")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin-top": "5em",
      "margin-bottom": "5em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("View and Update Business Details")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Delivery and Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Set Business Coupons and Vouchers")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-card info-card-mini"
  }, [_c('div', {
    staticClass: "info-card-header"
  }, [_c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container info-card-body"
  }, [_c('div', {
    staticClass: "info-card-row info-card-mini-row"
  }, [_c('p', [_vm._v("Connect to your Business Payment Receival Portal")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("Your Sellpoint's Delivery Information")]), _vm._v(" "), _c('p', {
    staticClass: "p-tiny",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("This is the general shipping Information that would be shown to buyers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "font-size": "14px"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                                If you want to end an existing discount click on \"Stop Discount\" button near the\r\n                                button.\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#363535",
      "line-height": "1.2"
    }
  }, [_vm._v("Note that you can only set one Sellpoint Discount at a time.\r\n                          If you want to end an existing discount click on \"Stop Discount\" button on the Discount.\r\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Your Gallery is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Lookbooks to your gallery")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This Lookbook is empty, click on "), _c('b', [_vm._v("Manage")]), _vm._v(" to add Posts to your lookbook")])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    staticStyle: {
      "background": "#aa076b"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container gw-mtp4"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(6)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(8)]) : _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner-style-one home-page-two banner-hero",
    attrs: {
      "id": "banner"
    }
  }, [_c('span', {
    staticClass: "bubble-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-3"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-4"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-5"
  }), _vm._v(" "), _c('span', {
    staticClass: "bubble-6"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "banner-hero-img-1 banner-mock",
    attrs: {
      "src": "/static/assets/images/banner-moc-1-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-lg-8 banner-hero-intro"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('h3', {
    staticClass: "gw-not-mobile",
    staticStyle: {
      "font-size": "38px",
      "margin-bottom": "-8px"
    }
  }, [_vm._v("Show your Best with the Best.")]), _vm._v(" "), _c('div', {
    staticClass: "hero-mobile"
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "height": "15em"
    },
    attrs: {
      "src": "/static/assets/images/banner-mobile-2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Capture your moments "), _c('br'), _vm._v(" Save, Organise and "), _c('br'), _vm._v(" Make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn lengthy",
    attrs: {
      "href": "/demos"
    }
  }, [_c('span', [_vm._v("View Live  Demos")])]), _vm._v(" "), _c('a', {
    staticClass: "banner-btn shorty",
    attrs: {
      "href": "/go/pricing"
    }
  }, [_c('span', [_vm._v("Purchase")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-style-one",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "image-block"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/banner-mobile.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "block-title "
  }, [_c('h2', [_vm._v("Showcase your awesome designs "), _c('br'), _vm._v(" with your Gallery Website.")])]), _vm._v(" "), _c('p', [_vm._v("We live in a visual world - "), _c('br'), _vm._v(" Make it easier for Clients to find and choose you. ")]), _vm._v(" "), _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Choose a plan and create an account  ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Arrange and organise your Services into Lookbooks")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Upload and describe Products and Services in Posts")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Easy to use Admin Area")])]), _vm._v(" "), _c('a', {
    staticClass: "feature-btn",
    attrs: {
      "href": "#more"
    }
  }, [_vm._v("Learn More")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 2 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Nil Custom domain ")]), _vm._v(" "), _c('li', [_vm._v("Nil custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or video")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl security")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl Security")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gw-customize",
    staticStyle: {
      "background-color": "#f7fbff"
    }
  }, [_c('div', {
    staticClass: "container subscribe-style-one"
  }, [_c('h2', {
    staticClass: "text-center gw-mtp3",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("Customize your Gallery with your own designs.")]), _vm._v(" "), _c('form', {
    staticClass: "subscribe-form",
    staticStyle: {
      "margin-bottom": "-1em"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Interested? Enter your email, we will contact you"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Yes I'm Interested")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "faq-style-one",
    attrs: {
      "id": "more"
    }
  }, [_c('div', {
    staticClass: "container gw-mtp3"
  }, [_c('div', {
    staticClass: "block-title text-center gw-mtp2"
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "-1em"
    }
  }, [_vm._v("Frequently Asked Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-grp",
    attrs: {
      "data-grp-name": "faq-accrodion"
    }
  }, [_c('div', {
    staticClass: "accrodion active"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v(" What is a Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Gallery Websites are simple, visual focused websites with products arranged like you wouldin a Product Catalogue with ecommerce functionality. The concept is that of the Fashion Lookbook\r\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("How does one get a Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("It’s simple. Just choose from any of our 3 plans above, subscribe, create an account and get started")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("What happens when my subscription expires?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Your account is archived for a month and permanently deleted afterwards if no further actionis taken. But if you wish to keep your contents/posts, you can pay for your Gallery Website to remain archived until the day you decide to make it Live again. "), _c('br'), _vm._v("Don’t worry, we would send you reminders.\r\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("How do I receive payments from Clients?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Payments on each Gallery Website is directly to the Site owner via an online payment gateway which we would help you setup but would be managed solely by you.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Will my website have my company name as the domain e.x www.mycompany.com?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, all our paid plans have free custom .com.ng domains but you can easily pay for any domain of your choice to be added - .com, .ng etc")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Will I be able to upload my products?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, every account has its own Admin area where you have "), _c('b', [_vm._v("full control over your Gallery Website’s Look and Feel")]), _vm._v(" - manage your product and shipping details, upload and change images, update your Contact Us info etc.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Do you provide shipping partners?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("No, we don’t. It’s the responsibility of each Gallery Website owner to handle his/her shipping responsibilities. But feel free to browse through our Logistics category in ‘Our Gallery’ to find a shipping partner that sits your needs.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Do I get unlimited Storage space on my Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("No, every plan is capped but you can expand your space for an additional unremarkable yearly fee")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("I have a domain and hosting already, can my Gallery Website be moved there?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Unfortunately, this service is not yet available for now. All Gallery Websites are managed from a central host but you can use your already purchased domain name for your Gallery Website.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("Can I have some additional features added to my Gallery Website?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Yes, you can. Just write to the team at "), _c('a', {
    attrs: {
      "href": "mailto:customfeatures@lookbookgallery.com"
    }
  }, [_vm._v("customfeatures@lookbookgallery.com")]), _vm._v(" and start the discussion on how we can build you a custom Gallery Website")])])])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion"
  }, [_c('div', {
    staticClass: "accrodion-title"
  }, [_c('h4', [_vm._v("I have registered and logged in, but don’t know what to do next?")])]), _vm._v(" "), _c('div', {
    staticClass: "accrodion-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('p', [_vm._v("Please watch our "), _c('b', [_vm._v("onboarding videos")]), _vm._v(" or read through our "), _c('b', [_vm._v("‘Getting Started Tutorials’")]), _vm._v(" to serve as a guide. And if you are still not clear on what to do next, you can give us a call on 0708 642 8158 or send us a mail at "), _c('a', {
    attrs: {
      "href": "mailto:onboarding@lookbookgallery.com"
    }
  }, [_vm._v("onboarding@lookbookgallery.com")]), _vm._v(" to guide you through the process")])])])])])])])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loggedIn) ? _c('div', {
    staticClass: "hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _vm._v(" "), _c('h5', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "timeline"
    }
  }, [_vm._v(_vm._s(_vm.user.user_name))])]), _vm._v(" "), _vm._m(0), _c('br'), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 62 shops")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ion ion-android-person-add"
  }), _vm._v(" 1,500 friends")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-news-feed"
  }, [_c('li', [_c('i', {
    staticClass: "icon ion-ios-paper"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Tradefair Newsfeed")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-shopping-cart"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Shops Following")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-ios-people-outline"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friends")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-chatboxes"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Discussions / Messages")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon ion-images"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Orders")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "icon fa fa-bell"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("No6ifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "profile-card"
  }, [_c('p', [_vm._v("Do you dream of the day you will use naijabrandtradefair2019 and really make so much sales? Like the day you will stop struggling to pay bills because sales aren’t forth coming, Or maybe you want to be your own brand influencer but your visibility keeps diminishing day by day …")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Olu Jane Stores")]), _vm._v(" Commented on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lami Fashion Store")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Trish Hairs")]), _vm._v(" Liked friend's product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("4 hours ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LuluBeads Crafts")]), _vm._v(" has shared a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("a day ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Cynthia Belonwu"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jubril Sani"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sandra Oseni"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Titilo Bass"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Jayden Ajibade"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Nonso Obi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Efiong Dun"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Chika Nnabi"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Bolaji Adewale"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sign-in-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 sign-in"
  }, [_c('h4', {}, [_vm._v("Sign in")]), _vm._v(" "), _c('p', {}, [_vm._v("Hello and Welcome back, login to continue.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('form', {
    staticClass: "register-form outer-top-xs",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail1"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control unicase-form-control text-input",
    attrs: {
      "type": "password",
      "id": "exampleInputPassword1"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "btn-upper btn btn-primary checkout-page-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" | "), _c('a', {
    staticClass: "forgot-password pull-right",
    attrs: {
      "href": "register"
    }
  }, [_vm._v("Hava an account? Sign In")])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "breadcrumb-inner"
  }, [_c('ul', {
    staticClass: "list-inline list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Login")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-xs-12 hidden-xs"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/maller.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-sign-in outer-top-xs",
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "facebook-sign-in",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" Sign In with Facebook")]), _vm._v(" "), _c('a', {
    staticClass: "twitter-sign-in",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" Sign In with Twitter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Email Address "), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "info-title",
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("Password "), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio outer-xs"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "optionsRadios",
      "id": "optionsRadios2",
      "value": "option2"
    }
  }), _vm._v("Remember me!\r\n                  ")]), _vm._v(" "), _c('a', {
    staticClass: "forgot-password pull-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot your Password?")])])
}]}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticStyle: {
      "background": "#ffffff",
      "margin-bottom": "5em"
    },
    attrs: {
      "id": "menu"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.product.product_business_name))])]), _vm._v(" / " + _vm._s(_vm.product.product_category_name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "width": "40%",
      "float": "left"
    }
  }, [_c('h4', {
    staticClass: "hidden-md hidden-lg"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "images-slider img-main-frame"
  }, [(_vm.product_display_image.product_image != '' && _vm.product_display_image.product_image != 'error') ? _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": _vm.img_product_url + _vm.product_display_image.product_image,
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "img-responsive sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-row"
  }, _vm._l((_vm.product.product_images), function(img) {
    return _c('div', {
      staticClass: "img-column"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-display-image', img)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card sp-p-main",
    staticStyle: {
      "width": "60%",
      "float": "right",
      "padding": "0 2em"
    }
  }, [_c('div', {
    staticClass: "sp-prd-intro-block"
  }, [_c('h4', {
    staticClass: "hidden-sm hidden-xs"
  }, [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "p-bold"
  }, [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('p', {
    staticClass: "p-bold"
  }, [_vm._v("Category: "), _c('span', [_c('b', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hozontal-flat-block"
  }, [_c('p', {
    staticClass: "pull-left"
  }, [_vm._v("reviews")]), _vm._v(" "), _c('p', {
    staticClass: "pull-right"
  }, [_vm._v("@"), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sp-prd-attr-block"
  }, [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [(_vm.product_item.product_item_actual_price != 0) ? _c('p', {
    staticClass: "attr-intro-desc prd-price prd-discounted-price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _c('p', {
    staticClass: "attr-intro-desc prd-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc prd-discount-price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('p', {
    staticClass: "attr-intro-desc"
  }, [_vm._v(_vm._s(_vm.product_item.product_item_weight) + " (Kg)")])])]), _vm._v(" "), (((_vm.product.product_set_groups != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_vm._l((_vm.product.product_item_groups), function(pg) {
    return _c('div', {
      staticClass: "prd-color-block"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item-group', pg)
        }
      }
    }, [_c('div', {
      staticClass: "box-cube col-xs-2"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "product-item-group"
    }, [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', {}, [_c('div', {
      staticClass: "product-item-group box-color-cube",
      style: ({
        background: pg.product_item_group_color
      }),
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_group_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_group_message))]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (((_vm.product_item_group.product_items) && (_vm.product_item_group.product_items.length != 0))) ? _c('div', {
    staticClass: "info-block col-xs-12"
  }, [(((_vm.product.product_set_items != 0) && (_vm.product.product_set_items_params_check != 0))) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('div', {
    staticClass: "prd-color-block"
  }, _vm._l((_vm.product_item_group.product_items), function(pt) {
    return _c('div', {
      staticClass: "items-list-tiny",
      staticStyle: {
        "display": "inline"
      }
    }, [_c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'P') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "product-item",
      attrs: {
        "id": pt.product_item_id + 'PRT'
      }
    }, [(_vm.product.product_service == 'S') ? _c('a', {
      staticClass: "box-wrap",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.data_cart_item_message) ? _c('p', {
    staticClass: "p-tiny-info",
    staticStyle: {
      "margin-top": "-0.1em",
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.data_cart_item_message))]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n              " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(!_vm.edit_mode) ? _c('div', [_c('div', [_c('div', {
    staticClass: "info-block col-xs-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-right col-xs-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "102px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "change": function($event) {
        _vm.checkOrderQuantity(_vm.product_item.product_item_order_quantity)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.check_order_quantity))])])]), _vm._v(" "), _c('hr')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner-info"
  }, [_c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-xs-8"
  }, [_c('div', {
    staticClass: "tiny-notice"
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + "\r\n                      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                        Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                        partners to make transactions seamless.\r\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-blocks"
  }, [_c('div', {
    staticClass: "info-block col-md-12 col-xs-12",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "info-right-2 col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "prd-delivery-list",
    staticStyle: {
      "display": "none"
    }
  }, [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + "\r\n                          ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦" + _vm._s(delivery.business_delivery_option_price) + " \r\n                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "prd-delivery-list"
  }, _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - ₦\r\n                          "), (delivery.business_products_delivery_fees.length > 0) ? _c('span', _vm._l((delivery.business_products_delivery_fees), function(fee, fdex) {
      return _c('span', [((fee.product_delivery_product == _vm.product.product_id)) ? _c('span', [_vm._v(_vm._s(fee.product_delivery_fee) + "\r\n                              ")]) : _vm._e()])
    })) : _c('span', [_vm._v("\r\n                            " + _vm._s(delivery.business_delivery_option_price) + "\r\n                          ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _c('ul', {
    staticClass: "social_icons"
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Click the Copy button below to Copy product link, paste the link anywhere you want to share to")]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-xs linky",
    staticStyle: {
      "cursor": "pointer",
      "padding": "10px 30px"
    },
    attrs: {
      "title": "Copy Link. Paste and Share Anywhere"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_vm._v("Copy Link\r\n                    ")]), _vm._v(" "), (_vm.copied) ? _c('span', {
    staticStyle: {
      "background": "rgb(240, 227, 157)"
    }
  }, [_vm._v("Copied, Paste anywhere you want to share to")]) : _vm._e()])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "dishes v2"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Discount Price: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Weight: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Groups/Types: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Select: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left col-xs-2"
  }, [_c('p', {
    staticClass: "attr-intro-head"
  }, [_vm._v("Quantity:  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-xs-2"
  }, [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-left-2 col-md-2 col-xs-12"
  }, [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")])])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-info-wrap",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-4 col-xs-12"
  }, [_c('div', {
    staticClass: "loading-md"
  })]) : _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [(_vm.orders.set) ? _c('div', {
    staticClass: "col-sm-12 card",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('h1', {
    staticClass: "card-title"
  }, [_vm._v("Your Orders")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "orders-panel"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Ordered From")]), _vm._v(" "), _c('th', [_vm._v("Order Total")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-backdrop": "false",
        "data-target": "#ordersModal"
      },
      on: {
        "click": function($event) {
          _vm.setOrder(order)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#df4d4d"
      }
    }, [_c('u', [_c('b', [_vm._v(_vm._s(order.order_no))])])]), _c('br'), _vm._v("\r\n                        " + _vm._s(order.order_date) + "\r\n                        "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "p-tiny"
    }, [_vm._v("Tap to view")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.order_business))]), _vm._v(" "), _c('td', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(order.order_total))]), _vm._v(" "), _c('td', [_c('span', {
      style: ({
        color: order.order_payment_status_color
      })
    }, [_vm._v(_vm._s(order.order_payment_status))])])])
  })], 2)])]) : _c('p', [_vm._v("No orders yet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "ordersModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Order No " + _vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v("Order No: ")]), _vm._v(_vm._s(_vm.order.order_no))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Date: ")]), _vm._v(_vm._s(_vm.order.order_date))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _vm._l((_vm.order.order_items), function(item) {
    return _c('tr', [_c('td', [_c('img', {
      attrs: {
        "src": _vm.img_product_url + item.product_item_group_image,
        "height": "50",
        "width": "50"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.product_name) + " - " + _vm._s(item.order_delivery_city))])])
  })], 2), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Payment Mode: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Order Status: ")]), _c('span', {
    style: ({
      color: _vm.order.order_payment_status_color
    })
  }, [_vm._v(_vm._s(_vm.order.order_payment_status))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Fee Details:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_not_set))])]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Delivery Location:  ")]), _vm._v(_vm._s(_vm.order.order_delivery_city))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivery Address:  ")]), _vm._v(_vm._s(_vm.order.order_user_delivery_address))])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Order Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header'), _vm._v(" "), (_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#aa076b",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "single-pricing-one upgrade-packs basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), _c('div', {
      staticClass: "feature-list"
    }, [(plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 2 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Nil Custom domain ")]), _vm._v(" "), _c('li', [_vm._v("Nil custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")])]) : _vm._e(), _vm._v(" "), (plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Upload images or video")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl security")])]) : _vm._e(), _vm._v(" "), (plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl Security")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")]), _vm._v(" "), _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v("₦" + _vm._s(details.subscription_new_product_total_amount_to_pay))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Afiahub Sellpoint")]), _vm._v(" account. We use Afiahub to manage your acounts. \r\n                                        If you already have a Afiahub account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 2 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Nil Custom domain ")]), _vm._v(" "), _c('li', [_vm._v("Nil custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("Upload images or video")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl security")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl Security")])]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [(!_vm.set_up_with_existing_account) ? _c('div', [(!_vm.loggedIn) ? _c('div', {}, [_c('div', {
    staticClass: "gw-mobile"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-light pu",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up with Afiahub")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#aa076b",
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_vm._v("Or Create an Afiahub account to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "gw-not-mobile"
  }, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Create an Afiahub account to proceed.")]), _vm._v(" "), _c('a', {
    staticClass: "btn gw-btn-cta-light pull-right",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v(" Or Sign Up with Afiahub")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [(!_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })])]) : _c('div', [_c('label', [_c('b', [_vm._v("Name:")]), _vm._v(" " + _vm._s(_vm.user.user_name))]), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.user.user_email))]), _c('br'), _vm._v(" "), _c('label', [_c('b', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.user.user_phone))]), _c('br')]), _vm._v(" "), (_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                            Change Subscription Duration\r\n                                                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                            ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sellpoint Username or Handle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_business),
      expression: "user.user_business"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Sellpoint Username/Handle"
    },
    domProps: {
      "value": (_vm.user.user_business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_business = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2p",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v(" Or Create a new account")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Afiahub Sellpoint")]), _vm._v(" account. We use Afiahub to manage your acounts. \r\n                                        If you already have a Afiahub account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(10), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "container gw-mobile"
  }, [_vm._m(11)]) : _vm._e()]), _vm._v(" "), (!_vm.$route.query.upgrade) ? _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(12), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(13)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_description_name))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Proceed with your Afiahub Account ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Afiahub")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Afiahub for your Business")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-sm-4",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 2 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Nil Custom domain ")]), _vm._v(" "), _c('li', [_vm._v("Nil custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or video")]), _vm._v(" "), _c('li', [_vm._v("Maximum of 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Nil Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl security")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Upload images or videos")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("Unlimited custom email addresses")]), _vm._v(" "), _c('li', [_vm._v("Online Store")]), _vm._v(" "), _c('li', [_vm._v("SSl Security")])])
}]}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.$route.path == '/cart') ? _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cart-summ"
  }, [_c('div', {
    staticClass: " cart-summ-card-left card col-sm-1",
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cart.length)), _c('br'), _vm._v("items")])])]), _vm._v(" "), _c('div', {
    staticClass: " cart-summ-card-right card col-md-8",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._m(1), _vm._v(" "), _c('li', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12  text-center",
    staticStyle: {
      "background": "#ffffff"
    }
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_c('h5', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(group[0]) + "'s Sellpoint")]), _c('br'), _vm._v(" "), _c('div', {}, [_vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details"
      }, [_c('li', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "pull-left"
      }, [(item.product_checked) ? _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }, [_c('del', [_vm._v("Selected")])]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Select "), _c('br'), _vm._v("Order")])]), _vm._v(" "), _c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [_c('div', {}, [_c('div', {
        staticClass: "quinty"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [(group.selected_business_delivery_option && item.product_checked) ? _c('p', [(!group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', _vm._l((group.selected_business_delivery_option.business_products_delivery_fees), function(pd_fee) {
        return _c('span', [(item.product_main_id == pd_fee.product_delivery_product) ? _c('span', [_vm._v("\r\n                          ₦" + _vm._s(pd_fee.product_delivery_fee) + "\r\n                      ")]) : _vm._e()])
      })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [(item.can_remove) ? _c('div', {}, [_c('label', [_vm._v("Remove: ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "background": "#000000",
          "color": "#ffffff"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-close"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })])
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 2), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', {
      staticClass: "row"
    }, [(group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "pull-left coupons-sec"
    }, [_vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.coupon_code),
          expression: "coupon_code"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id,
          "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, coupon, coupon.discount_percentage)
          },
          "__c": function($event) {
            var $$a = _vm.coupon_code,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = coupon.discount_id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.coupon_code = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [(group[2]) ? _c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
      staticClass: "dropdown"
    }, [(group.selected_business_delivery_option) ? _c('button', {
      staticClass: "dropbtn"
    }, [(group.selected_business_delivery_option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                        " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_product_delivery_fee) + "▼\r\n                      ")]) : _c('span', [_vm._v("\r\n                          " + _vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼\r\n                      ")])]) : _c('button', {
      staticClass: "dropbtn"
    }, [_vm._v("Select Delivery Option " + _vm._s(group[0]) + " Orders▼")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((group[2]), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.sellpoint_delivery_fee),
          expression: "sellpoint_delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.sellpoint_delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v(" "), (option.has_product_delivery_fee) ? _c('span', [_vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_product_delivery_fee) + "\r\n                            ")]) : _c('span', [_vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                            ")])])]) : _vm._e()])
    }))])]) : _c('div', [_c('p', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Free Delivery")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total Orders from "), _c('b', [_vm._v(_vm._s(group[0]) + ":")]), _vm._v(" ₦" + _vm._s(group.total_order_amt))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
      staticClass: "tiny-part"
    }, [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', {
      staticClass: "tiny-part"
    }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "12px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true)]), _vm._v(" "), (_vm.buy_now_order && (_vm.checked_out.length != 0)) ? _c('div', {
      staticClass: "text-align"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "background": "#000000"
      },
      on: {
        "click": function($event) {
          _vm.process_orders()
        }
      }
    }, [_vm._v("Process Orders")])]) : _vm._e()])])]) : _vm._e()])
  })), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.buy_now_order) ? _c('div', [(_vm.checked_out.length != 0) ? _c('div', {
    staticClass: "col-sm-12 orders-panel pull-right",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('span', {
    staticClass: "col-sm-3"
  }, [_c('h5', [_vm._v("Your Orders")]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.total_order_amt))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Shipping Fee: ")]), _vm._v("₦" + _vm._s(_vm.total_delivery_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.$route.path == '/order') ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "background": "#ffffff"
    }
  }, [_c('h2', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Process your Order")]), _vm._v(" "), _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-top": "4em",
        "margin-bottom": "6em"
      }
    }, _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "col-md-8 col-md-offset-4 col-sm-12"
      }, [(item.active_order) ? _c('div', [_c('div', [_c('li', {
        staticClass: "col-md-4 col-sm-12"
      }, [_c('div', {}, [_c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [((item.product_item_image && (item.product_item_image != ''))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": _vm.img_product_url + item.product_item_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-md-8"
      }, [_c('div', {}, [_c('h4', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "quinty"
      }, [_c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Qty: ")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('label', {
        staticStyle: {
          "display": "inline"
        }
      }, [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])]), _vm._v(" "), _c('div', [(item.product_checked) ? _c('a', {
        staticClass: "btn order-btn",
        staticStyle: {
          "margin-top": "3px",
          "float": "right"
        },
        attrs: {
          "href": "/"
        }
      }, [_vm._v("Cancel Order")]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Process Order")])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "id": item.index2 + 'PRT_CART'
        }
      }, [(group.items_in_checkout > 0) ? _c('div', {
        staticClass: "col-md-4"
      }, [(group[4] && (group[4].length > 0)) ? _c('div', {}, [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
        return _c('p', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.coupon_code),
            expression: "coupon_code"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": coupon.discount_id,
            "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
          },
          on: {
            "click": function($event) {
              _vm.set_coupons(index, coupon, coupon.discount_percentage)
            },
            "__c": function($event) {
              var $$a = _vm.coupon_code,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = coupon.discount_id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
                } else {
                  $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.coupon_code = $$c
              }
            }
          }
        }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
      })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-8"
      }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [(group[2]) ? _c('div', [(group[2].length != 0 && !group.delivery_option) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2].length != 0) ? _c('div', [_c('div', {
        staticClass: "dropdown"
      }, [(group.selected_business_delivery_option) ? _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v(_vm._s(group.selected_business_delivery_option.business_delivery_option) + " -  ₦" + _vm._s(group.selected_business_delivery_option.business_delivery_option_price) + "▼")]) : _c('button', {
        staticClass: "dropbtn"
      }, [_vm._v("Select Delivery Location▼")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-content"
      }, _vm._l((group[2]), function(option) {
        return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.sellpoint_delivery_fee),
            expression: "sellpoint_delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.sellpoint_delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_sellpoint_delivery_fee(index, option)
            },
            "__c": function($event) {
              _vm.sellpoint_delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v("\r\n                                  " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                                ")])]) : _vm._e()])
      }))])]) : _c('div', [_c('p', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Free Delivery")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(group[2]) ? _c('span', [_c('p', {
        staticClass: "tiny-part"
      }, [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', {
        staticClass: "tiny-part"
      }, [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', {
        staticClass: "tiny-part"
      }, [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {}, [_vm._m(8, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
        staticStyle: {
          "color": "#ff0000",
          "font-size": "12px"
        }
      }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_on_delivrey"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 2)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_on_delivrey"
          }
        }
      }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.payment_option),
          expression: "payment_option"
        }],
        attrs: {
          "type": "radio",
          "value": "pay_now"
        },
        domProps: {
          "checked": _vm._q(_vm.payment_option, "pay_now")
        },
        on: {
          "click": function($event) {
            _vm.setPaymentOption(index, 1)
          },
          "__c": function($event) {
            _vm.payment_option = "pay_now"
          }
        }
      }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {}, [_vm._m(9, true)]), _vm._v(" "), (_vm.buy_now_order && (_vm.checked_out.length != 0)) ? _c('div', {
        staticClass: "text-align"
      }, [_c('button', {
        staticClass: "btn btn-primary",
        staticStyle: {
          "background": "#000000"
        },
        on: {
          "click": function($event) {
            _vm.process_orders()
          }
        }
      }, [_vm._v("Proceed")])]) : _vm._e()])])])]) : _vm._e()])
    }))
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-summ",
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "margin-bottom": "2em"
    }
  }, [_c('h3', {
    staticClass: "cart-title",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('p', {}, [_vm._v("Checkout items from each sellpoint, then click *Process Orders* to continue.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Total to checkout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tiny-part"
  }, [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route sp-cart-wrap",
    staticStyle: {
      "width": "98.8%"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticStyle: {
      "border": "1px dashed #8a8787"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "col-md-6 col-md-offset-3 col-sm-12 chart-card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 pull-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/empty-lonely-cart.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("I'm Lonely and Sad, please "), _c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("fill me up")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 pull-right",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is sad and empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "rgb(252, 16, 75)",
      "color": "#ffffff"
    },
    attrs: {
      "href": "tour"
    }
  }, [_vm._v("Start Buying")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "rgb(252, 16, 75)"
    },
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")]), _vm._v(" to see products you added to your cart")])])
}]}

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[104]);


// WEBPACK FOOTER //
// static/js/app.7aaa430bd55f451bdce1.js